webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(927);
	__webpack_require__(929);
	__webpack_require__(928);
	module.exports = __webpack_require__(750);


/***/ },

/***/ 28:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LATEST_ARTICLES_REQUEST = exports.LATEST_ARTICLES_REQUEST = 'LATEST_ARTICLES_REQUEST';
	var LATEST_ARTICLES_SUCCESS = exports.LATEST_ARTICLES_SUCCESS = 'LATEST_ARTICLES_SUCCESS';
	var LATEST_ARTICLES_FAILURE = exports.LATEST_ARTICLES_FAILURE = 'LATEST_ARTICLES_FAILURE';
	
	var PLUSS_ARTICLES_REQUEST = exports.PLUSS_ARTICLES_REQUEST = 'PLUSS_ARTICLES_REQUEST';
	var PLUSS_ARTICLES_SUCCESS = exports.PLUSS_ARTICLES_SUCCESS = 'PLUSS_ARTICLES_SUCCESS';
	var PLUSS_ARTICLES_ADD = exports.PLUSS_ARTICLES_ADD = 'PLUSS_ARTICLES_ADD';
	var PLUSS_ARTICLES_FAILURE = exports.PLUSS_ARTICLES_FAILURE = 'PLUSS_ARTICLES_FAILURE';
	
	var COLLECTION_ARTICLES_REQUEST = exports.COLLECTION_ARTICLES_REQUEST = 'COLLECTION_ARTICLES_REQUEST';
	var COLLECTION_ARTICLES_SUCCESS = exports.COLLECTION_ARTICLES_SUCCESS = 'COLLECTION_ARTICLES_SUCCESS';
	var COLLECTION_ARTICLES_ADD = exports.COLLECTION_ARTICLES_ADD = 'COLLECTION_ARTICLES_ADD';
	var COLLECTION_ARTICLES_FAILURE = exports.COLLECTION_ARTICLES_FAILURE = 'COLLECTION_ARTICLES_FAILURE';
	
	var RECIRCULATION_REQUEST = exports.RECIRCULATION_REQUEST = 'RECIRCULATION_REQUEST';
	var RECIRCULATION_SUCCESS = exports.RECIRCULATION_SUCCESS = 'RECIRCULATION_SUCCESS';
	var RECIRCULATION_FAILURE = exports.RECIRCULATION_FAILURE = 'RECIRCULATION_FAILURE';
	
	var COUPON_CODES_REQUEST = exports.COUPON_CODES_REQUEST = 'COUPON_CODES_REQUEST';
	var COUPON_CODES_SUCCESS = exports.COUPON_CODES_SUCCESS = 'COUPON_CODES_SUCCESS';
	var COUPON_CODES_FAILURE = exports.COUPON_CODES_FAILURE = 'COUPON_CODES_FAILURE';
	
	var SWITCH_DEVICE = exports.SWITCH_DEVICE = 'SWITCH_DEVICE';
	
	var UTM_PARAMS = exports.UTM_PARAMS = 'UTM_PARAMS';
	
	var PAYWALL_TYPE = exports.PAYWALL_TYPE = 'PAYWALL_TYPE';

/***/ },

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _universalConfig = __webpack_require__(22);
	
	Object.defineProperty(exports, 'config', {
	  enumerable: true,
	  get: function get() {
	    return _universalConfig.appConfig;
	  }
	});

/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAdUserId = exports.getArticleAdKeywords = exports.updateWallpaperPosition = exports.getSupplyType = undefined;
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _rafThrottle = __webpack_require__(389);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WALLPAPER_MAGIC_NUMBER = 71; // Find a better way to fetch this...
	
	/* globals getComputedStyle */
	var generateTagFriendlyName = function generateTagFriendlyName(tagName) {
	    return 'vg_' + tagName.trim().toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-').replace(/,+/g, '').replace(/å/g, 'aa').replace(/ø/g, 'oe').replace(/æ/g, 'ae');
	};
	
	var deviceKeywordMap = function deviceKeywordMap(device) {
	    var deviceMap = {
	        mobile: 'phone',
	        'mobile-app': 'phone',
	        'tablet-app': 'tablet'
	    };
	
	    return deviceMap[device] || device;
	};
	
	var getSupplyType = exports.getSupplyType = function getSupplyType(device) {
	    var supplyType = '';
	
	    switch (device) {
	        case 'desktop':
	            supplyType = 'web_desktop';
	            break;
	
	        case 'tablet-app':
	        case 'tablet':
	            supplyType = 'web_tablet';
	            break;
	
	        case 'mobile-app':
	        case 'mobile':
	            supplyType = 'web_phone';
	            break;
	
	        default:
	            supplyType = 'web_desktop';
	    }
	
	    return supplyType;
	};
	
	var setBodyBackgroundPosition = function setBodyBackgroundPosition(height) {
	    document.body.style.setProperty('background-position', 'center ' + height + 'px', 'important');
	};
	
	/* eslint-disable consistent-return */
	var updateWallpaperPosition = exports.updateWallpaperPosition = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(node) {
	        var getScrollY, updatePosition, _ref2, backgroundPosition;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        getScrollY = function getScrollY() {
	                            return window.scrollY || window.pageYOffset;
	                        };
	
	                        updatePosition = new _promise2.default(function (resolve) {
	                            (0, _rafThrottle2.default)(function () {
	                                var top = node.getBoundingClientRect().top + getScrollY();
	                                var backgroundPosition = top + parseInt(getComputedStyle(node).paddingTop.replace('px'), 10);
	
	                                setBodyBackgroundPosition(backgroundPosition);
	
	                                return resolve({
	                                    top: top,
	                                    backgroundPosition: backgroundPosition
	                                });
	                            })();
	                        });
	                        _context.next = 4;
	                        return updatePosition;
	
	                    case 4:
	                        _ref2 = _context.sent;
	                        backgroundPosition = _ref2.backgroundPosition;
	
	
	                        window.addEventListener('scroll', (0, _rafThrottle2.default)(function () {
	                            if (getScrollY() >= backgroundPosition - WALLPAPER_MAGIC_NUMBER) {
	                                setBodyBackgroundPosition(WALLPAPER_MAGIC_NUMBER);
	                            } else {
	                                setBodyBackgroundPosition(backgroundPosition - getScrollY());
	                            }
	                        }));
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function updateWallpaperPosition(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	/* eslint-enable */
	
	var getArticleAdKeywords = exports.getArticleAdKeywords = function getArticleAdKeywords(articleObj, device) {
	    var keywords = {};
	    var section = articleObj.section,
	        tags = articleObj.tags;
	
	    if (section === undefined && tags === undefined || (0, _keys2.default)(section).length === 0) {
	        return {};
	    }
	
	    // If parent is set, use that at main appnexus keyword
	    if (section.parent !== undefined) {
	        keywords['no-sno-news-section'] = section.parent.title;
	        keywords['no-sno-news-subsection'] = section.title;
	    } else {
	        keywords['no-sno-news-section'] = section.title;
	    }
	
	    // Send all tags as an array
	    if (tags !== undefined && tags.length > 0) {
	        var tagNames = tags.map(function (tag) {
	            return tag.title;
	        });
	        keywords['no-sno-news-sponsors'] = tagNames;
	    }
	
	    (0, _keys2.default)(keywords).forEach(function (key) {
	        if (Array.isArray(keywords[key])) {
	            keywords[key] = keywords[key].map(function (tag) {
	                return generateTagFriendlyName(tag);
	            });
	        } else {
	            keywords[key] = generateTagFriendlyName(keywords[key]);
	        }
	    });
	
	    // Supply type should be without "vg_"-prefix
	    var supplyType = getSupplyType(device);
	    keywords['aa-sch-supply_type'] = supplyType;
	    keywords['no-sno-device'] = deviceKeywordMap(device);
	
	    return keywords;
	};
	
	var getAdUserId = exports.getAdUserId = function getAdUserId() {
	    var cookie = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent('_pulse2data').replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || false;
	
	    if (cookie) {
	        return cookie.split(',')[9];
	    }
	
	    return null;
	};

/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _adComponents = __webpack_require__(114);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onErrorDefault = function onErrorDefault(_ref) {
	    var adObj = _ref.adObj;
	
	    if (true) {
	        return;
	    }
	
	    /* eslint-disable no-console */
	    console.error('Failed to load an Ad: ', adObj);
	};
	
	/* eslint-disable */
	var VgClientPlacedAd = (_temp = _class = function (_Component) {
	    (0, _inherits3.default)(VgClientPlacedAd, _Component);
	
	    function VgClientPlacedAd() {
	        (0, _classCallCheck3.default)(this, VgClientPlacedAd);
	        return (0, _possibleConstructorReturn3.default)(this, (VgClientPlacedAd.__proto__ || (0, _getPrototypeOf2.default)(VgClientPlacedAd)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(VgClientPlacedAd, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$onError = _props.onError,
	                onError = _props$onError === undefined ? onErrorDefault : _props$onError,
	                subtype = _props.subtype,
	                clientPlacedAds = _props.clientPlacedAds,
	                _props$visibleOnError = _props.visibleOnError,
	                visibleOnError = _props$visibleOnError === undefined ? true : _props$visibleOnError;
	
	
	            return _react2.default.createElement(_adComponents.ClientPlacedAd, {
	                subtype: subtype,
	                clientPlacedAds: clientPlacedAds,
	                priority: 'high',
	                visibleOnError: visibleOnError,
	                onError: onError
	            });
	        }
	    }]);
	    return VgClientPlacedAd;
	}(_react.Component), _class.propTypes = {
	    clientPlacedAds: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    subtype: _propTypes2.default.string.isRequired,
	    onError: _propTypes2.default.function,
	    visibleOnError: _propTypes2.default.bool
	}, _temp);
	/* eslint-disable */
	
	exports.default = VgClientPlacedAd;

/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _universalConfig = __webpack_require__(22);
	
	var _uiErrorMessage = __webpack_require__(645);
	
	var _uiErrorMessage2 = _interopRequireDefault(_uiErrorMessage);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenericError = function GenericError(_ref) {
	    var statusCode = _ref.statusCode,
	        theme = _ref.theme;
	    var _config$errorMessages = _universalConfig.appConfig.errorMessages;
	    _config$errorMessages = _config$errorMessages === undefined ? {} : _config$errorMessages;
	    var _config$errorMessages2 = _config$errorMessages.notfound;
	    _config$errorMessages2 = _config$errorMessages2 === undefined ? {} : _config$errorMessages2;
	    var _config$errorMessages3 = _config$errorMessages2.heading,
	        notFoundHeading = _config$errorMessages3 === undefined ? '' : _config$errorMessages3,
	        _config$errorMessages4 = _config$errorMessages2.message,
	        notFoundMessage = _config$errorMessages4 === undefined ? '' : _config$errorMessages4,
	        _config$errorMessages5 = _config$errorMessages.generic;
	    _config$errorMessages5 = _config$errorMessages5 === undefined ? {} : _config$errorMessages5;
	    var _config$errorMessages6 = _config$errorMessages5.heading,
	        genericHeading = _config$errorMessages6 === undefined ? '' : _config$errorMessages6,
	        _config$errorMessages7 = _config$errorMessages5.message,
	        genericMessage = _config$errorMessages7 === undefined ? '' : _config$errorMessages7;
	
	
	    var error = void 0;
	    var title = void 0;
	    if (statusCode === 404) {
	        error = _react2.default.createElement(_uiErrorMessage2.default, {
	            heading: notFoundHeading,
	            message: notFoundMessage,
	            statusCode: 404,
	            theme: theme
	        });
	        title = 'VG - ' + notFoundMessage;
	    } else {
	        error = _react2.default.createElement(_uiErrorMessage2.default, {
	            heading: genericHeading,
	            message: genericMessage,
	            statusCode: statusCode,
	            theme: theme
	        });
	        title = 'VG - ' + genericMessage;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: theme.root },
	        _react2.default.createElement(_reactHelmet2.default, { title: title }),
	        _react2.default.createElement(
	            'main',
	            { id: 'main', role: 'main', className: theme.contentContainer },
	            error,
	            _react2.default.createElement(
	                'p',
	                null,
	                'G\xE5 tilbake til ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/' },
	                    'forsiden'
	                ),
	                '.'
	            )
	        )
	    );
	};
	
	GenericError.propTypes = {
	    statusCode: _propTypes2.default.number.isRequired,
	    theme: _propTypes2.default.shape({
	        notfound: _propTypes2.default.string
	    })
	};
	
	GenericError.defaultProps = {
	    statusCode: 404,
	    theme: {}
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/generic-error')(GenericError);

/***/ },

/***/ 131:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1xqge","visuallyhidden":"ueb5b","hide-text":"yq7D8","center":"_3ymZs","noprint":"_2mZPj","listItem":"_1BRhu","authorList":"iYfdu","image":"_3eAqo","root":"x1bQz _25KE7","description":"_7gAe0"};

/***/ },

/***/ 132:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2T1H-","visuallyhidden":"_2cKBa","hide-text":"_3lYjU","center":"_1pIp-","noprint":"_3wkUz","root":"_3SPB5","carousel":"_3s-9g","button":"_13TS-","buttonPrevious":"_1UMgR","buttonNext":"_1xb_z","videoSlide":"lv4JE","buttonContent":"_3XsOq","slides":"_1ApC-","statusBar":"wsmgg","caption":"_1nNs-","byline":"_3ujY5","state":"_3rzDP"};

/***/ },

/***/ 133:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1hb09","visuallyhidden":"_30S5m","hide-text":"_3-0kA","center":"UZAF6","noprint":"l7LtY","root":"_2rmUE","caption":"d2l1j","fullcaption":"CTL_e","captionButton":"jg2NW","image":"_3mT80"};

/***/ },

/***/ 134:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"pNNti","visuallyhidden":"_1gV_b","hide-text":"_2-SvX","center":"_2p8u0","noprint":"NmKq6","videoRatio":"_3-e72","square":"_1jaWj","audio":"_2ypP6","root":"frh73"};

/***/ },

/***/ 135:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"WE8MM","visuallyhidden":"_25uxr","hide-text":"_1KlJU","center":"_1MNTZ","noprint":"_3_Rqs","leadText":"dUYxZ _-_Vfy"};

/***/ },

/***/ 136:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3fFyq","visuallyhidden":"_3u0Kk","hide-text":"_2QjPz","center":"_3bnTH","noprint":"_2mQzm","map":"_33wbj"};

/***/ },

/***/ 137:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1Wf9H","visuallyhidden":"O8GQ8","hide-text":"_1KAIx","center":"_2xzsk","noprint":"_3Cits","subheading":"_38ZrT"};

/***/ },

/***/ 138:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1IwEB","visuallyhidden":"NzyiC","hide-text":"_2WTFD","center":"_3_gTa","noprint":"_2yOeh","subheading":"_2FI4V","subtitle":"_1DvZ7"};

/***/ },

/***/ 139:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"R2Z5d","visuallyhidden":"_26kU2","hide-text":"_3qJc7","center":"_1FoN6","noprint":"_37vdT","timestamp":"_3vDfG _25KE7"};

/***/ },

/***/ 183:
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    desktop: ['netboard_1', 'netboard_2', 'netboard_3'], // same as tablet
	    mobile: ['board_1', 'board_2', 'board_3'],
	    extraSizes: {
	        tablet: {
	            'no-vg-{deviceType}-article_topboard': [[980, 250]]
	        }
	    }
	};

/***/ },

/***/ 184:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.coreNavigationUI = exports.spid = exports.article = exports.video = exports.loadedTrackers = exports.paywallType = exports.utmParams = exports.couponCodes = exports.device = exports.recirculation = exports.collectionArticles = exports.plussArticles = exports.latestArticles = undefined;
	
	var _latestArticles = __webpack_require__(812);
	
	Object.defineProperty(exports, 'latestArticles', {
	    enumerable: true,
	    get: function get() {
	        return _latestArticles.fetchLatestArticlesReducer;
	    }
	});
	
	var _plussArticles = __webpack_require__(814);
	
	Object.defineProperty(exports, 'plussArticles', {
	    enumerable: true,
	    get: function get() {
	        return _plussArticles.fetchPlussArticlesReducer;
	    }
	});
	
	var _collectionArticles = __webpack_require__(810);
	
	Object.defineProperty(exports, 'collectionArticles', {
	    enumerable: true,
	    get: function get() {
	        return _collectionArticles.fetchCollectionArticlesReducer;
	    }
	});
	
	var _recirculation = __webpack_require__(815);
	
	Object.defineProperty(exports, 'recirculation', {
	    enumerable: true,
	    get: function get() {
	        return _recirculation.fetchRecirculationReducer;
	    }
	});
	
	var _clientDevice = __webpack_require__(809);
	
	Object.defineProperty(exports, 'device', {
	    enumerable: true,
	    get: function get() {
	        return _clientDevice.deviceReducer;
	    }
	});
	
	var _couponCodes = __webpack_require__(811);
	
	Object.defineProperty(exports, 'couponCodes', {
	    enumerable: true,
	    get: function get() {
	        return _couponCodes.fetchCouponCodesReducer;
	    }
	});
	
	var _utmParams = __webpack_require__(817);
	
	Object.defineProperty(exports, 'utmParams', {
	    enumerable: true,
	    get: function get() {
	        return _utmParams.utmParamsReducer;
	    }
	});
	
	var _paywallType = __webpack_require__(813);
	
	Object.defineProperty(exports, 'paywallType', {
	    enumerable: true,
	    get: function get() {
	        return _paywallType.paywallTypeReducer;
	    }
	});
	
	var _tracking = __webpack_require__(816);
	
	Object.defineProperty(exports, 'loadedTrackers', {
	    enumerable: true,
	    get: function get() {
	        return _tracking.trackingReducer;
	    }
	});
	
	var _videoAsset = __webpack_require__(182);
	
	Object.defineProperty(exports, 'video', {
	    enumerable: true,
	    get: function get() {
	        return _videoAsset.reducer;
	    }
	});
	
	var _reduxArticle = __webpack_require__(278);
	
	var _reduxSpid = __webpack_require__(69);
	
	var _uiCoreNavigation = __webpack_require__(118);
	
	var article = exports.article = _reduxArticle.reducers.fetchArticle;
	var spid = exports.spid = _reduxSpid.reducers.spid;
	var coreNavigationUI = exports.coreNavigationUI = _uiCoreNavigation.reducers.coreNavigationUI;

/***/ },

/***/ 185:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = clientParams;
	
	var _normalizeDevice = __webpack_require__(317);
	
	var _normalizeDevice2 = _interopRequireDefault(_normalizeDevice);
	
	var _getAuthors = __webpack_require__(840);
	
	var _getAuthors2 = _interopRequireDefault(_getAuthors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// pulse has 'medium' as 'channel' in schema
	var utmToPulse = function utmToPulse(utm) {
	    var medium = utm.medium,
	        rest = (0, _objectWithoutProperties3.default)(utm, ['medium']);
	
	
	    var converted = (0, _extends3.default)({}, rest);
	
	    if (medium) {
	        converted.channel = medium;
	    }
	
	    return converted;
	};
	
	// get name of each parent section
	var getSectionNames = function getSectionNames(section) {
	    var sectionNames = [];
	    var currentSection = section;
	    while (currentSection) {
	        sectionNames.unshift(currentSection.statisticsName);
	        currentSection = currentSection.parent;
	    }
	
	    return sectionNames;
	};
	
	// transforms state from screens into tracking params
	function clientParams() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$config = _ref.config,
	        config = _ref$config === undefined ? {} : _ref$config,
	        _ref$state = _ref.state,
	        state = _ref$state === undefined ? {} : _ref$state,
	        layout = _ref.layout,
	        _ref$utm = _ref.utm,
	        utm = _ref$utm === undefined ? {} : _ref$utm,
	        _ref$location = _ref.location,
	        location = _ref$location === undefined ? {} : _ref$location;
	
	    var article = state.article,
	        collectionArticles = state.collectionArticles,
	        plussArticles = state.plussArticles,
	        _state$spid = state.spid,
	        spid = _state$spid === undefined ? {} : _state$spid,
	        device = state.device,
	        _state$paywallType = state.paywallType,
	        paywallType = _state$paywallType === undefined ? 'spid' : _state$paywallType;
	    var clientAgreementAccepted = spid.clientAgreementAccepted,
	        defaultAgreementAccepted = spid.defaultAgreementAccepted;
	
	    var userId = clientAgreementAccepted && defaultAgreementAccepted ? spid.userId : null;
	    var baseUrl = config.baseUrl,
	        _config$tracking = config.tracking;
	    _config$tracking = _config$tracking === undefined ? {} : _config$tracking;
	    var _config$tracking$enga = _config$tracking.engage;
	    _config$tracking$enga = _config$tracking$enga === undefined ? {} : _config$tracking$enga;
	    var _config$tracking$enga2 = _config$tracking$enga.enableOverlay,
	        enableOverlay = _config$tracking$enga2 === undefined ? false : _config$tracking$enga2;
	
	
	    if (!baseUrl || !device) {
	        return {};
	    }
	
	    var customPulseData = utmToPulse(utm);
	    var content = {};
	    var url = void 0;
	    var type = void 0;
	
	    if (article && article.id) {
	        var _article$id = article.id,
	            id = _article$id === undefined ? '' : _article$id,
	            _article$title = article.title,
	            title = _article$title === undefined ? '' : _article$title,
	            _article$section = article.section,
	            section = _article$section === undefined ? {} : _article$section,
	            tags = article.tags,
	            _article$changes = article.changes,
	            changes = _article$changes === undefined ? {} : _article$changes,
	            authors = article.authors,
	            _article$clientProper = article.clientProperties,
	            clientProperties = _article$clientProper === undefined ? {} : _article$clientProper,
	            _article$customProper = article.customProperties;
	        _article$customProper = _article$customProper === undefined ? {} : _article$customProper;
	        var isSubscription = _article$customProper.vg_paywall;
	
	
	        if (!id || !title) {
	            return {};
	        }
	
	        var _section$statisticsNa = section.statisticsName,
	            statisticsName = _section$statisticsNa === undefined ? '' : _section$statisticsNa,
	            _section$parent = section.parent;
	        _section$parent = _section$parent === undefined ? {} : _section$parent;
	        var _section$parent$stati = _section$parent.statisticsName,
	            parentSection = _section$parent$stati === undefined ? '' : _section$parent$stati,
	            _section$title = section.title,
	            sectionTitle = _section$title === undefined ? '' : _section$title;
	
	
	        var group = sectionTitle;
	        var isPaid = isSubscription && layout === 'promo';
	
	        customPulseData.accessLevel = isSubscription ? 'Paid' : 'Free';
	
	        if (isPaid) {
	            customPulseData.paywallType = paywallType;
	        }
	
	        type = isPaid ? 'SalesPoster' : 'Article';
	        url = baseUrl + '/i/' + id; // short url
	
	        content = {
	            id: id,
	            title: title.value,
	            categories: [parentSection + '>' + statisticsName],
	            group: group,
	            section: section,
	            tags: tags,
	            productTag: isSubscription ? 'vgpluss' : 'vg',
	            published: changes.published,
	            updated: changes.updated,
	            authors: (0, _getAuthors2.default)(authors),
	            wordcount: clientProperties.wordCount
	        };
	    } else if (collectionArticles && collectionArticles.collection.length) {
	        var articles = collectionArticles.collection,
	            meta = collectionArticles.meta;
	        var _section = meta.section,
	            story = meta.story,
	            tag = meta.tag;
	
	        customPulseData.numItems = articles ? articles.length : 0;
	
	        type = 'Listing';
	        url = baseUrl + location.pathname;
	        if (_section) {
	            url = _section.url;
	            var sectionNames = getSectionNames(_section);
	            var _id = '/' + sectionNames.join('/');
	            var category = sectionNames.join('>');
	
	            content = {
	                id: _id,
	                title: _section.statisticsName,
	                category: category,
	                categories: [category]
	            };
	        } else if (tag) {
	            content = {
	                id: tag.id,
	                title: tag.title
	            };
	        } else if (story) {
	            content = {
	                id: story.id,
	                title: story.title
	            };
	        }
	    } else if (plussArticles && plussArticles.pluss.length) {
	        // vg.no/pluss
	        type = 'Listing';
	        url = baseUrl + location.pathname;
	        content = {
	            id: '/pluss',
	            title: 'VG+ Landingsside',
	            productTag: 'vgpluss'
	        };
	    }
	
	    if (!url || !type) {
	        // eslint-disable-next-line no-console
	        console.warn(new Error('Missing important tracking variables'));
	    }
	
	    var trackingOpt = {
	        site: 'VG',
	        device: (0, _normalizeDevice2.default)(device),
	        type: type,
	        url: url,
	        content: content,
	        config: config.tracking,
	        enableOverlay: enableOverlay,
	        custom: {
	            pulse: customPulseData
	        }
	    };
	
	    if (userId) {
	        trackingOpt.userId = userId;
	    }
	
	    return trackingOpt;
	}

/***/ },

/***/ 186:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deferOnload = function deferOnload() {
	    return new _promise2.default(function (resolve) {
	        var throttled = (window.requestIdleCallback || setTimeout).bind(null, resolve);
	        /* eslint-disable no-undef */
	        if (document.readyState === 'complete') {
	            throttled();
	        } else {
	            window.addEventListener('load', throttled);
	        }
	        /* eslint-enable no-undef */
	    });
	};
	
	exports.default = deferOnload;

/***/ },

/***/ 187:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFonts = getFonts;
	exports.fontsToInlineStyle = fontsToInlineStyle;
	function getFonts() {
	    var customFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var irisTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var themes = customFonts.themes;
	
	
	    var shouldExcludeFont = function shouldExcludeFont(font, irisThemes) {
	        if (!Array.isArray(font.exclude)) {
	            return false;
	        }
	
	        var len = font.exclude.length;
	
	        /* eslint-disable */
	        while (len--) {
	            if (irisThemes.indexOf(font.exclude[len]) > -1) {
	                return true;
	            }
	
	            continue;
	        }
	        /* eslint-enable */
	
	        return false;
	    };
	
	    var fonts = themes.all.filter(function (font) {
	        return !shouldExcludeFont(font, irisTheme);
	    });
	
	    irisTheme.reduce(function (acc, themeId) {
	        var sectionFonts = themes[themeId];
	
	        if (sectionFonts) {
	            sectionFonts.forEach(function (font) {
	                return acc.push(font);
	            });
	        }
	
	        return acc;
	    }, fonts);
	
	    return fonts;
	}
	
	function fontsToInlineStyle() {
	    var fonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return fonts.map(function (_ref) {
	        var name = _ref.name,
	            cdn = _ref.cdn,
	            weight = _ref.weight,
	            style = _ref.style;
	        return '\n            @font-face {\n                src: url("' + cdn + '.eot#?iefix") format(\'embedded-opentype\'),\n                     url("' + cdn + '.woff2") format(\'woff2\'),\n                     url("' + cdn + '.woff") format(\'woff\');\n                font-family: ' + name + ';\n                font-display: fallback;\n                font-weight: ' + weight + ';\n                font-style: ' + style + ';\n            }\n        ';
	    }).join('');
	}

/***/ },

/***/ 188:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _reduxSpid = __webpack_require__(69);
	
	var _universalConfig = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRedirectUri = function getRedirectUri(_ref) {
	    var protocol = _ref.protocol,
	        host = _ref.host;
	    return protocol + '//' + host + '/auth/callback';
	};
	var isAppRegex = /-app$/;
	
	exports.default = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3) {
	        var thunkDispatch = _ref3.thunkDispatch,
	            getState = _ref3.getState;
	
	        var _getState, _getState$article, _getState$article$cus, isSubscription, device, cookieBeforeSpid, spidConfig, isAppAndPaywalledArticle, cookieAfterSpid, spidCookieAppeared;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _getState = getState(), _getState$article = _getState.article;
	                        _getState$article = _getState$article === undefined ? {} : _getState$article;
	                        _getState$article$cus = _getState$article.customProperties;
	                        _getState$article$cus = _getState$article$cus === undefined ? {} : _getState$article$cus;
	                        isSubscription = _getState$article$cus.vg_paywall, device = _getState.device;
	                        cookieBeforeSpid = hasVarnishCookie();
	                        spidConfig = _universalConfig.appConfig.spid;
	                        isAppAndPaywalledArticle = isSubscription && isAppRegex.test(device);
	
	                        // clear spid hasSession cache if referer is payment.schibsted.no
	
	                        if (!cookieBeforeSpid && (/payment\.schibsted\.no|\/auth\/callback/.test(document.referrer) || isAppAndPaywalledArticle)) {
	                            try {
	                                window.localStorage.removeItem('hasSession-cache');
	                            } catch (err) {} // eslint-disable-line
	                        }
	
	                        if (!spidConfig.redirectUri) {
	                            spidConfig.redirectUri = getRedirectUri(window.location);
	                        }
	                        _context.next = 12;
	                        return thunkDispatch(_reduxSpid.actions.start(spidConfig));
	
	                    case 12:
	                        cookieAfterSpid = hasVarnishCookie();
	                        spidCookieAppeared = !cookieBeforeSpid && cookieAfterSpid;
	
	                        // reload paid article after spid login
	
	                        if (isSubscription && spidCookieAppeared) {
	                            window.location.reload(true);
	                        }
	
	                    case 15:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    function initSpid(_x) {
	        return _ref2.apply(this, arguments);
	    }
	
	    return initSpid;
	}();
	
	function hasVarnishCookie() {
	    return document.cookie.indexOf('SP_ID') > -1;
	}

/***/ },

/***/ 189:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(91);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = urlFriendly;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function replaceArray(string, object) {
	    return object.reduce(function (original, _ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            regexp = _ref2[0],
	            replace = _ref2[1];
	
	        return original.replace(regexp, replace);
	    }, string);
	}
	
	var specialChars = [[/æ/g, 'ae'], [/ø/g, 'oe'], [/å/g, 'aa'], [/é/g, 'e'], [/è/g, 'e'], [/à/g, 'a'], [/ä/g, 'a'], [/ö/g, 'o'], [/õ/g, 'o']];
	
	var nonAlphaNumeric = /[^A-Za-z0-9]+/g;
	
	function urlFriendly(string) {
	    if (typeof string !== 'string') {
	        throw new Error("Can't url friendly a non string");
	    }
	
	    return replaceArray(string.toLowerCase(), specialChars).replace(nonAlphaNumeric, '-').replace(/(^([-]+)|([-]+)$)/g, ''); // Trim leading and trailing dashes
	}

/***/ },

/***/ 209:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1tr5N","visuallyhidden":"_3PXlu","hide-text":"_2zIOB","center":"_1lP7v","noprint":"_3m5bB","root":"_3d744","contentContainer":"_2ExW9","noA":"MoZLw"};

/***/ },

/***/ 210:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2mOVl","visuallyhidden":"_1dRZU","hide-text":"_3UEdN","center":"_2zFMM","noprint":"_3H3Rf","root":"_3Xtny","text":"_2-y68"};

/***/ },

/***/ 211:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1cxDW","visuallyhidden":"_2PBfG","hide-text":"_1hKHG","center":"_1dl2J","noprint":"_3gMyA","headline":"_11zKy _1o64I"};

/***/ },

/***/ 312:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AdPlacement = __webpack_require__(767);
	
	Object.defineProperty(exports, 'AdPlacement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AdPlacement).default;
	  }
	});
	
	var _VgClientPlacedAd = __webpack_require__(123);
	
	Object.defineProperty(exports, 'ClientPlacedAd', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VgClientPlacedAd).default;
	  }
	});
	
	var _SponsorAd = __webpack_require__(769);
	
	Object.defineProperty(exports, 'SponsorAd', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SponsorAd).default;
	  }
	});
	
	var _HorseshoeAd = __webpack_require__(768);
	
	Object.defineProperty(exports, 'HorseshoeAd', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HorseshoeAd).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ 313:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.themePrefix = undefined;
	
	var _assign = __webpack_require__(73);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(166);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var themePrefix = exports.themePrefix = 'vgTheme-';
	
	var BodyClass = function (_Component) {
	    (0, _inherits3.default)(BodyClass, _Component);
	
	    function BodyClass() {
	        (0, _classCallCheck3.default)(this, BodyClass);
	        return (0, _possibleConstructorReturn3.default)(this, (BodyClass.__proto__ || (0, _getPrototypeOf2.default)(BodyClass)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(BodyClass, [{
	        key: 'render',
	        value: function render() {
	            return _react.Children.only(this.props.children);
	        }
	    }]);
	    return BodyClass;
	}(_react.Component);
	
	BodyClass.propTypes = {
	    theme: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
	    children: _propTypes2.default.node.isRequired
	};
	
	function reducePropsToState(propsList) {
	    var theme = {};
	    propsList.forEach(function (props) {
	        (0, _assign2.default)(theme, props);
	    });
	    return theme;
	}
	
	function handleStateChangeOnClient(reducedProps) {
	    var classNames = document.body.className.split(' ');
	    classNames = classNames.filter(function (name) {
	        return name.indexOf(themePrefix) !== 0;
	    });
	    classNames.push(reducedProps.theme);
	    document.body.className = classNames.filter(Boolean).join(' ');
	}
	
	exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(BodyClass);

/***/ },

/***/ 314:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Teaser = __webpack_require__(796);
	
	var _Teaser2 = _interopRequireDefault(_Teaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GridTeaser = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(GridTeaser, _React$PureComponent);
	
	    function GridTeaser() {
	        (0, _classCallCheck3.default)(this, GridTeaser);
	        return (0, _possibleConstructorReturn3.default)(this, (GridTeaser.__proto__ || (0, _getPrototypeOf2.default)(GridTeaser)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(GridTeaser, [{
	        key: 'render',
	
	        /* eslint-disable react/forbid-prop-types */
	        value: function render() {
	            var _props = this.props,
	                article = _props.article,
	                theme = _props.theme,
	                index = _props.index,
	                utmParams = _props.utmParams;
	
	            var fullWidthDesktop = (index - 3) % 7 === 0; // every seventh teaser, except from the fourth
	            var fullWidthMobile = [true, false, false, true][index % 4]; // every first and fourth
	
	            return _react2.default.createElement(_Teaser2.default, {
	                article: article,
	                theme: theme,
	                utmParams: utmParams,
	                fullWidthDesktop: fullWidthDesktop,
	                fullWidthMobile: fullWidthMobile
	            });
	        }
	    }]);
	    return GridTeaser;
	}(_react2.default.PureComponent), _class.propTypes = {
	    article: _propTypes2.default.object.isRequired,
	    theme: _propTypes2.default.object,
	    utmParams: _propTypes2.default.object,
	    index: _propTypes2.default.number
	}, _class.defaultProps = {
	    theme: {},
	    index: undefined
	}, _temp);
	exports.default = GridTeaser;

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable global-require */
	
	exports.default = {
	    default: {
	        ReferenceFront: __webpack_require__(975),
	        PlussFront: __webpack_require__(981),
	        Article: __webpack_require__(976),
	        Collection: __webpack_require__(979),
	        AboutVG: __webpack_require__(974),
	        '@spp/ui-text': __webpack_require__(1023),
	        '@spp/skip-to-content': __webpack_require__(1016),
	        '@spp/ui-article': __webpack_require__(986),
	        '@spp/ui-article-list': __webpack_require__(985),
	        '@spp/ui-blockquote': __webpack_require__(987),
	        '@spp/ui-carousel': __webpack_require__(992),
	        '@spp/ui-embed-content': __webpack_require__(995),
	        '@spp/ui-factbox': __webpack_require__(998),
	        '@spp/ui-gallery': __webpack_require__(1001),
	        '@spp/ui-gallery:image': __webpack_require__(1002),
	        '@spp/ui-grade': __webpack_require__(1003),
	        '@spp/ui-headline': __webpack_require__(1004),
	        '@spp/ui-image': __webpack_require__(1007),
	        '@spp/ui-label': __webpack_require__(1009),
	        '@spp/ui-lead-text': __webpack_require__(1010),
	        '@spp/ui-list': __webpack_require__(1011),
	        '@spp/ui-map': __webpack_require__(1012),
	        '@spp/ui-share': __webpack_require__(1015),
	        '@spp/ui-share:svg': __webpack_require__(1020),
	        '@spp/ui-subheading': __webpack_require__(1018),
	        '@spp/ui-subtitle': __webpack_require__(1019),
	        '@spp/video-asset': __webpack_require__(1029),
	        '@spp/inline-video': __webpack_require__(1008),
	        '@spp/ui-byline': __webpack_require__(990),
	        '@spp/ui-teaser-small': __webpack_require__(1022),
	        '@vg/ui-contact-us': __webpack_require__(993),
	        '@vg/ui-url': __webpack_require__(1026),
	        '@vg/coupon-codes': __webpack_require__(982),
	        '@vg/gold-competition': __webpack_require__(1028),
	        '@vg/ui-embed-wrapper': __webpack_require__(996),
	        '@vg/editorial-label': __webpack_require__(994),
	        '@vg/fb-comments': __webpack_require__(999),
	        '@vg/feedback': __webpack_require__(1000),
	        '@vg/footer': __webpack_require__(983),
	        '@vg/publication-timestamp': __webpack_require__(1024),
	        '@vg/tags': __webpack_require__(1021),
	        '@vg/top-object': __webpack_require__(1025),
	        '@vg/map-mapbox': __webpack_require__(984),
	        '@vg/generic-error': __webpack_require__(980),
	        '@vg/salesposter': __webpack_require__(341),
	        '@vg/external-articles': __webpack_require__(997),
	        '@spp/ui-core-navigation': __webpack_require__(959),
	        '@spp/cn-login-button': __webpack_require__(961),
	        '@spp/cn-subscribe-button': __webpack_require__(971),
	        '@spp/cn-chevron-down-main-menu': __webpack_require__(339),
	        '@spp/cn-chevron-down-masthead-extension': __webpack_require__(339),
	        '@spp/cn-chevron-left': __webpack_require__(930),
	        '@spp/cn-logo': __webpack_require__(973),
	        '@spp/cn-main-menu': __webpack_require__(962),
	        '@spp/cn-masthead': __webpack_require__(963),
	        '@spp/cn-masthead-extension': __webpack_require__(964),
	        '@spp/cn-masthead-extension-basic-view': __webpack_require__(965),
	        '@spp/cn-masthead-extension-section-view': __webpack_require__(966),
	        '@spp/cn-masthead-search': __webpack_require__(931),
	        '@spp/cn-search': __webpack_require__(969),
	        '@spp/cn-sitemap': __webpack_require__(970),
	        '@spp/cn-user-menu': __webpack_require__(972),
	        '@spp/cn-masthead-extension-subscription-buttons': __webpack_require__(967),
	        '@spp/cn-masthead-extension-widgets': __webpack_require__(968),
	        '@spp/cn-user-logged-in-button': __webpack_require__(932),
	        '@spp/cn-logged-in-badge': __webpack_require__(960),
	        '@vg/ui-nt-disclaimer': __webpack_require__(1014),
	        '@vg/ui-nt-bundle': __webpack_require__(1013),
	        '@vg/ui-video-paywall-overlay': __webpack_require__(1027)
	    },
	    sportnews: {
	        Article: __webpack_require__(977),
	        '@spp/ui-blockquote': __webpack_require__(988),
	        '@spp/ui-carousel': __webpack_require__(343),
	        '@spp/ui-headline': __webpack_require__(1005),
	        '@spp/ui-byline': __webpack_require__(991),
	        '@spp/ui-article-list': __webpack_require__(342),
	        '@spp/ui-teaser-small': __webpack_require__(346),
	        '@vg/ui-nt-bundle': __webpack_require__(344),
	        '@vg/tags': __webpack_require__(345)
	    },
	    sportfeature: {
	        Article: __webpack_require__(978),
	        '@spp/ui-blockquote': __webpack_require__(989),
	        '@spp/ui-carousel': __webpack_require__(343),
	        '@spp/ui-gallery': __webpack_require__(132),
	        '@spp/ui-headline': __webpack_require__(1006),
	        '@spp/ui-image': __webpack_require__(133),
	        '@spp/ui-lead-text': __webpack_require__(135),
	        '@spp/ui-map': __webpack_require__(136),
	        '@spp/ui-subheading': __webpack_require__(137),
	        '@spp/ui-subtitle': __webpack_require__(138),
	        '@spp/inline-video': __webpack_require__(134),
	        '@spp/ui-byline': __webpack_require__(131),
	        '@spp/ui-teaser-small': __webpack_require__(346),
	        '@spp/ui-article-list': __webpack_require__(342),
	        '@vg/ui-nt-bundle': __webpack_require__(344),
	        '@vg/publication-timestamp': __webpack_require__(139),
	        '@vg/tags': __webpack_require__(345)
	    },
	    /* all of these are the same, so add new items to all categories */
	    nyheterfeature: {
	        Article: __webpack_require__(209),
	        '@spp/ui-blockquote': __webpack_require__(210),
	        '@spp/ui-gallery': __webpack_require__(132),
	        '@spp/ui-headline': __webpack_require__(211),
	        '@spp/ui-image': __webpack_require__(133),
	        '@spp/ui-lead-text': __webpack_require__(135),
	        '@spp/ui-map': __webpack_require__(136),
	        '@spp/ui-subheading': __webpack_require__(137),
	        '@spp/ui-subtitle': __webpack_require__(138),
	        '@spp/inline-video': __webpack_require__(134),
	        '@spp/ui-byline': __webpack_require__(131),
	        '@vg/publication-timestamp': __webpack_require__(139)
	    },
	    rampelysfeature: {
	        Article: __webpack_require__(209),
	        '@spp/ui-blockquote': __webpack_require__(210),
	        '@spp/ui-gallery': __webpack_require__(132),
	        '@spp/ui-headline': __webpack_require__(211),
	        '@spp/ui-image': __webpack_require__(133),
	        '@spp/ui-lead-text': __webpack_require__(135),
	        '@spp/ui-map': __webpack_require__(136),
	        '@spp/ui-subheading': __webpack_require__(137),
	        '@spp/ui-subtitle': __webpack_require__(138),
	        '@spp/inline-video': __webpack_require__(134),
	        '@spp/ui-byline': __webpack_require__(131),
	        '@vg/publication-timestamp': __webpack_require__(139)
	    },
	    forbrukerfeature: {
	        Article: __webpack_require__(209),
	        '@spp/ui-blockquote': __webpack_require__(210),
	        '@spp/ui-gallery': __webpack_require__(132),
	        '@spp/ui-headline': __webpack_require__(211),
	        '@spp/ui-image': __webpack_require__(133),
	        '@spp/ui-lead-text': __webpack_require__(135),
	        '@spp/ui-map': __webpack_require__(136),
	        '@spp/ui-subheading': __webpack_require__(137),
	        '@spp/ui-subtitle': __webpack_require__(138),
	        '@spp/inline-video': __webpack_require__(134),
	        '@spp/ui-byline': __webpack_require__(131),
	        '@vg/publication-timestamp': __webpack_require__(139)
	    }
	};
	/* eslint-enable global-require */

/***/ },

/***/ 316:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var getLeadText = function getLeadText(_ref) {
	    var components = _ref.components;
	
	    var leadText = components.find(function (component) {
	        return component.subtype === 'lead';
	    });
	
	    if (leadText !== undefined) {
	        return leadText.text.value;
	    }
	    return '';
	};
	
	exports.default = getLeadText;

/***/ },

/***/ 317:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var deviceMap = {
	    'mobile-app': 'mobile',
	    'tablet-app': 'tablet'
	};
	
	var normalizeDevice = function normalizeDevice(device) {
	    return deviceMap[device] || device;
	};
	
	exports.default = normalizeDevice;

/***/ },

/***/ 341:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"USxgr","visuallyhidden":"_16_Y_","hide-text":"_3JDhA","center":"_3iUZV","noprint":"_4TTBs","salesPoster":"ZZ2w_","autumn":"_3owtJ","buyButton":"_3Ua1N","buylink":"OOTC3","price":"_3GObJ","existing":"_3ceBc","logIn":"_3fotB","salespitch":"z6m6t","salespitchContent":"_3MGVX","paymentOptions":"_1N5sg","option":"_2pR1x","content":"_11oCc","title":"_2yQho","currency":"_38BuT","priceDetail":"_1fzZq","promoted":"xCtQu","banner":"ye_5M","span":"F58G1","footnote":"_2bTri","iapFooternote":"mSJlC","promotion":"_36hM-","footer":"rflwF","paymentPartner":"_1mXWw","clearfix":"_1D4c0","IAPbreadCrumbs":"_2Pv1t","crumb":"_2pUzQ","crumbMarker":"dJ53I","crumbText":"_2s4Ic","complete":"_1k15J","paywallTextFading":"v1Os6","mobileLogin":"F4XeC","desktopLogin":"_2MAMA"};

/***/ },

/***/ 342:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1Sb8o","visuallyhidden":"_1kwP3","hide-text":"_1Qg5b","center":"_2BtOj","noprint":"_15Ca9","articlesList":"_1cRzt","listItem":"_1SBVB","article":"_2FCBm","articleLink":"_3vknC","root":"_3vZ1g"};

/***/ },

/***/ 343:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3h0UL","visuallyhidden":"_2ZO3h","hide-text":"_2Vt5q","center":"_1tn6N","noprint":"_2764Y","carousel":"vIOJJ","slideContainer":"qpvc7","slideContainerViewport":"_3L7Yk","slide":"_3N5--","slideItemWrapper":"_2ZMJP","changeSlideButton":"_1dnSr","changeSlideButtonDisabled":"_3E_9u"};

/***/ },

/***/ 344:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3oxlr","visuallyhidden":"_3Hptr","hide-text":"_1OShY","center":"_1mI7L","noprint":"_1qTbf","nt-bundle":"_37Mvq"};

/***/ },

/***/ 345:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1CIiE","visuallyhidden":"_2Qw-O","hide-text":"_1420M","center":"_1IERM","noprint":"_2e9NL","tags":"_-TqRQ"};

/***/ },

/***/ 346:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2HBgP","visuallyhidden":"_2HYUD","hide-text":"_9jk-Z","center":"_2jq9Q","noprint":"m0IBx","root":"_2NumO","image":"_1-isB","alternateImagePosition":"_2ILBU","content":"P7TUR","label":"_1YnST"};

/***/ },

/***/ 759:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _littleLoader = __webpack_require__(63);
	
	var _littleLoader2 = _interopRequireDefault(_littleLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var url = 'https://sdk.pulse.schibsted.com/gdpr-transparency-apnxs/latest/gdpr-bundle.js';
	
	    return new _promise2.default(function (resolve, reject) {
	        (0, _littleLoader2.default)(url, function (err) {
	            if (err) {
	                return reject(err);
	            }
	
	            return resolve();
	        });
	    });
	};

/***/ },

/***/ 767:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VgClientPlacedAd = __webpack_require__(123);
	
	var _VgClientPlacedAd2 = _interopRequireDefault(_VgClientPlacedAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var AdPlacement = (_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AdPlacement, _Component);
	
	    function AdPlacement() {
	        (0, _classCallCheck3.default)(this, AdPlacement);
	        return (0, _possibleConstructorReturn3.default)(this, (AdPlacement.__proto__ || (0, _getPrototypeOf2.default)(AdPlacement)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AdPlacement, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var ads = this.props.types.map(function (type) {
	                return _react2.default.createElement(_VgClientPlacedAd2.default, {
	                    key: type,
	                    subtype: type,
	                    clientPlacedAds: _this2.props.clientPlacedAds
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'board_ads' },
	                ads
	            );
	        }
	    }]);
	    return AdPlacement;
	}(_react.Component), _class.propTypes = {
	    types: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	    clientPlacedAds: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	}, _temp);
	/* eslint-disable */
	
	exports.default = AdPlacement;

/***/ },

/***/ 768:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactStickynode = __webpack_require__(1298);
	
	var _reactStickynode2 = _interopRequireDefault(_reactStickynode);
	
	var _VgClientPlacedAd = __webpack_require__(123);
	
	var _VgClientPlacedAd2 = _interopRequireDefault(_VgClientPlacedAd);
	
	var _helpers = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HorseshoeAd = (_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(HorseshoeAd, _Component);
	
	    function HorseshoeAd() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, HorseshoeAd);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HorseshoeAd.__proto__ || (0, _getPrototypeOf2.default)(HorseshoeAd)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            wallpaperUpdated: false
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(HorseshoeAd, [{
	        key: 'updateWallpaperPosition',
	        value: function updateWallpaperPosition(ref, subtype) {
	            var node = (0, _reactDom.findDOMNode)(ref);
	
	            if (node && subtype === 'topboard' && this.state.wallpaperUpdated === false) {
	                (0, _helpers.updateWallpaperPosition)(node);
	                this.setState({
	                    wallpaperUpdated: true
	                });
	            }
	        }
	    }, {
	        key: 'renderAd',
	        value: function renderAd(subtype) {
	            var _this2 = this;
	
	            if (this.props.device !== 'desktop' && subtype !== 'topboard') {
	                return null;
	            }
	
	            return _react2.default.createElement(_VgClientPlacedAd2.default, {
	                subtype: subtype,
	                clientPlacedAds: this.props.clientPlacedAds,
	                ref: function ref(_ref2) {
	                    return _this2.updateWallpaperPosition(_ref2, subtype);
	                }
	            });
	        }
	    }, {
	        key: 'renderStickyAd',
	        value: function renderStickyAd(subtype, className) {
	            if (this.props.device !== 'desktop') {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                _reactStickynode2.default,
	                { enabled: true, top: 58, bottomBoundary: 'main', className: className },
	                this.renderAd(subtype)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'horseshoe' },
	                this.renderAd('wallpaper'),
	                this.renderAd('topboard'),
	                this.renderStickyAd('skyscraperleft_1', 'skyscraperleft'),
	                this.renderStickyAd('skyscraperright_1', 'skyscraperright')
	            );
	        }
	    }]);
	    return HorseshoeAd;
	}(_react.Component), _class.propTypes = {
	    clientPlacedAds: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    device: _propTypes2.default.string.isRequired
	}, _temp2);
	exports.default = HorseshoeAd;

/***/ },

/***/ 769:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VgClientPlacedAd = __webpack_require__(123);
	
	var _VgClientPlacedAd2 = _interopRequireDefault(_VgClientPlacedAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	exports.default = function (_ref) {
	    var clientPlacedAds = _ref.clientPlacedAds;
	    return _react2.default.createElement(_VgClientPlacedAd2.default, {
	        subtype: 'sponsorstripe',
	        clientPlacedAds: clientPlacedAds,
	        visibleOnError: false
	    });
	};
	/* eslint-disable */

/***/ },

/***/ 770:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactUs = function ContactUs(_ref) {
	    var urlValue = _ref.url,
	        titleValue = _ref.title,
	        links = _ref.links,
	        theme = _ref.theme,
	        identifier = _ref.identifier;
	
	    var listItems = links.map(function (item) {
	        return _react2.default.createElement(
	            'li',
	            { key: identifier + '-' + encodeURIComponent(item.linkText) },
	            _react2.default.createElement(
	                'a',
	                { href: item.link },
	                item.spanLinkText && _react2.default.createElement(
	                    'span',
	                    null,
	                    item.spanLinkText
	                ),
	                item.linkText
	            )
	        );
	    });
	
	    return _react2.default.createElement(
	        'aside',
	        { className: theme.root },
	        _react2.default.createElement(
	            'a',
	            { href: urlValue },
	            _react2.default.createElement(
	                'h3',
	                { className: theme.title },
	                titleValue
	            )
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: theme['tip-list'], 'aria-label': titleValue },
	            listItems
	        )
	    );
	};
	
	ContactUs.propTypes = {
	    identifier: _react.PropTypes.string.isRequired,
	    links: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        link: _react.PropTypes.string.isRequired,
	        linkText: _react.PropTypes.string.isRequired,
	        spanLinkText: _react.PropTypes.string
	    })).isRequired,
	    url: _react.PropTypes.string.isRequired,
	    title: _react.PropTypes.string.isRequired,
	    theme: _react.PropTypes.shape({
	        root: _react.PropTypes.string,
	        url: _react.PropTypes.string
	    })
	};
	
	ContactUs.defaultProps = {
	    identifier: '',
	    links: [{
	        link: 'tel:2200',
	        linkText: '2200',
	        spanLinkText: 'SMS'
	    }, {
	        link: 'tel:22000000',
	        linkText: '2200 0000',
	        spanLinkText: 'Tlf.'
	    }, {
	        link: 'mailto:2200@vg.no',
	        linkText: '2200@vg.no',
	        spanLinkText: 'E-post'
	    }],
	    theme: {},
	    title: 'Tips oss',
	    url: 'https://www.vg.no/tips-oss'
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/ui-contact-us')(ContactUs);

/***/ },

/***/ 771:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _class, _temp; /* eslint-disable react/prop-types, react/forbid-prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _universalConfig = __webpack_require__(22);
	
	var _uiArticleList = __webpack_require__(564);
	
	var _uiArticleList2 = _interopRequireDefault(_uiArticleList);
	
	var _uiImage = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assembleQueryParams = function assembleQueryParams(params) {
	    return (0, _keys2.default)(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');
	};
	
	var _articleRenderer = function _articleRenderer(_ref) {
	    var article = _ref.article,
	        imageAssetSizes = _ref.imageAssetSizes,
	        theme = _ref.theme,
	        onClick = _ref.onClick,
	        utmParams = _ref.utmParams;
	
	    var imageAsset = article.promotionContent.imageAsset ? _react2.default.createElement(_uiImage.ImageAsset, {
	        theme: theme.image,
	        urls: article.promotionContent.imageAsset.urls,
	        sizes: imageAssetSizes,
	        testTag: '@spp/ui-article-list:image-asset'
	    }) : _react2.default.createElement('img', { src: _universalConfig.appConfig.shareDefaults.image, alt: article.promotionContent.title.value });
	
	    var isPaywall = article.customProperties.vg_paywall;
	    // show indicator only if paywall
	    // and image asset is present
	    var indicator = isPaywall && imageAsset !== null ? _react2.default.createElement('div', { className: theme.plusIndicator }) : null;
	
	    var href = article.links.canonicalUrl;
	    if (utmParams) {
	        href += (href.indexOf('?') === -1 ? '?' : '&') + assembleQueryParams(utmParams);
	    }
	
	    return _react2.default.createElement(
	        'a',
	        {
	            className: theme.articleLink,
	            'data-test-tag': '@spp/ui-article-list:link',
	            href: href,
	            'aria-label': article.promotionContent.title.value,
	            'data-article-id': article.id,
	            onClick: onClick
	        },
	        _react2.default.createElement(
	            'div',
	            { className: theme.imageWrapper },
	            imageAsset,
	            indicator
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: theme.articleHeader },
	            article.promotionContent.title.value
	        )
	    );
	};
	
	var List = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(List, _React$PureComponent);
	
	    function List() {
	        (0, _classCallCheck3.default)(this, List);
	        return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(List, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                articles = _props.articles,
	                theme = _props.theme,
	                title = _props.title,
	                description = _props.description,
	                onClick = _props.onClick,
	                utmParams = _props.utmParams;
	
	            var imageAssetSizes = '(min-width: 980px) 300px, 50vw';
	
	            return _react2.default.createElement(_uiArticleList2.default, {
	                theme: theme,
	                header: title,
	                articleList: articles,
	                ariaLabel: description,
	                imageAssetSizes: imageAssetSizes,
	                articleRenderer: function articleRenderer(article) {
	                    return _articleRenderer({
	                        article: article,
	                        imageAssetSizes: imageAssetSizes,
	                        theme: theme,
	                        utmParams: utmParams,
	                        onClick: onClick
	                    });
	                }
	            });
	        }
	    }]);
	    return List;
	}(_react2.default.PureComponent), _class.propTypes = {
	    theme: _propTypes2.default.object,
	    articles: _propTypes2.default.array.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func,
	    utmParams: _propTypes2.default.object
	}, _class.defaultProps = {
	    theme: {}
	}, _temp);
	exports.default = List;

/***/ },

/***/ 772:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NorskTippingMeta = function NorskTippingMeta(_ref) {
	    var article = _ref.article;
	    var _article$customProper = article.customProperties;
	    _article$customProper = _article$customProper === undefined ? {} : _article$customProper;
	    var addTippetips = _article$customProper.vg_tippetips;
	
	
	    if (!addTippetips) {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('meta', { name: 'article:tag:type', content: 'Tippetips' }),
	        _react2.default.createElement('script', { src: '//tags.tiqcdn.com/utag/norsktipping/affiliate/prod/utag.js', defer: true })
	    );
	};
	
	NorskTippingMeta.propTypes = {
	    article: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	
	exports.default = NorskTippingMeta;

/***/ },

/***/ 773:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(190);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _universalConfig = __webpack_require__(22);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _getLeadText = __webpack_require__(316);
	
	var _getLeadText2 = _interopRequireDefault(_getLeadText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatAuthors = function formatAuthors(_ref) {
	    var authors = _ref.authors;
	    return authors.map(function (author) {
	        return {
	            '@type': 'Person',
	            name: author.title
	        };
	    });
	};
	
	var formatKeywords = function formatKeywords(_ref2) {
	    var tags = _ref2.tags;
	    return tags.map(function (tag) {
	        return tag.title;
	    }).join(' ').toLowerCase();
	};
	
	var fallbackImage = function fallbackImage() {
	    var defaultImage = _universalConfig.appConfig.schemaOrg.defaultImage;
	
	    return defaultImage;
	};
	
	var formatImage = function formatImage(_ref3) {
	    var promotionContent = _ref3.promotionContent;
	
	    if (promotionContent.imageAssets === undefined) {
	        return fallbackImage();
	    }
	
	    var imageUrl = promotionContent.imageAsset.urls[promotionContent.imageAsset.urls.length - 1].url;
	
	
	    return imageUrl;
	};
	
	var formatOrganization = function formatOrganization() {
	    var schemaOrg = _universalConfig.appConfig.schemaOrg.organization;
	
	    return schemaOrg;
	};
	
	/**
	 * Based on http://schema.org/NewsArticle
	 */
	var SchemaOrgArticle = function SchemaOrgArticle(_ref4) {
	    var article = _ref4.article,
	        _ref4$type = _ref4.type,
	        type = _ref4$type === undefined ? 'NewsArticle' : _ref4$type;
	    var headline = article.title.value,
	        _article$changes = article.changes,
	        datePublished = _article$changes.published,
	        dateModified = _article$changes.updated,
	        wordCount = article.clientProperties.wordCount,
	        articleSection = article.section.title;
	    var baseUrl = _universalConfig.appConfig.baseUrl;
	
	    var authors = formatAuthors(article);
	    var description = (0, _getLeadText2.default)(article);
	    var keywords = formatKeywords(article);
	    var image = formatImage(article);
	    var publisher = formatOrganization();
	    var url = baseUrl + '/i/' + article.id;
	
	    var articleData = {
	        '@context': 'http://schema.org',
	        '@type': type,
	        headline: headline,
	        datePublished: datePublished,
	        dateModified: dateModified,
	        wordCount: wordCount,
	        articleSection: articleSection,
	        description: description,
	        keywords: keywords,
	        image: image,
	        publisher: publisher,
	        author: authors,
	        mainEntityOfPage: url
	    };
	    var schema = {
	        type: 'application/ld+json',
	        innerHTML: (0, _stringify2.default)(articleData)
	    };
	
	    return _react2.default.createElement(_reactHelmet2.default, { script: [schema] });
	};
	
	SchemaOrgArticle.defaultProps = {
	    type: 'NewsArticle'
	};
	
	SchemaOrgArticle.propTypes = {
	    article: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	    type: _propTypes2.default.string // eslint-disable-line react/forbid-prop-types
	};
	
	exports.default = SchemaOrgArticle;

/***/ },

/***/ 774:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _twitterCard = __webpack_require__(746);
	
	var _twitterCard2 = _interopRequireDefault(_twitterCard);
	
	var _uiOpenGraph = __webpack_require__(667);
	
	var _uiOpenGraph2 = _interopRequireDefault(_uiOpenGraph);
	
	var _universalConfig = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShareMeta = function ShareMeta(_ref) {
	    var article = _ref.article;
	    var _article$promotionCon = article.promotionContent,
	        promotionContent = _article$promotionCon === undefined ? {} : _article$promotionCon;
	
	
	    if (!promotionContent.description) {
	        return null;
	    }
	
	    var shareUrl = article.links.shareUrl;
	    var defaultShareImage = _universalConfig.appConfig.shareDefaults.image;
	    var articleDesc = promotionContent.description.value,
	        articleTitle = promotionContent.title.value;
	
	    var _ref2 = promotionContent.imageAsset ? promotionContent.imageAsset.urls[promotionContent.imageAsset.urls.length - 1] : {},
	        _ref2$url = _ref2.url,
	        shareImageUrl = _ref2$url === undefined ? defaultShareImage : _ref2$url;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_twitterCard2.default, {
	            title: articleTitle,
	            card: 'summary_large_image',
	            description: articleDesc,
	            image: shareImageUrl
	        }),
	        _react2.default.createElement(_uiOpenGraph2.default, {
	            title: articleTitle,
	            type: 'article',
	            url: shareUrl,
	            description: articleDesc,
	            image: shareImageUrl
	        })
	    );
	};
	ShareMeta.propTypes = {
	    article: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	
	exports.default = ShareMeta;

/***/ },

/***/ 775:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Url = function Url(_ref) {
	    var urlValue = _ref.url,
	        _ref$title = _ref.title;
	    _ref$title = _ref$title === undefined ? {} : _ref$title;
	    var titleValue = _ref$title.value,
	        theme = _ref.theme;
	    return _react2.default.createElement(
	        'div',
	        { className: theme.root },
	        _react2.default.createElement(
	            'a',
	            { className: theme.url, href: urlValue },
	            titleValue
	        )
	    );
	};
	Url.propTypes = {
	    url: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.shape({
	        value: _propTypes2.default.string
	    }).isRequired,
	    theme: _propTypes2.default.shape({
	        url: _propTypes2.default.string
	    })
	};
	
	Url.defaultProps = {
	    theme: {}
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/ui-url')(Url);

/***/ },

/***/ 776:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactVG = function ContactVG(_ref) {
	    var theme = _ref.theme;
	    return _react2.default.createElement(
	        'section',
	        { 'aria-label': 'Kontakt oss', className: theme.aboutvg },
	        _react2.default.createElement(
	            'h1',
	            { className: theme.headline },
	            'Kontakt oss'
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Har du et nyhetstips, forslag til sak eller kommentar til innholdet p\xE5 VG Nett?'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Ta kontakt med vaktsjef:'
	            ),
	            _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Send tips online'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.vg.no/tips-oss/' },
	                        'Bruk skjema'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'SMS / MMS'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:2200' },
	                        '2200'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Ring'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:22000000' },
	                        '22 00 00 00'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'E-post til'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:2200@vg.no' },
	                        'tusentipset'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Pressemelding til redaksjonen:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:pressemeldinger@vg.no' },
	                    'pressemeldinger@vg.no'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Henvendelser om VG Helg:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:vghelg@vg.no' },
	                    'vghelg@vg.no'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Kommentar til en spesifikk sak?'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Klikk p\xE5 navnet til journalisten i toppen av artikkelen for \xE5 ta direkte kontakt.'
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Helgeabonnement - VG levert hjem'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://kundeportal.vg.no/' },
	                    'Kj\xF8p helgebonnement, gj\xF8r endringer i abonnementet, meld bortreist.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Ikke f\xE5tt avisen?'
	            ),
	            _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'E-post:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:kundeservice@abo.vg.no' },
	                        'kundeservice@abo.vg.no'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Telefon:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:22000777' },
	                        '22 00 07 77'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Avissalg og distribusjon'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Ved henvendelser ang\xE5ende avissalg:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:kundeservice@vg.no' },
	                    'kundeservice@vg.no'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Er du over 13 \xE5r, og \xF8nsker \xE5 selge VG p\xE5 s\xF8ndager,',
	                ' ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'http://www.md.no/' },
	                    'ta kontakt her.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Annons\xE8r i VG'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://annonseweb.schibsted.no/' },
	                    'Informasjon om priser, matereriell, formater og frister.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Bes\xF8ksaddresse'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Postadresse:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Verdens Gang AS',
	                _react2.default.createElement('br', null),
	                'Postboks 1185',
	                _react2.default.createElement('br', null),
	                'Sentrum 0107 Oslo'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Bes\xF8ksadresse:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Akersgata 55, 0180 Oslo',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.google.no/maps/place/Akersgata+55,+0180+Oslo/@59.9153665,10.7409502,17z/data=!3m1!4b1!4m5!3m4!1s0x46416e62d5089bd5:0x9da86b2ac96f02aa!8m2!3d59.915142!4d10.743943' },
	                    '\xC5pne i Google Maps'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Sentralbord:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tel:22000000' },
	                    '22 00 00 00'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'VG+ Support'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Kontakt oss:'
	            ),
	            _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Via kontaktskjema:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://support.pluss.vg.no/hc/no/requests/new' },
	                        '\xC5pne skjema'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'E-post:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:vgpluss@vg.no' },
	                        'vgpluss@vg.no'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Telefon:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:22000222' },
	                        '22 00 02 22'
	                    ),
	                    ' (11-12 p\xE5 hverdager)'
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Andre digitale henvendelser:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:support@vg.no' },
	                        'support@vg.no'
	                    )
	                )
	            )
	        )
	    );
	};
	
	ContactVG.propTypes = {
	    theme: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	};
	
	ContactVG.defaultProps = {
	    theme: {}
	};
	
	exports.default = ContactVG;

/***/ },

/***/ 777:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiblePersons = function ResponsiblePersons(_ref) {
	    var theme = _ref.theme;
	    return _react2.default.createElement(
	        'section',
	        { 'aria-label': 'Ansvarlige personer', className: theme.aboutvg },
	        _react2.default.createElement(
	            'h1',
	            { className: theme.headline },
	            'Ansvarlige personer'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.lighthr },
	            _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Ansv. redakt\xF8r og adm. direkt\xF8r:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:Gard.Steiro@vg.no' },
	                        'Gard Steiro'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Nyhetsredakt\xF8r:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:Tora.Bakke.Handlykken@vg.no' },
	                        'Tora Bakke H\xE5ndlykken'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Utviklingsredakt\xF8r:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:Ola.Stenberg@vg.no' },
	                        'Ola E. Stenberg'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Featureredakt\xF8r:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:Jane.Throndsen@vg.no' },
	                        'Jane Throndsen'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Politisk redakt\xF8r:'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:Hanne.Skartveit@vg.no' },
	                        'Hanne Skartveit'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'p',
	                null,
	                'VG arbeider etter',
	                ' ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'http://presse.no/pfu/etiske-regler/vaer-varsom-plakaten/' },
	                    'V\xE6r varsom-plakatens'
	                ),
	                ' ',
	                'regler for god presseskikk. VG har ikke ansvar for innhold p\xE5 eksterne nettsider som det lenkes til. Kopiering av materiale fra VG for bruk annet sted er ikke tillatt uten avtale.'
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Tips oss!'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Send tips online'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://support.pluss.vg.no/hc/no/requests/new' },
	                        'Bruk skjema'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'SMS / MMS'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:2200' },
	                        '2200'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Ring'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'tel:22000000' },
	                        '22 00 00 00'
	                    )
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'E-post til'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:2200@vg.no' },
	                        'tusentipset'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: theme.darkhr },
	            _react2.default.createElement(
	                'a',
	                { href: '/om-vg/kontakt-oss/', className: theme.contactButton },
	                'Kontakt oss'
	            )
	        )
	    );
	};
	
	ResponsiblePersons.propTypes = {
	    theme: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	};
	
	ResponsiblePersons.defaultProps = {
	    theme: {}
	};
	
	exports.default = ResponsiblePersons;

/***/ },

/***/ 778:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _feedback = __webpack_require__(726);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkup(html) {
	    return { __html: html };
	}
	
	// eslint-disable-next-line react/prop-types
	var ActionableText = function ActionableText(_ref) {
	    var text = _ref.text,
	        settings = _ref.settings;
	    return _react2.default.createElement(
	        _feedback2.default,
	        { settings: settings },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: createMarkup(text.value) })
	    );
	};
	
	exports.default = ActionableText;

/***/ },

/***/ 779:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uiTeaserSmall = __webpack_require__(699);
	
	var _uiTeaserSmall2 = _interopRequireDefault(_uiTeaserSmall);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bundle = function Bundle() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        theme = _ref.theme,
	        items = _ref.items;
	
	    var teaserBundle = items.map(function (teaser) {
	        return _react2.default.createElement(_uiTeaserSmall2.default, teaser);
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: theme['nt-bundle'] },
	        teaserBundle
	    );
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/ui-nt-bundle')(Bundle);

/***/ },

/***/ 780:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uiByline = __webpack_require__(285);
	
	var _uiByline2 = _interopRequireDefault(_uiByline);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Byline = function Byline(props) {
	    var _config$ariaLabels = _config.config.ariaLabels;
	    _config$ariaLabels = _config$ariaLabels === undefined ? {} : _config$ariaLabels;
	    var _config$ariaLabels$by = _config$ariaLabels.byline;
	    _config$ariaLabels$by = _config$ariaLabels$by === undefined ? {} : _config$ariaLabels$by;
	    var _config$ariaLabels$by2 = _config$ariaLabels$by.listTitle,
	        listTitle = _config$ariaLabels$by2 === undefined ? 'Skrevet av' : _config$ariaLabels$by2;
	
	
	    return _react2.default.createElement(_uiByline2.default, (0, _extends3.default)({}, props, { listTitle: listTitle, listFormat: { separator: '' } }));
	};
	
	exports.default = Byline;

/***/ },

/***/ 781:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbComments = __webpack_require__(310);
	
	var _fbComments2 = _interopRequireDefault(_fbComments);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Comments = function Comments(_ref) {
	    var url = _ref.url,
	        value = _ref.value,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['url', 'value']);
	
	    if (!value) {
	        return null;
	    }
	
	    var _config$comments = _config.config.comments;
	    _config$comments = _config$comments === undefined ? {} : _config$comments;
	    var _config$comments$face = _config$comments.facebook;
	    _config$comments$face = _config$comments$face === undefined ? {} : _config$comments$face;
	    var appId = _config$comments$face.appId,
	        buttonText = _config$comments$face.buttonText,
	        commentsAlwaysOpen = _config$comments$face.commentsAlwaysOpen,
	        commentsClosedHeading = _config$comments$face.commentsClosedHeading,
	        commentsClosedText = _config$comments$face.commentsClosedText,
	        commentsCloseHour = _config$comments$face.commentsCloseHour,
	        commentsOpenHour = _config$comments$face.commentsOpenHour,
	        cookie = _config$comments$face.cookie,
	        lang = _config$comments$face.lang,
	        minutesLeftWhenWarningDisplayed = _config$comments$face.minutesLeftWhenWarningDisplayed,
	        numPosts = _config$comments$face.numPosts,
	        version = _config$comments$face.version,
	        widgetWidth = _config$comments$face.widgetWidth,
	        xfbml = _config$comments$face.xfbml;
	
	
	    return _react2.default.createElement(_fbComments2.default, (0, _extends3.default)({
	        appId: appId,
	        buttonText: buttonText,
	        cookie: cookie,
	        commentsAlwaysOpen: commentsAlwaysOpen,
	        commentsClosedHeading: commentsClosedHeading,
	        commentsClosedText: commentsClosedText,
	        commentsOpenHour: commentsOpenHour,
	        commentsCloseHour: commentsCloseHour,
	        lang: lang,
	        minutesLeftWhenWarningDisplayed: minutesLeftWhenWarningDisplayed,
	        numPosts: numPosts,
	        url: url,
	        version: version,
	        widgetWidth: widgetWidth,
	        xfbml: xfbml
	    }, rest));
	};
	
	exports.default = Comments;

/***/ },

/***/ 782:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uiCoreComments = __webpack_require__(595);
	
	var _uiCoreComments2 = _interopRequireDefault(_uiCoreComments);
	
	var _reactLazyLoad = __webpack_require__(67);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var CoreCommentsComponent = function CoreCommentsComponent(_ref) {
	    var articleId = _ref.articleId;
	
	    var theme = {
	        // eslint-disable-line no-underscore-dangle
	        // avatars toggle (default: false)
	        avatarsEnabled: false,
	        // rules url for publication (default: null)
	        rulesUrl: 'https://www.vg.no/informasjon/moderering/',
	        // primary CTA (publish comment button) options
	        ctaBackgroundColor: '#1199CC',
	        ctaBorderRadius: '0px',
	        ctaBorderColor: '#1199CC',
	        ctaPadding: '5px',
	        ctaTextColor: '#fff',
	        // secondary CTA (load more buttons etc.) options
	        secondaryCtaBackgroundColor: 'transparent',
	        secondaryCtaBorderRadius: '100px',
	        secondaryCtaBorderColor: '#1199CC',
	        secondaryCtaPadding: '4px 12px',
	        secondaryCtaTextColor: '#1199CC',
	        // links (reply, vote)
	        linkColor: '#1199CC',
	        linkBorderBottom: 'none',
	        linkFontWeight: '300'
	    };
	
	    var extraProps = {};
	
	    if (true) {
	        extraProps.embedScript = '//cmmnts.i.bt.no/assets/embedd.js';
	    }
	
	    return _react2.default.createElement(
	        _reactLazyLoad2.default,
	        { offset: 1500, debounce: false, throttle: 100 },
	        _react2.default.createElement(_uiCoreComments2.default, (0, _extends3.default)({
	            contentId: articleId,
	            publication: 'vg',
	            contentType: 'article',
	            lang: 'nb-no',
	            theme: theme
	        }, extraProps))
	    );
	};
	
	exports.default = CoreCommentsComponent;

/***/ },

/***/ 783:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uiEmbedContent = __webpack_require__(643);
	
	var _uiEmbedContent2 = _interopRequireDefault(_uiEmbedContent);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is a hack to provide a wrapper element as this is not supported in web-sdk yet.
	var EmbedWrapper = function EmbedWrapper(_ref) {
	    var url = _ref.url,
	        subtype = _ref.subtype,
	        theme = _ref.theme,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['url', 'subtype', 'theme']);
	
	    var isTippebanner = /^https:\/\/widget\.tippebannere\.no/.test(url);
	
	    if (subtype === 'top-banner') {
	        var disclaimer = void 0;
	        if (isTippebanner) {
	            disclaimer = _react2.default.createElement(
	                'span',
	                { className: theme.tippebannerDisclaimer },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#commercial-disclaimer' },
	                    'Hva er dette?'
	                )
	            );
	        }
	
	        var className = (0, _classnames2.default)(theme.topBanner, isTippebanner && theme.tippebanner);
	
	        var embedContent = _react2.default.createElement(_uiEmbedContent2.default, rest);
	        // add stretch (-16px) if not tippebanner
	        if (!isTippebanner) {
	            embedContent = _react2.default.createElement(
	                'div',
	                { className: theme.stretch },
	                embedContent
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: className },
	            embedContent,
	            disclaimer
	        );
	    }
	
	    if (isTippebanner) {
	        return _react2.default.createElement(
	            'div',
	            { className: theme['nt-widget-bottom'], id: 'commercial' },
	            _react2.default.createElement(_uiEmbedContent2.default, (0, _extends3.default)({}, rest, { scrolling: 'no' }))
	        );
	    }
	
	    return _react2.default.createElement(_uiEmbedContent2.default, rest);
	};
	
	EmbedWrapper.propTypes = {
	    url: _propTypes2.default.string,
	    subtype: _propTypes2.default.string,
	    theme: _propTypes2.default.shape({
	        url: _propTypes2.default.string
	    })
	};
	
	EmbedWrapper.defaultProps = {
	    url: '',
	    subtype: '',
	    theme: {}
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/ui-embed-wrapper')(EmbedWrapper);

/***/ },

/***/ 784:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uiFactbox = __webpack_require__(653);
	
	var _uiFactbox2 = _interopRequireDefault(_uiFactbox);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Factbox = function Factbox(_ref) {
	    var title = _ref.title,
	        components = _ref.components,
	        i18n = _ref.i18n,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['title', 'components', 'i18n']);
	    return _react2.default.createElement(_uiFactbox2.default, (0, _extends3.default)({
	        title: title,
	        expandBy: _config.config.factbox.expandBy,
	        i18n: _config.config.factbox.i18n
	    }, rest));
	};
	
	exports.default = Factbox;

/***/ },

/***/ 785:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeProvider = __webpack_require__(27);
	
	var _uiImage = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/prop-types: 0 */
	var GalleryImage = function GalleryImage(_ref) {
	    var imageAsset = _ref.imageAsset,
	        theme = _ref.theme,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['imageAsset', 'theme']);
	    return _react2.default.createElement(_uiImage.ImageAsset, (0, _extends3.default)({}, rest, imageAsset, { theme: theme.image }));
	};
	
	exports.default = (0, _themeProvider.themer)('@spp/ui-gallery:image')(GalleryImage);

/***/ },

/***/ 786:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeProvider = __webpack_require__(27);
	
	var _uiGallery = __webpack_require__(297);
	
	var _videoAsset = __webpack_require__(182);
	
	var _videoAsset2 = _interopRequireDefault(_videoAsset);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/prop-types: 0 */
	var GalleryVideo = function GalleryVideo(_ref) {
	    var _ref$title = _ref.title,
	        title = _ref$title === undefined ? {} : _ref$title,
	        videoAsset = _ref.videoAsset,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['title', 'videoAsset']);
	    var _config$video = _config.config.video;
	    _config$video = _config$video === undefined ? {} : _config$video;
	    var locale = _config$video.locale,
	        vendor = _config$video.vendor,
	        shareLink = _config$video.shareLink,
	        plugins = _config$video.plugins,
	        skin = _config$video.skin,
	        playerUrl = _config$video.playerUrl,
	        _config$iris = _config.config.iris;
	    _config$iris = _config$iris === undefined ? {} : _config$iris;
	    var host = _config$iris.host;
	    var videoTitle = title.value;
	
	
	    var getPlayerConfig = function getPlayerConfig(videoConfig) {
	        return (0, _extends3.default)({}, videoConfig, {
	            locale: locale,
	            vendor: vendor,
	            title: videoTitle,
	            sharing: { link: shareLink + videoAsset.id },
	            plugins: plugins,
	            skin: skin
	        });
	    };
	
	    return _react2.default.createElement(
	        _uiGallery.SlideContext,
	        null,
	        function (_ref2) {
	            var isActive = _ref2.isActive;
	            return _react2.default.createElement(_videoAsset2.default, (0, _extends3.default)({
	                forcePause: !isActive,
	                getPlayerConfig: getPlayerConfig,
	                reduxPath: 'video',
	                videoAsset: videoAsset,
	                autoplayNext: true,
	                apiUrl: host,
	                videoPlayerUrl: playerUrl
	            }, rest));
	        }
	    );
	};
	
	exports.default = (0, _themeProvider.themer)('@spp/ui-gallery:video')(GalleryVideo);

/***/ },

/***/ 787:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyLoad = __webpack_require__(67);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _uiImage = __webpack_require__(71);
	
	var _uiImage2 = _interopRequireDefault(_uiImage);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var LazyLoadedImage = function LazyLoadedImage(_ref) {
	    var subtype = _ref.subtype,
	        byline = _ref.byline,
	        _ref$caption = _ref.caption,
	        caption = _ref$caption === undefined ? { value: '' } : _ref$caption,
	        imageAsset = _ref.imageAsset;
	    var _caption$value = caption.value,
	        altText = _caption$value === undefined ? '' : _caption$value;
	    var imageSizes = _config.config.image.sizes;
	
	    var isTopObject = subtype === 'top';
	
	    // Drop sizes config for top image, makes it look better in VG+ articles
	    var img = _react2.default.createElement(_uiImage2.default, {
	        altText: altText,
	        byline: byline,
	        caption: caption,
	        imageAsset: (0, _extends3.default)({}, imageAsset, {
	            sizes: imageSizes
	        }),
	        sizes: isTopObject ? '100vw' : imageSizes,
	        labels: _config.config.image.labels,
	        showFullCaption: _config.config.image.showFullCaption
	    });
	
	    // if top object, do not lazy load
	    if (isTopObject) {
	        return img;
	    }
	
	    return _react2.default.createElement(
	        _reactLazyLoad2.default,
	        { offset: 500, debounce: false, throttle: 100 },
	        img
	    );
	};
	
	exports.default = LazyLoadedImage;

/***/ },

/***/ 788:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyLoad = __webpack_require__(67);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _MapMapbox = __webpack_require__(791);
	
	var _MapMapbox2 = _interopRequireDefault(_MapMapbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var LazyLoadedMapMapbox = function LazyLoadedMapMapbox(_ref) {
	    var subtype = _ref.subtype,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['subtype']);
	
	    var map = _react2.default.createElement(_MapMapbox2.default, props);
	
	    // if top object, do not lazy load
	    if (subtype === 'top') {
	        return map;
	    }
	
	    return _react2.default.createElement(
	        _reactLazyLoad2.default,
	        { offset: 500, debounce: false, throttle: 100 },
	        map
	    );
	};
	
	exports.default = LazyLoadedMapMapbox;

/***/ },

/***/ 789:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(857);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _topObject = __webpack_require__(745);
	
	var _topObject2 = _interopRequireDefault(_topObject);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyLoad = __webpack_require__(67);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LazyLoadedTopObject = (_dec = (0, _themeProvider.themer)('@vg/top-object'), _dec(_class = function (_TopObject) {
	    (0, _inherits3.default)(LazyLoadedTopObject, _TopObject);
	
	    function LazyLoadedTopObject() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, LazyLoadedTopObject);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LazyLoadedTopObject.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadedTopObject)).call.apply(_ref, [this].concat(args))), _this), _this.isPentFactBox = function () {
	            var _this$props$data$desc = _this.props.data.description,
	                description = _this$props$data$desc === undefined ? '' : _this$props$data$desc;
	
	            return description.indexOf('Pent.no') === 0;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(LazyLoadedTopObject, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                subtype = _props.subtype,
	                theme = _props.theme;
	
	
	            if (subtype === 'top') {
	                return _react2.default.createElement(
	                    'div',
	                    { className: theme['top-object-in-header'] },
	                    (0, _get3.default)(LazyLoadedTopObject.prototype.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadedTopObject.prototype), 'render', this).call(this)
	                );
	            }
	
	            if (this.isPentFactBox()) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                _reactLazyLoad2.default,
	                { offset: 1000, debounce: false, throttle: 100 },
	                (0, _get3.default)(LazyLoadedTopObject.prototype.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadedTopObject.prototype), 'render', this).call(this)
	            );
	        }
	    }]);
	    return LazyLoadedTopObject;
	}(_topObject2.default)) || _class);
	exports.default = LazyLoadedTopObject;

/***/ },

/***/ 790:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(73);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _isomorphicFetch = __webpack_require__(62);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _inlineVideo = __webpack_require__(541);
	
	var _inlineVideo2 = _interopRequireDefault(_inlineVideo);
	
	var _reduxSpid = __webpack_require__(69);
	
	var _VideoPaywallOverlay = __webpack_require__(799);
	
	var _VideoPaywallOverlay2 = _interopRequireDefault(_VideoPaywallOverlay);
	
	var _config = __webpack_require__(38);
	
	var _normalizeDevice = __webpack_require__(317);
	
	var _normalizeDevice2 = _interopRequireDefault(_normalizeDevice);
	
	var _helpers = __webpack_require__(72);
	
	var _plussIpAccess = __webpack_require__(846);
	
	var _plussIpAccess2 = _interopRequireDefault(_plussIpAccess);
	
	var _getPersonalizedConfig = __webpack_require__(842);
	
	var _getPersonalizedConfig2 = _interopRequireDefault(_getPersonalizedConfig);
	
	var _duplicateApnKeywords = __webpack_require__(836);
	
	var _duplicateApnKeywords2 = _interopRequireDefault(_duplicateApnKeywords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// timeout for loading video access
	var VIDEO_ACCESS_TIMEOUT = 5000;
	
	/* eslint-disable react/prop-types */
	var LazyLoadedVideo = (_temp = _class = function (_Component) {
	    (0, _inherits3.default)(LazyLoadedVideo, _Component);
	
	    function LazyLoadedVideo(props) {
	        (0, _classCallCheck3.default)(this, LazyLoadedVideo);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoadedVideo.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadedVideo)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _config$video = _config.config.video,
	            locale = _config$video.locale,
	            vendor = _config$video.vendor,
	            shareLink = _config$video.shareLink,
	            plugins = _config$video.plugins,
	            skin = _config$video.skin,
	            playerUrl = _config$video.playerUrl,
	            _config$video$appnexu = _config$video.appnexus;
	        _config$video$appnexu = _config$video$appnexu === undefined ? {} : _config$video$appnexu;
	        var _config$video$appnexu2 = _config$video$appnexu.placementIds;
	        _config$video$appnexu2 = _config$video$appnexu2 === undefined ? {} : _config$video$appnexu2;
	        var _config$video$appnexu3 = _config$video$appnexu2.preroll,
	            preroll = _config$video$appnexu3 === undefined ? {} : _config$video$appnexu3,
	            _config$video$appnexu4 = _config$video$appnexu2.bumper,
	            bumper = _config$video$appnexu4 === undefined ? {} : _config$video$appnexu4,
	            _config$video$appnexu5 = _config$video$appnexu.pageType,
	            pageType = _config$video$appnexu5 === undefined ? 'article' : _config$video$appnexu5,
	            _config$video$appnexu6 = _config$video$appnexu.publisher,
	            publisher = _config$video$appnexu6 === undefined ? 'vg' : _config$video$appnexu6,
	            _config$video$appnexu7 = _config$video$appnexu.publisherGroup,
	            publisherGroup = _config$video$appnexu7 === undefined ? 'schibsted' : _config$video$appnexu7,
	            _config$video$appnexu8 = _config$video$appnexu.countryCode,
	            countryCode = _config$video$appnexu8 === undefined ? 'no' : _config$video$appnexu8,
	            antiAdblock = _config$video.antiAdblock,
	            antiAdblockConfigUrl = _config$video.antiAdblockConfigUrl,
	            pulse = _config$video.pulse,
	            _config$iris = _config.config.iris;
	        _config$iris = _config$iris === undefined ? {} : _config$iris;
	        var host = _config$iris.host;
	
	        var _ref = _this.props.title || {},
	            videoTitle = _ref.value;
	
	        var _this$props$videoAsse = _this.props.videoAsset,
	            _this$props$videoAsse2 = _this$props$videoAsse.id,
	            videoId = _this$props$videoAsse2 === undefined ? '' : _this$props$videoAsse2,
	            _this$props$videoAsse3 = _this$props$videoAsse.section;
	        _this$props$videoAsse3 = _this$props$videoAsse3 === undefined ? {} : _this$props$videoAsse3;
	        var _this$props$videoAsse4 = _this$props$videoAsse3.id,
	            tvCategory = _this$props$videoAsse4 === undefined ? '' : _this$props$videoAsse4;
	
	        var isAutoPlay = _this.props.startMode === 'silent';
	
	        var _this$props$videoAsse5 = _this.props.videoAsset.access;
	        _this$props$videoAsse5 = _this$props$videoAsse5 === undefined ? {} : _this$props$videoAsse5;
	        var plus = _this$props$videoAsse5.plus;
	
	        var userHasAccess = true;
	
	        // need to check access before rendering
	        if (plus === true) {
	            userHasAccess = false;
	        }
	
	        var assetType = 'video';
	        var firstSource = _this.props.videoAsset.sourceFiles && _this.props.videoAsset.sourceFiles.length && _this.props.videoAsset.sourceFiles[0];
	        if (firstSource && firstSource.width === 0 && firstSource.height === 0) {
	            assetType = 'audio';
	        }
	
	        _this.state = {
	            assetType: assetType,
	            userHasAccess: userHasAccess,
	            userIsLoaded: false,
	            noAds: false,
	            ready: false,
	
	            config: {
	                locale: locale,
	                vendor: vendor,
	                shareLink: shareLink,
	                plugins: plugins,
	                skin: skin,
	                playerUrl: playerUrl,
	                preroll: preroll,
	                bumper: bumper,
	                pageType: pageType,
	                publisher: publisher,
	                publisherGroup: publisherGroup,
	                countryCode: countryCode,
	                host: host,
	                antiAdblock: antiAdblock,
	                antiAdblockConfigUrl: antiAdblockConfigUrl,
	                pulse: pulse
	            },
	            videoTitle: videoTitle,
	            videoId: videoId,
	            tvCategory: tvCategory,
	            isAutoPlay: isAutoPlay
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(LazyLoadedVideo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                if (_this2.state.ready) {
	                    return;
	                }
	
	                _this2.setState({
	                    ready: true
	                });
	            }, VIDEO_ACCESS_TIMEOUT);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _nextProps$spid = nextProps.spid,
	                spid = _nextProps$spid === undefined ? {} : _nextProps$spid;
	            var ready = this.state.ready;
	
	
	            if (this.state.userIsLoaded === false && spid.userId && !this.loadingUser) {
	                this.loadingUser = true;
	                this.loadAccess(nextProps);
	            } else if (!ready && !spid.userId && typeof spid.login === 'function') {
	                // set to ready if not logged in
	                this.setState({
	                    ready: true
	                });
	            }
	        }
	    }, {
	        key: 'setUserConfigToVideo',
	        value: function setUserConfigToVideo(access) {
	            var noAds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            this.setState(function (_ref2) {
	                var userHasAccess = _ref2.userHasAccess;
	                return {
	                    userHasAccess: userHasAccess || access,
	                    userIsLoaded: true,
	                    noAds: noAds,
	                    ready: true
	                };
	            });
	
	            this.forceUpdate();
	        }
	    }, {
	        key: 'loadAccess',
	
	
	        /**
	         * check if access to VG+ products and whether to show ads or not
	         */
	        value: function loadAccess() {
	            var _this3 = this;
	
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	            var dispatch = props.dispatch;
	
	
	            dispatch(_reduxSpid.actions.hasAnyProduct(_config.config.spid.productIds)).then(function (spidResponse) {
	                var hasProduct = spidResponse && spidResponse.result;
	                if (hasProduct) {
	                    var _props$spid = _this3.props.spid,
	                        userId = _props$spid.userId,
	                        sig = _props$spid.sig;
	
	
	                    _this3.shouldNotShowAds(userId, sig).then(function (showNoAds) {
	                        return _this3.setUserConfigToVideo(hasProduct, showNoAds);
	                    });
	                } else {
	                    (0, _plussIpAccess2.default)().then(function (hasAccess) {
	                        return _this3.setUserConfigToVideo(hasAccess);
	                    });
	                }
	            }).catch(function (err) {
	                console.error(err); // eslint-disable-line
	                _this3.setState({
	                    ready: true
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                ready = _state.ready,
	                userHasAccess = _state.userHasAccess,
	                userIsLoaded = _state.userIsLoaded,
	                videoConfig = _state.config;
	            var _props = this.props,
	                videoAsset = _props.videoAsset,
	                device = _props.device,
	                subtype = _props.subtype,
	                spid = _props.spid,
	                rest = (0, _objectWithoutProperties3.default)(_props, ['videoAsset', 'device', 'subtype', 'spid']);
	
	
	            if (!ready) {
	                // render placeholder
	                return _react2.default.createElement('div', { style: { paddingBottom: '56.25%', backgroundColor: '#f1f1f1' } });
	            }
	
	            if (!userHasAccess) {
	                return _react2.default.createElement(_VideoPaywallOverlay2.default, {
	                    isTop: subtype === 'top',
	                    videoAsset: videoAsset,
	                    isLoggedIn: userIsLoaded,
	                    spid: spid,
	                    device: device
	                });
	            }
	
	            var inlineVideoMarkup = _react2.default.createElement(_inlineVideo2.default, (0, _extends3.default)({
	                getPlayerConfig: this.getPlayerConfig,
	                reduxPath: 'video',
	                videoAsset: this.props.videoAsset,
	                autoplayNext: true,
	                apiUrl: videoConfig.host,
	                videoPlayerUrl: videoConfig.playerUrl,
	                antiAdblock: videoConfig.antiAdblock,
	                antiAdblockConfigUrl: videoConfig.antiAdblockConfigUrl,
	                startMode: videoConfig.startMode
	            }, rest));
	
	            if (subtype === 'top') {
	                inlineVideoMarkup = _react2.default.createElement(
	                    'div',
	                    { className: 'top-video' },
	                    inlineVideoMarkup
	                );
	            }
	
	            return inlineVideoMarkup;
	        }
	    }]);
	    return LazyLoadedVideo;
	}(_react.Component), _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.getPlayerConfig = function (videoConfig) {
	        var _props$videoAsset$acc = _this4.props.videoAsset.access;
	        _props$videoAsset$acc = _props$videoAsset$acc === undefined ? {} : _props$videoAsset$acc;
	        var plus = _props$videoAsset$acc.plus;
	
	
	        var playerConfig = (0, _extends3.default)({}, videoConfig, {
	            locale: _this4.state.config.locale,
	            vendor: _this4.state.config.vendor,
	            title: _this4.state.videoTitle,
	            sharing: { link: _this4.state.config.shareLink + _this4.state.videoId },
	            plugins: _this4.state.config.plugins,
	            skin: _this4.state.config.skin,
	            adn: _this4.adn,
	            pulse: _this4.state.config.pulse
	        });
	
	        // audio asset
	        if (_this4.state.assetType === 'audio') {
	            (0, _assign2.default)(playerConfig, { height: 40, na: true });
	        }
	
	        if (plus === true) {
	            (0, _assign2.default)(playerConfig, { token: _this4.tokenPromiseFunc() });
	        }
	
	        return playerConfig;
	    };
	
	    this.getAdSlotsSchedule = function () {
	        var placementId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var categoryId = arguments[1];
	
	        var adformat = _this4.state.isAutoPlay ? 'bumper' : 'preroll';
	
	        return {
	            preroll: (0, _duplicateApnKeywords2.default)({
	                id: placementId,
	                'no-sno-adformat': adformat,
	                'no-sno-news-tv_category': categoryId,
	                'no-sno-publishergroup': _this4.state.config.publisherGroup
	            })
	        };
	    };
	
	    this.getAppnexusPlacementId = function (deviceType) {
	        var placements = _this4.state.isAutoPlay ? _this4.state.config.bumper : _this4.state.config.preroll;
	
	        if (!placements[deviceType]) {
	            throw new Error('Missing appnexus placement id for device type of ' + deviceType);
	        }
	
	        return placements[deviceType];
	    };
	
	    this.shouldNotShowAds = function (userId, sig) {
	        return (0, _getPersonalizedConfig2.default)('vg:hyperion', userId, sig).then(function (personalizedConfig) {
	            var _personalizedConfig$v = personalizedConfig.vgtvNoAds,
	                vgtvNoAds = _personalizedConfig$v === undefined ? 'false' : _personalizedConfig$v;
	
	
	            return vgtvNoAds === 'true';
	        });
	    };
	
	    this.tokenPromiseFunc = function () {
	        var tokenApiUrl = _config.config.video.tokenApiUrl;
	
	        return function (assetId) {
	            var url = tokenApiUrl + '/svp/token/' + assetId;
	
	            // eslint-disable-next-line
	            return (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status === 200) {
	                    return response.json();
	                }
	                return _promise2.default.reject();
	            }).catch(function () {
	                return _promise2.default.reject();
	            });
	        };
	    };
	
	    this.adn = function (currentVideoAsset) {
	        var _currentVideoAsset$id = currentVideoAsset.id,
	            currentVideoId = _currentVideoAsset$id === undefined ? _this4.state.videoId : _currentVideoAsset$id,
	            _currentVideoAsset$se = currentVideoAsset.section.id,
	            categoryId = _currentVideoAsset$se === undefined ? 0 : _currentVideoAsset$se;
	
	        var isFirstVideo = currentVideoId === _this4.state.videoId;
	
	        var shallSkipPreroll = _this4.state.isAutoPlay && isFirstVideo;
	        var deviceType = (0, _normalizeDevice2.default)(_this4.props.device);
	        var placementId = shallSkipPreroll ? null : _this4.getAppnexusPlacementId(deviceType);
	
	        /**
	         * Custom placement id for VG+ subscribers
	         * https://github.schibsted.io/vg/hyperion-vg/issues/1409
	         */
	        if (_this4.state.noAds) {
	            placementId = {
	                mobile: 14096833,
	                tablet: 14096832,
	                desktop: 14096831
	            }[deviceType];
	        }
	
	        var schedule = _this4.getAdSlotsSchedule(placementId, categoryId);
	
	        return _promise2.default.resolve({
	            adSlots: {
	                schedule: schedule,
	                params: (0, _duplicateApnKeywords2.default)({
	                    'aa-sch-country_code': _this4.state.config.countryCode,
	                    'aa-sch-supply_type': (0, _helpers.getSupplyType)(_this4.props.device),
	                    'aa-sch-publisher': _this4.state.config.publisher,
	                    'aa-sch-page_type': _this4.state.config.pageType
	                })
	            }
	        });
	    };
	}, _temp);
	
	
	var enhance = (0, _reactRedux.connect)(function (state) {
	    return {
	        device: state.device,
	        spid: state.spid
	    };
	});
	
	exports.default = enhance(LazyLoadedVideo);

/***/ },

/***/ 791:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapMapbox = __webpack_require__(733);
	
	var _mapMapbox2 = _interopRequireDefault(_mapMapbox);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapMapbox = function MapMapbox(props) {
	  return _react2.default.createElement(_mapMapbox2.default, (0, _extends3.default)({}, props, { accessToken: _config.config.mapboxAccessToken }));
	};
	
	exports.default = MapMapbox;

/***/ },

/***/ 792:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	/* eslint-disable */
	// to prevent jsx-a11y/anchor-has-content error
	var NtDisclaimer = function NtDisclaimer(_ref) {
	    var theme = _ref.theme,
	        _ref$content = _ref.content,
	        heading = _ref$content.heading,
	        text = _ref$content.text;
	    return _react2.default.createElement(
	        'div',
	        { className: theme['nt-disclaimer'] },
	        _react2.default.createElement('a', { className: 'anchor', id: 'commercial-disclaimer' }),
	        _react2.default.createElement(
	            'p',
	            null,
	            heading
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            text
	        )
	    );
	};
	/* eslint-enable */
	
	NtDisclaimer.propTypes = {
	    content: _propTypes2.default.shape({
	        heading: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    }),
	    theme: _propTypes2.default.shape({
	        url: _propTypes2.default.string
	    })
	};
	
	NtDisclaimer.defaultProps = {
	    content: {
	        heading: '',
	        text: ''
	    },
	    theme: {}
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/ui-nt-disclaimer')(NtDisclaimer);

/***/ },

/***/ 793:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* global AutoTrack */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(25);
	
	var _salesposter = __webpack_require__(741);
	
	var _salesposter2 = _interopRequireDefault(_salesposter);
	
	var _config = __webpack_require__(38);
	
	var _adblockDetect = __webpack_require__(835);
	
	var _adblockDetect2 = _interopRequireDefault(_adblockDetect);
	
	var _default = __webpack_require__(341);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _subscriptionHelper = __webpack_require__(849);
	
	var _fetchTimeout = __webpack_require__(837);
	
	var _fetchTimeout2 = _interopRequireDefault(_fetchTimeout);
	
	var _queryParser = __webpack_require__(847);
	
	var _queryParser2 = _interopRequireDefault(_queryParser);
	
	var _paywallType = __webpack_require__(804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APP_TARGET = 'app';
	var WEB_TARGET = 'web';
	var WEB_FALLBACK_TARGET = 'web-fallback';
	var USE_HYPERION_POSTER = new RegExp('^(' + APP_TARGET + '|' + WEB_FALLBACK_TARGET + ')$');
	var SALEPOSTER_ID = 'salesposter_iframe';
	
	// spid has completed when userId && sig is set, or error (no spid session)
	var spidCompleted = function spidCompleted(_ref) {
	    var sig = _ref.sig,
	        userId = _ref.userId,
	        error = _ref.error;
	    return userId && sig || error;
	};
	
	// client side feature toggling
	var featureToggle = function featureToggle(_ref2) {
	    var feature = _ref2.feature,
	        enableThreshold = _ref2.enableThreshold;
	
	    var threshold = enableThreshold;
	    var query = (0, _queryParser2.default)(window.location);
	    var p = parseFloat(query[feature]);
	
	    if (!isNaN(p) && p >= 0) {
	        threshold = p;
	    }
	
	    return Math.random() > 1 - threshold;
	};
	
	var Salesposter = (_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Salesposter, _Component);
	
	    function Salesposter(props) {
	        (0, _classCallCheck3.default)(this, Salesposter);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Salesposter.__proto__ || (0, _getPrototypeOf2.default)(Salesposter)).call(this, props));
	
	        var _config$salesposter = _config.config.salesposter;
	        _config$salesposter = _config$salesposter === undefined ? {} : _config$salesposter;
	        var _config$salesposter$p = _config$salesposter.products,
	            products = _config$salesposter$p === undefined ? [] : _config$salesposter$p;
	
	
	        _this.state = {
	            target: WEB_TARGET,
	            products: products
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Salesposter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var device = this.props.device;
	            var _window = window,
	                location = _window.location;
	            var _config$salesposter2 = _config.config.salesposter;
	            _config$salesposter2 = _config$salesposter2 === undefined ? {} : _config$salesposter2;
	            var _config$salesposter2$ = _config$salesposter2.products,
	                products = _config$salesposter2$ === undefined ? [] : _config$salesposter2$,
	                _config$salesposter2$2 = _config$salesposter2.paywallApi;
	            _config$salesposter2$2 = _config$salesposter2$2 === undefined ? {} : _config$salesposter2$2;
	            var _config$salesposter2$3 = _config$salesposter2$2.enableThreshold,
	                enableThreshold = _config$salesposter2$3 === undefined ? 0 : _config$salesposter2$3;
	
	
	            this.articleUrl = location.protocol + '//' + location.host + location.pathname;
	
	            var isAppWithPurchase = device.indexOf(APP_TARGET) > -1 && (0, _subscriptionHelper.isInAppPurchaseEnabled)();
	            (0, _adblockDetect2.default)(function (err) {
	                if (err) {
	                    _this2.adblocked = true;
	                }
	            });
	
	            if (isAppWithPurchase) {
	                this.appProducts();
	            } else {
	                var target = featureToggle({ feature: 'saleposter', enableThreshold: enableThreshold }) ? WEB_TARGET : WEB_FALLBACK_TARGET;
	                this.setState({ target: target, products: products }); // eslint-disable-line react/no-did-mount-set-state
	
	                // Fallback if poster is not loaded
	                if (!USE_HYPERION_POSTER.test(this.state.target)) {
	                    setTimeout(function () {
	                        if (!_this2.loadingPaywall) {
	                            _this2.setState({ target: 'web-fallback' });
	                        }
	                    }, 2000);
	                }
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _nextProps$spid = nextProps.spid,
	                userId = _nextProps$spid.userId,
	                sig = _nextProps$spid.sig,
	                error = _nextProps$spid.error,
	                loadedTrackers = nextProps.loadedTrackers;
	
	
	            if (!USE_HYPERION_POSTER.test(this.state.target) && spidCompleted({ sig: sig, userId: userId, error: error }) && (loadedTrackers.engage || this.adblocked) && !this.loadingPaywall) {
	                this.loadingPaywall = true;
	
	                this.webProducts(nextProps);
	            }
	        }
	    }, {
	        key: 'appProducts',
	        value: function appProducts() {
	            var _this3 = this;
	
	            return this.setState({
	                target: APP_TARGET,
	                products: (0, _subscriptionHelper.getAppProducts)()
	            }, function () {
	                return _this3.props.dispatch((0, _paywallType.paywallTypeAction)('iap'));
	            });
	        }
	    }, {
	        key: 'webProducts',
	        value: function () {
	            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(props) {
	                var _config$salesposter3, _config$salesposter3$, products, _config$salesposter3$2, endpoint, timeout, _props$spid, getLoginUrl, userId, sig, baseUrl, iframeId, pageViewId, environmentId, loginUri, params, url, res, _ref4, html, doc;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                // Experimental personalised paywall. Implemenation details:
	                                // https://docs.google.com/presentation/d/1DWtXHbuHzsy5WMI2maLE0ES8ZuOAV2qEiloAQX6fepc/edit?usp=sharing
	
	                                _config$salesposter3 = _config.config.salesposter;
	                                _config$salesposter3 = _config$salesposter3 === undefined ? {} : _config$salesposter3;
	                                _config$salesposter3$ = _config$salesposter3.products, products = _config$salesposter3$ === undefined ? [] : _config$salesposter3$, _config$salesposter3$2 = _config$salesposter3.paywallApi, endpoint = _config$salesposter3$2.endpoint, timeout = _config$salesposter3$2.timeout;
	                                _props$spid = props.spid, getLoginUrl = _props$spid.getLoginUrl, userId = _props$spid.userId, sig = _props$spid.sig;
	                                baseUrl = this.buyUrlTemplate().replace('{{PRODUCT_ID}}{{CAMPAIGN_ID}}', '');
	                                iframeId = SALEPOSTER_ID;
	                                pageViewId = this.adblocked || !window.AutoTrack ? 'pageViewId' : AutoTrack.getPageViewId();
	                                environmentId = this.adblocked || !window.AutoTrack ? 'environmentId' : AutoTrack.activity().envId;
	                                loginUri = getLoginUrl();
	                                _context.prev = 9;
	                                params = ['pageViewId=' + pageViewId, 'environmentId=' + environmentId, 'iframeId=' + iframeId, 'baseUrl=' + encodeURIComponent(baseUrl), 'loginUri=' + encodeURIComponent(loginUri)].join('&');
	                                url = endpoint + '?' + params;
	                                _context.next = 14;
	                                return (0, _fetchTimeout2.default)(url, {
	                                    headers: {
	                                        'x-spid-sig': sig,
	                                        'x-spid-user': userId
	                                    },
	                                    mode: 'cors',
	                                    timeout: timeout
	                                });
	
	                            case 14:
	                                res = _context.sent;
	                                _context.next = 17;
	                                return res.json();
	
	                            case 17:
	                                _ref4 = _context.sent;
	                                html = _ref4.html;
	                                doc = this.iframe.contentDocument;
	                                // hack: adjust name to set target from links inside iframe.
	
	                                window.name = 'top';
	                                doc.open();
	                                doc.writeln(html);
	                                doc.close();
	                                _context.next = 29;
	                                break;
	
	                            case 26:
	                                _context.prev = 26;
	                                _context.t0 = _context['catch'](9);
	
	                                this.setState({
	                                    target: 'web-fallback',
	                                    products: products
	                                });
	
	                            case 29:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[9, 26]]);
	            }));
	
	            function webProducts(_x) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return webProducts;
	        }()
	    }, {
	        key: 'buildUtmParams',
	        value: function buildUtmParams() {
	            var _this4 = this;
	
	            var utm = this.props.utm;
	
	
	            return (0, _keys2.default)(utm).map(function (param) {
	                return 'utm_' + param + '=' + _this4.props.utm[param];
	            }).join('&');
	        }
	    }, {
	        key: 'buyUrlTemplate',
	        value: function buyUrlTemplate() {
	            var articleId = this.props.articleId;
	            var _config$spid = _config.config.spid;
	            _config$spid = _config$spid === undefined ? {} : _config$spid;
	            var spidUrl = _config$spid.server,
	                clientId = _config$spid.clientId;
	
	
	            var utmParams = this.buildUtmParams();
	            var utmFragment = utmParams ? '&' + utmParams : '';
	
	            // Temporary fix for including utm params as part of tag
	            var tagUtmParams = utmFragment.replace(/&/g, '_').replace(/utm_/g, '').replace(/=/g, '-');
	
	            var urlTemplate = this.state.target === APP_TARGET ? 'vg.no:///buy?articleUrl=' + encodeURIComponent(this.articleUrl) + '{{APP_PRODUCT_ID}}' : 'https://' + spidUrl + '/flow/checkout?response_type=code&flow=payment&client_id=' + clientId + ('&redirect_uri=' + encodeURIComponent(this.articleUrl) + '&tag=' + articleId + tagUtmParams + '{{PRODUCT_ID}}{{CAMPAIGN_ID}}');
	
	            return '' + urlTemplate + utmFragment;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _config$salesposter4 = _config.config.salesposter;
	            _config$salesposter4 = _config$salesposter4 === undefined ? {} : _config$salesposter4;
	            var _config$salesposter4$ = _config$salesposter4.header,
	                header = _config$salesposter4$ === undefined ? {} : _config$salesposter4$,
	                _config$salesposter4$2 = _config$salesposter4.campaignName,
	                campaignName = _config$salesposter4$2 === undefined ? '' : _config$salesposter4$2,
	                _config$salesposter4$3 = _config$salesposter4.salespitch,
	                salespitch = _config$salesposter4$3 === undefined ? '' : _config$salesposter4$3,
	                _config$salesposter4$4 = _config$salesposter4.salespitchContent,
	                salespitchContent = _config$salesposter4$4 === undefined ? '' : _config$salesposter4$4;
	
	            var login = !this.props.spid.loggedIn ? this.props.spid.login : null;
	
	            if (USE_HYPERION_POSTER.test(this.state.target)) {
	                return _react2.default.createElement(_salesposter2.default, {
	                    target: this.state.target,
	                    spidLogin: login,
	                    products: (0, _subscriptionHelper.addPaymentUrl)(this.state.products, this.buyUrlTemplate()),
	                    header: (0, _subscriptionHelper.getHeaderConfig)(header, this.buyUrlTemplate()),
	                    campaignName: campaignName,
	                    salespitch: salespitch,
	                    salespitchContent: salespitchContent
	                });
	            }
	            // target === web, title added for accessibility
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: _default2.default.paywallTextFading }),
	                _react2.default.createElement('iframe', {
	                    id: SALEPOSTER_ID,
	                    title: 'Kj\xF8p tilgang til VG pluss',
	                    frameBorder: '0',
	                    scrolling: 'no',
	                    width: '100%',
	                    ref: function ref(iframe) {
	                        _this5.iframe = iframe;
	                    }
	                })
	            );
	        }
	    }]);
	    return Salesposter;
	}(_react.Component), _class.propTypes = {
	    articleId: _propTypes2.default.string.isRequired,
	    device: _propTypes2.default.string.isRequired,
	    dispatch: _propTypes2.default.func.isRequired,
	    spid: _propTypes2.default.shape({
	        loggedIn: _propTypes2.default.bool,
	        login: _propTypes2.default.func,
	        userId: _propTypes2.default.number,
	        sig: _propTypes2.default.string
	    }),
	    loadedTrackers: _propTypes2.default.shape({
	        engage: _propTypes2.default.bool
	    }),
	    utm: _propTypes2.default.shape({
	        content: _propTypes2.default.string,
	        source: _propTypes2.default.string,
	        medium: _propTypes2.default.string,
	        term: _propTypes2.default.string,
	        campaign: _propTypes2.default.string
	    }).isRequired
	}, _class.defaultProps = {
	    spid: {
	        loggedIn: false,
	        login: null,
	        userId: null,
	        sig: null
	    },
	    loadedTrackers: {
	        engage: false
	    }
	}, _temp);
	
	
	var enhance = (0, _reactRedux.connect)(function (state) {
	    return {
	        articleId: state.article.id,
	        device: state.device,
	        spid: state.spid,
	        utm: state.utmParams,
	        loadedTrackers: state.loadedTrackers
	    };
	});
	
	exports.default = enhance(Salesposter);

/***/ },

/***/ 794:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uiStreamer = __webpack_require__(672);
	
	var _uiStreamer2 = _interopRequireDefault(_uiStreamer);
	
	var _plussIndicator = __webpack_require__(1017);
	
	var _plussIndicator2 = _interopRequireDefault(_plussIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Streamer = function Streamer(props) {
	    var _props$subtype = props.subtype,
	        subtype = _props$subtype === undefined ? '' : _props$subtype;
	
	
	    if (subtype === 'pluss-indicator') {
	        return _react2.default.createElement(
	            'a',
	            { href: 'https://www.vg.no/pluss' },
	            _react2.default.createElement(_uiStreamer2.default, (0, _extends3.default)({ theme: _plussIndicator2.default }, props))
	        );
	    }
	
	    return null;
	};
	
	Streamer.defaultProps = {
	    subtype: ''
	};
	
	Streamer.propTypes = {
	    subtype: _propTypes2.default.string
	};
	
	exports.default = Streamer;

/***/ },

/***/ 795:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tags = __webpack_require__(743);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(props) {
	    return _react2.default.createElement(_tags2.default, (0, _extends3.default)({}, props, {
	        listHeading: _config.config.tags.listHeading,
	        listAriaHeading: _config.config.tags.listAriaHeading
	    }));
	};
	
	exports.default = Tags;

/***/ },

/***/ 796:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uiImage = __webpack_require__(71);
	
	var _moment = __webpack_require__(233);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assembleQueryParams = function assembleQueryParams(params) {
	    return (0, _keys2.default)(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');
	};
	
	var Teaser = function Teaser(_ref) {
	    var _classNames;
	
	    var article = _ref.article,
	        fullWidthDesktop = _ref.fullWidthDesktop,
	        fullWidthMobile = _ref.fullWidthMobile,
	        theme = _ref.theme,
	        utmParams = _ref.utmParams;
	    var _article$changes = article.changes;
	    _article$changes = _article$changes === undefined ? '' : _article$changes;
	    var articlePublished = _article$changes.published,
	        _article$links = article.links;
	    _article$links = _article$links === undefined ? '' : _article$links;
	    var articleLink = _article$links.canonicalUrl,
	        _article$promotionCon = article.promotionContent,
	        _article$promotionCon2 = _article$promotionCon.imageAsset;
	    _article$promotionCon2 = _article$promotionCon2 === undefined ? [] : _article$promotionCon2;
	    var imageUrls = _article$promotionCon2.urls,
	        _article$promotionCon3 = _article$promotionCon.title;
	    _article$promotionCon3 = _article$promotionCon3 === undefined ? '' : _article$promotionCon3;
	    var articleTitle = _article$promotionCon3.value,
	        _article$customProper = article.customProperties;
	    _article$customProper = _article$customProper === undefined ? {} : _article$customProper;
	    var _article$customProper2 = _article$customProper.vg_paywall,
	        isPaywall = _article$customProper2 === undefined ? false : _article$customProper2;
	
	
	    var containerWidthPx = 980;
	    var mobileImageWidth = fullWidthMobile ? '100vw' : '30vw';
	    var desktopImageWidthPx = fullWidthDesktop ? containerWidthPx : Math.round(containerWidthPx / 3);
	    var imageAsset = imageUrls ? _react2.default.createElement(_uiImage.ImageAsset, {
	        urls: imageUrls,
	        sizes: '(max-width: 980px) ' + mobileImageWidth + ', ' + desktopImageWidthPx + 'px',
	        testTag: '@spp/ui-article-list:image-asset'
	    }) : null;
	    var indicator = isPaywall && imageAsset !== null ? _react2.default.createElement('div', { className: theme.plussIndicator }) : null;
	
	    var publishedDate = (0, _moment2.default)(articlePublished).format('DD.MM.YY');
	
	    var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.articleCard, true), (0, _defineProperty3.default)(_classNames, theme.fullWidthDesktop, fullWidthDesktop), (0, _defineProperty3.default)(_classNames, theme.fullWidthMobile, fullWidthMobile), _classNames));
	
	    var href = articleLink;
	    if (utmParams) {
	        href += (href.indexOf('?') === -1 ? '?' : '&') + assembleQueryParams(utmParams);
	    }
	
	    return _react2.default.createElement(
	        'a',
	        { href: href, className: className },
	        _react2.default.createElement(
	            'article',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: theme.imageWrapper },
	                imageAsset,
	                indicator
	            ),
	            _react2.default.createElement(
	                'h2',
	                null,
	                articleTitle
	            ),
	            _react2.default.createElement(
	                'time',
	                null,
	                publishedDate
	            )
	        )
	    );
	};
	
	Teaser.propTypes = {
	    article: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	    theme: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	    utmParams: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	    fullWidthDesktop: _propTypes2.default.bool, // eslint-disable-line react/forbid-prop-types
	    fullWidthMobile: _propTypes2.default.bool // eslint-disable-line react/forbid-prop-types
	};
	
	Teaser.defaultProps = {
	    article: {},
	    theme: {},
	    fullWidthDesktop: false,
	    fullWidthMobile: false
	};
	
	exports.default = Teaser;

/***/ },

/***/ 797:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _adComponents = __webpack_require__(114);
	
	var _config = __webpack_require__(183);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var TextAd = function TextAd(_ref) {
	    var device = _ref.device,
	        variants = _ref.variants,
	        rest = (0, _objectWithoutProperties3.default)(_ref, ['device', 'variants']);
	
	    var format = variants[0].invCode.split(/_(.+)/)[1];
	    var platform = device.indexOf('mobile') > -1 ? 'mobile' : 'desktop';
	
	    if (_config2.default[platform].includes(format)) {
	        return _react2.default.createElement(_adComponents.Ad, (0, _extends3.default)({ variants: variants, subtype: 'text-ad' }, rest));
	    }
	
	    return null;
	};
	
	var enhance = (0, _reactRedux.connect)(function (state) {
	    return {
	        device: state.device
	    };
	});
	
	exports.default = enhance(TextAd);

/***/ },

/***/ 798:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/forbid-prop-types */
	var VgGoldCompetition = function VgGoldCompetition(_ref) {
	    var codes = _ref.codes,
	        theme = _ref.theme;
	
	    var date = new Date();
	    var key = date.getDate() + '/' + (date.getMonth() + 1);
	    var promocode = codes[key];
	    if (!promocode) {
	        return null;
	    }
	    return _react2.default.createElement(
	        'div',
	        { className: theme.root, rel: 'noindex' },
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Vinn Gull i VG+'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: theme.promoCode },
	            'Dagens kode: ',
	            _react2.default.createElement(
	                'strong',
	                null,
	                promocode
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: theme.instructions },
	            'Send SMS med koden til 2424. Tjenesten koster 1 kr.'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: theme.disclaimer },
	            'Ved \xE5 delta i konkurransen samtykker du til at vi kan kontakte deg p\xE5 SMS med relevant informasjon om konkurransen \xABFinn Gull i VG\xBB.',
	            ' ',
	            _react2.default.createElement(
	                'a',
	                { href: 'https://gull.vg.no' },
	                'Les mer om konkurransen her \xBB'
	            )
	        )
	    );
	};
	
	VgGoldCompetition.propTypes = {
	    codes: _react.PropTypes.any.isRequired,
	    theme: _react.PropTypes.shape({
	        root: _react.PropTypes.string,
	        url: _react.PropTypes.string
	    }).isRequired
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/gold-competition')(VgGoldCompetition);

/***/ },

/***/ 799:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(13);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactRedux = __webpack_require__(25);
	
	var _redux = __webpack_require__(89);
	
	__webpack_require__(62);
	
	var _themeProvider = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types, jsx-a11y/href-no-hash, react/sort-comp */
	var VideoPaywallOverlay = function (_Component) {
	    (0, _inherits3.default)(VideoPaywallOverlay, _Component);
	
	    function VideoPaywallOverlay(props) {
	        (0, _classCallCheck3.default)(this, VideoPaywallOverlay);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (VideoPaywallOverlay.__proto__ || (0, _getPrototypeOf2.default)(VideoPaywallOverlay)).call(this, props));
	
	        _this.state = {
	            additionalAttributes: {}
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(VideoPaywallOverlay, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.assetAttirbutes();
	        }
	    }, {
	        key: 'assetAttirbutes',
	        value: function assetAttirbutes() {
	            var _this2 = this;
	
	            var videoAsset = this.props.videoAsset;
	
	            var url = 'https://svp.vg.no/svp/api/v1/vgtv/assets/' + videoAsset.id + '?appName=svp-player';
	
	            // eslint-disable-next-line
	            fetch(url).then(function (response) {
	                if (response.status === 200) {
	                    return response.json();
	                }
	                return _promise2.default.reject({});
	            }).then(function (json) {
	                _this2.setState({ additionalAttributes: json });
	            });
	        }
	    }, {
	        key: 'getBuyUrl',
	        value: function getBuyUrl() {
	            var _props = this.props,
	                videoAsset = _props.videoAsset,
	                articleId = _props.articleId;
	
	
	            var params = ['utm_source=vgtv-embed', 'utm_content=' + videoAsset.id, 'utm_medium=' + articleId];
	
	            return 'https://www.vg.no/nyheter/i/jPJ5g9/vg?' + params.join('&');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.additionalAttributes.id === undefined) {
	                return null;
	            }
	            // by default video asset doesn't have attribute with images
	            // thus need to fetch those
	            var main = this.state.additionalAttributes.images.main;
	
	            var transformedImage = main + '?t[]=1280x720';
	            var _props2 = this.props,
	                spid = _props2.spid,
	                isTop = _props2.isTop,
	                theme = _props2.theme;
	
	
	            var loginButton = void 0;
	            if (spid.login && !spid.userId) {
	                loginButton = _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: spid.login },
	                    'logg inn'
	                );
	            }
	
	            var className = (0, _classnames3.default)(theme['video-paywall-overlay'], (0, _defineProperty3.default)({}, theme.top, isTop));
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'background-wrapper',
	                        style: { backgroundImage: 'url("' + transformedImage + '")' }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: theme['play-button'] },
	                            _react2.default.createElement('div', null)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: theme['info-message'] },
	                            'For \xE5 se filmen m\xE5 du v\xE6re VG+ abonnent.',
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: this.getBuyUrl() },
	                                'Kj\xF8p VG+'
	                            ),
	                            loginButton ? ' eller ' : undefined,
	                            loginButton,
	                            '.'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return VideoPaywallOverlay;
	}(_react.Component);
	
	var enhance = (0, _redux.compose)((0, _themeProvider.themer)('@vg/ui-video-paywall-overlay'), (0, _reactRedux.connect)(function (_ref) {
	    var article = _ref.article;
	    return {
	        articleId: article.id
	    };
	}));
	
	exports.default = enhance(VideoPaywallOverlay);

/***/ },

/***/ 800:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addCollectionArticlesAction = exports.fetchCollectionArticlesAction = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _universalConfig = __webpack_require__(22);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var fetchCollectionArticlesAction = exports.fetchCollectionArticlesAction = function fetchCollectionArticlesAction(_ref) {
	    var _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force,
	        _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? 0 : _ref$offset,
	        _ref$section = _ref.section,
	        section = _ref$section === undefined ? '' : _ref$section,
	        _ref$excludedSections = _ref.excludedSections,
	        excludedSections = _ref$excludedSections === undefined ? '' : _ref$excludedSections,
	        _ref$tag = _ref.tag,
	        tag = _ref$tag === undefined ? '' : _ref$tag,
	        _ref$story = _ref.story,
	        story = _ref$story === undefined ? '' : _ref$story;
	    var host = _universalConfig.appConfig.iris.host;
	
	    var endpoint = '' + host + _universalConfig.appConfig.iris.teasers + '?offset=' + offset + '&limit=21&section=' + section + '&excludedSections=' + excludedSections + '&tag=' + tag + '&story=' + story;
	
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.COLLECTION_ARTICLES_REQUEST, _types.COLLECTION_ARTICLES_SUCCESS, _types.COLLECTION_ARTICLES_FAILURE],
	        bailout: function bailout(state) {
	            return !force && !!state.collectionArticles.collection.length;
	        }
	    });
	};
	/* eslint-enable import/prefer-default-export */
	
	/* eslint-disable import/prefer-default-export */
	var addCollectionArticlesAction = exports.addCollectionArticlesAction = function addCollectionArticlesAction(_ref3) {
	    var _ref3$offset = _ref3.offset,
	        offset = _ref3$offset === undefined ? 0 : _ref3$offset,
	        _ref3$section = _ref3.section,
	        section = _ref3$section === undefined ? '' : _ref3$section,
	        _ref3$excludedSection = _ref3.excludedSections,
	        excludedSections = _ref3$excludedSection === undefined ? '' : _ref3$excludedSection,
	        _ref3$tag = _ref3.tag,
	        tag = _ref3$tag === undefined ? '' : _ref3$tag,
	        _ref3$story = _ref3.story,
	        story = _ref3$story === undefined ? '' : _ref3$story;
	    var host = _universalConfig.appConfig.iris.host;
	
	    var endpoint = '' + host + _universalConfig.appConfig.iris.teasers + '?offset=' + offset + '&limit=21&section=' + section + '&excludedSections=' + excludedSections + '&tag=' + tag + '&story=' + story;
	
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.COLLECTION_ARTICLES_REQUEST, _types.COLLECTION_ARTICLES_ADD, _types.COLLECTION_ARTICLES_FAILURE]
	    });
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 801:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCouponCodesAction = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var fetchCouponCodesAction = exports.fetchCouponCodesAction = function fetchCouponCodesAction(_ref) {
	    var endpoint = _ref.endpoint,
	        _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force;
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.COUPON_CODES_REQUEST, {
	            type: _types.COUPON_CODES_SUCCESS,
	            payload: function payload(action, state, res) {
	                return res.json();
	            }
	        }, _types.COUPON_CODES_FAILURE],
	        bailout: function bailout(state) {
	            return !force && !!state.couponCodes.items.length;
	        }
	    });
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 802:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.default = getTagByTitle;
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _universalConfig = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTagByTitle(_ref) {
	    var _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force,
	        title = _ref.title;
	    var host = _universalConfig.appConfig.iris.host;
	
	
	    var endpoint = host + '/v1/tagLookup?title=' + title;
	
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: ['GET_TAG_BY_TITLE_REQUEST', 'GET_TAG_BY_TITLE_SUCCESS', 'GET_TAG_BY_TITLE_FAILURE'],
	        bailout: function bailout() {
	            return !force;
	        }
	    });
	}

/***/ },

/***/ 803:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchLatestArticlesAction = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var fetchLatestArticlesAction = exports.fetchLatestArticlesAction = function fetchLatestArticlesAction(_ref) {
	    var endpoint = _ref.endpoint,
	        _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force;
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.LATEST_ARTICLES_REQUEST, _types.LATEST_ARTICLES_SUCCESS, _types.LATEST_ARTICLES_FAILURE],
	        bailout: function bailout(state) {
	            return !force && !!state.latestArticles.length;
	        }
	    });
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 804:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.paywallTypeAction = undefined;
	
	var _types = __webpack_require__(28);
	
	/* eslint-disable import/prefer-default-export */
	var paywallTypeAction = exports.paywallTypeAction = function paywallTypeAction(paywallType) {
	    return {
	        type: _types.PAYWALL_TYPE,
	        payload: paywallType
	    };
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 805:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addPlussArticlesAction = exports.fetchPlussArticlesAction = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _universalConfig = __webpack_require__(22);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var fetchPlussArticlesAction = exports.fetchPlussArticlesAction = function fetchPlussArticlesAction(_ref) {
	    var _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force,
	        _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? 0 : _ref$offset,
	        _ref$section = _ref.section,
	        section = _ref$section === undefined ? '' : _ref$section,
	        _ref$excludedSections = _ref.excludedSections,
	        excludedSections = _ref$excludedSections === undefined ? '' : _ref$excludedSections;
	    var host = _universalConfig.appConfig.iris.host;
	
	    var endpoint = '' + host + _universalConfig.appConfig.iris.teasers + '?paywall=true&offset=' + offset + '&limit=21&section=' + section + '&excludedSections=' + excludedSections;
	
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.PLUSS_ARTICLES_REQUEST, _types.PLUSS_ARTICLES_SUCCESS, _types.PLUSS_ARTICLES_FAILURE],
	        bailout: function bailout(state) {
	            return !force && !!state.plussArticles.pluss.length;
	        }
	    });
	};
	/* eslint-enable import/prefer-default-export */
	
	/* eslint-disable import/prefer-default-export */
	var addPlussArticlesAction = exports.addPlussArticlesAction = function addPlussArticlesAction(_ref3) {
	    var _ref3$offset = _ref3.offset,
	        offset = _ref3$offset === undefined ? 0 : _ref3$offset,
	        _ref3$section = _ref3.section,
	        section = _ref3$section === undefined ? '' : _ref3$section,
	        _ref3$excludedSection = _ref3.excludedSections,
	        excludedSections = _ref3$excludedSection === undefined ? '' : _ref3$excludedSection;
	    var host = _universalConfig.appConfig.iris.host;
	
	    var endpoint = '' + host + _universalConfig.appConfig.iris.teasers + '?paywall=true&offset=' + offset + '&limit=21&section=' + section + '&excludedSections=' + excludedSections;
	
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.PLUSS_ARTICLES_REQUEST, _types.PLUSS_ARTICLES_ADD, _types.PLUSS_ARTICLES_FAILURE]
	    });
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 806:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchRecirculationListAction = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var fetchRecirculationListAction = exports.fetchRecirculationListAction = function fetchRecirculationListAction(_ref) {
	    var endpoint = _ref.endpoint,
	        _ref$force = _ref.force,
	        force = _ref$force === undefined ? false : _ref$force;
	    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: endpoint,
	        method: 'GET',
	        types: [_types.RECIRCULATION_REQUEST, _types.RECIRCULATION_SUCCESS, _types.RECIRCULATION_FAILURE],
	        bailout: function bailout(state) {
	            return !force && !!state.recirculation.items.length;
	        }
	    });
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 807:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.utmParamsAction = undefined;
	
	var _types = __webpack_require__(28);
	
	/* eslint-disable import/prefer-default-export */
	var utmParamsAction = exports.utmParamsAction = function utmParamsAction(utmTags) {
	    return {
	        type: _types.UTM_PARAMS,
	        payload: utmTags
	    };
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 808:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxApiMiddleware = __webpack_require__(44);
	
	var _reduxSpid = __webpack_require__(69);
	
	var _uiCoreNavigation = __webpack_require__(118);
	
	var _clientTrackers = __webpack_require__(831);
	
	var _clientTrackers2 = _interopRequireDefault(_clientTrackers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return [_reduxApiMiddleware.apiMiddleware, _reduxSpid.middleware, _clientTrackers2.default.middleware, _uiCoreNavigation.middlewares.coreNavigationUI];
	};

/***/ },

/***/ 809:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deviceReducer = undefined;
	
	var _types = __webpack_require__(28);
	
	var defaultState = 'mobile';
	
	/* eslint-disable import/prefer-default-export */
	var deviceReducer = exports.deviceReducer = function deviceReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    if (action.type === _types.SWITCH_DEVICE) {
	        return action.payload;
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 810:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCollectionArticlesReducer = undefined;
	
	var _toConsumableArray2 = __webpack_require__(50);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultCollectionArticlesState = function defaultCollectionArticlesState() {
	    return {
	        collection: [],
	        meta: {},
	        clientPlacedAds: [],
	        error: false
	    };
	};
	
	/* eslint-disable import/prefer-default-export */
	var fetchCollectionArticlesReducer = exports.fetchCollectionArticlesReducer = function fetchCollectionArticlesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCollectionArticlesState();
	    var action = arguments[1];
	
	    if (action.type === _types.COLLECTION_ARTICLES_SUCCESS) {
	        var payload = action.payload;
	
	
	        return (0, _extends3.default)({}, state, {
	            collection: payload.articles.filter(function (article) {
	                return !article.error;
	            }),
	            meta: payload.meta,
	            clientPlacedAds: payload.clientPlacedAds
	        });
	    }
	
	    if (action.type === _types.COLLECTION_ARTICLES_ADD) {
	        return (0, _extends3.default)({}, state, {
	            collection: [].concat((0, _toConsumableArray3.default)(state.collection)).concat([].concat((0, _toConsumableArray3.default)(action.payload.articles.filter(function (article) {
	                return !article.error;
	            }))))
	        });
	    }
	
	    if (action.type === _types.COLLECTION_ARTICLES_FAILURE) {
	        return (0, _extends3.default)({}, state, action.payload, {
	            error: true
	        });
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 811:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCouponCodesReducer = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultCouponCodesState = function defaultCouponCodesState() {
	    return {
	        items: [],
	        error: false
	    };
	};
	
	/* eslint-disable import/prefer-default-export */
	var fetchCouponCodesReducer = exports.fetchCouponCodesReducer = function fetchCouponCodesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCouponCodesState();
	    var action = arguments[1];
	
	    if (action.type === _types.COUPON_CODES_SUCCESS) {
	        var defaultItems = action.payload.default;
	
	
	        return (0, _extends3.default)({}, state, {
	            items: defaultItems
	        });
	    }
	
	    if (action.type === _types.COUPON_CODES_FAILURE) {
	        return (0, _extends3.default)({}, state, action.payload, {
	            error: true
	        });
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 812:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchLatestArticlesReducer = undefined;
	
	var _toConsumableArray2 = __webpack_require__(50);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultLatestArticlesState = function defaultLatestArticlesState() {
	    return {
	        latest: [],
	        error: false
	    };
	};
	
	/* eslint-disable import/prefer-default-export */
	var fetchLatestArticlesReducer = exports.fetchLatestArticlesReducer = function fetchLatestArticlesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultLatestArticlesState();
	    var action = arguments[1];
	
	    if (action.type === _types.LATEST_ARTICLES_SUCCESS) {
	        return (0, _extends3.default)({}, state, {
	            latest: [].concat((0, _toConsumableArray3.default)(action.payload))
	        });
	    }
	
	    if (action.type === _types.LATEST_ARTICLES_FAILURE) {
	        return (0, _extends3.default)({}, state, action.payload, {
	            error: true
	        });
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 813:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.paywallTypeReducer = undefined;
	
	var _types = __webpack_require__(28);
	
	var defaultState = 'spid';
	
	/* eslint-disable import/prefer-default-export */
	var paywallTypeReducer = exports.paywallTypeReducer = function paywallTypeReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    if (action.type === _types.PAYWALL_TYPE) {
	        return action.payload;
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 814:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPlussArticlesReducer = undefined;
	
	var _toConsumableArray2 = __webpack_require__(50);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultPlussArticlesState = function defaultPlussArticlesState() {
	    return {
	        pluss: [],
	        meta: {},
	        error: false
	    };
	};
	
	/* eslint-disable import/prefer-default-export */
	var fetchPlussArticlesReducer = exports.fetchPlussArticlesReducer = function fetchPlussArticlesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPlussArticlesState();
	    var action = arguments[1];
	
	    if (action.type === _types.PLUSS_ARTICLES_SUCCESS) {
	        var payload = action.payload;
	
	
	        return (0, _extends3.default)({}, state, {
	            pluss: payload.articles.filter(function (article) {
	                return !article.error && article.id !== 'jPJ5g9';
	            }),
	            meta: payload.meta
	        });
	    }
	
	    if (action.type === _types.PLUSS_ARTICLES_ADD) {
	        return (0, _extends3.default)({}, state, {
	            pluss: [].concat((0, _toConsumableArray3.default)(state.pluss)).concat([].concat((0, _toConsumableArray3.default)(action.payload.articles.filter(function (article) {
	                return !article.error;
	            }))))
	        });
	    }
	
	    if (action.type === _types.PLUSS_ARTICLES_FAILURE) {
	        return (0, _extends3.default)({}, state, action.payload, {
	            error: true
	        });
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 815:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchRecirculationReducer = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _types = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultRecirculationState = function defaultRecirculationState() {
	    return {
	        items: [],
	        error: false
	    };
	};
	
	/* eslint-disable import/prefer-default-export */
	var fetchRecirculationReducer = exports.fetchRecirculationReducer = function fetchRecirculationReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecirculationState();
	    var action = arguments[1];
	
	    if (action.type === _types.RECIRCULATION_SUCCESS) {
	        return (0, _extends3.default)({}, state, {
	            items: state.items.concat(action.payload)
	        });
	    }
	
	    if (action.type === _types.RECIRCULATION_FAILURE) {
	        return (0, _extends3.default)({}, state, action.payload, {
	            error: true
	        });
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 816:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.trackingReducer = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _types = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	var trackingReducer = exports.trackingReducer = function trackingReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (action.type === _types.TRACKER_SUCCESS) {
	        return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.trackerId, true));
	    }
	
	    return state;
	};

/***/ },

/***/ 817:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.utmParamsReducer = undefined;
	
	var _types = __webpack_require__(28);
	
	var defaultState = {};
	
	/* eslint-disable import/prefer-default-export */
	var utmParamsReducer = exports.utmParamsReducer = function utmParamsReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    if (action.type === _types.UTM_PARAMS) {
	        return action.payload;
	    }
	
	    return state;
	};
	/* eslint-enable import/prefer-default-export */

/***/ },

/***/ 818:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(165);
	
	var _app = __webpack_require__(819);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _front = __webpack_require__(828);
	
	var _front2 = _interopRequireDefault(_front);
	
	var _article = __webpack_require__(821);
	
	var _article2 = _interopRequireDefault(_article);
	
	var _pluss = __webpack_require__(829);
	
	var _pluss2 = _interopRequireDefault(_pluss);
	
	var _collection = __webpack_require__(827);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _contact = __webpack_require__(824);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _responsible = __webpack_require__(830);
	
	var _responsible2 = _interopRequireDefault(_responsible);
	
	var _error = __webpack_require__(124);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _embed = __webpack_require__(826);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _fbComments = __webpack_require__(825);
	
	var _fbComments2 = _interopRequireDefault(_fbComments);
	
	var _authCallback = __webpack_require__(822);
	
	var _authCallback2 = _interopRequireDefault(_authCallback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _reactRouter.Router,
	        null,
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { component: _embed2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: '/embed/fb-comments', component: _fbComments2.default })
	        ),
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { component: _app2.default },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _front2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/(:section/)(:subSection/)i/:id(/:title)', component: _article2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/(:section/)(:subSection/)(:title/)i/:id', component: _article2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/pluss', component: _pluss2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/om-vg/ansvarlige-personer', component: _responsible2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/om-vg/kontakt-oss', component: _contact2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/tag/:tag(/:title)', component: _collection2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/emne/:story(/:title)', component: _collection2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/auth/callback', component: _authCallback2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/:section(/:subSection)(/:tagTitle)', component: _collection2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '*', component: _error2.default })
	        )
	    );
	};

/***/ },

/***/ 819:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _merge2 = __webpack_require__(1166);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _get2 = __webpack_require__(101);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _cloneDeep2 = __webpack_require__(379);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _themeProvider = __webpack_require__(27);
	
	var _uiCoreNavigation = __webpack_require__(118);
	
	var _uiCoreNavigation2 = _interopRequireDefault(_uiCoreNavigation);
	
	var _cnSkinVg = __webpack_require__(309);
	
	var _cnSkinVg2 = _interopRequireDefault(_cnSkinVg);
	
	var _footer = __webpack_require__(730);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _universalConfig = __webpack_require__(22);
	
	var _whitelabel = __webpack_require__(311);
	
	var _whitelabel2 = _interopRequireDefault(_whitelabel);
	
	var _adComponents = __webpack_require__(114);
	
	var _uiSkipToContent = __webpack_require__(670);
	
	var _uiSkipToContent2 = _interopRequireDefault(_uiSkipToContent);
	
	var _theme = __webpack_require__(315);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _BodyClass = __webpack_require__(313);
	
	var _BodyClass2 = _interopRequireDefault(_BodyClass);
	
	var _helpers = __webpack_require__(72);
	
	var _mypageAb = __webpack_require__(845);
	
	var _mypageAb2 = _interopRequireDefault(_mypageAb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var engagement = function engagement(_ref) {
	    var elementIdentifier = _ref.elementIdentifier,
	        meta = _ref.meta;
	    var name = meta.name,
	        event = meta.event;
	
	    var href = event.target.pathname;
	
	    try {
	        var activity = window.AutoTrack.activity();
	        var eventObj = activity.events.trackEngagement(undefined, undefined, 'Click', 'CoreNavigation', elementIdentifier, 'Click', { name: name, targetUrl: href });
	
	        return new _promise2.default(function (resolve) {
	            return eventObj.send(resolve);
	        });
	    } catch (err) {
	        console.error(err); // eslint-disable-line no-console
	    }
	
	    return _promise2.default.resolve();
	};
	
	var App = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        article: state.article,
	        device: state.device,
	        irisStyles: state.themes
	    };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(App, _Component);
	
	    function App() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.prepareCoreNavSkin = function () {
	            if (_this.props.isWeb) {
	                var coreNavSkin = (0, _cloneDeep3.default)(_cnSkinVg2.default);
	                var replacement = {
	                    mastheadExtension: {
	                        myPage: {
	                            name: 'MyPage'
	                        }
	                    }
	                };
	                if ((0, _mypageAb2.default)(_universalConfig.appConfig.myPage.ratio)) {
	                    replacement.mastheadExtension.myPage.url = (0, _get3.default)(_universalConfig.appConfig, 'myPage.url');
	
	                    return (0, _merge3.default)(coreNavSkin, replacement);
	                }
	                replacement.mastheadExtension.myPage.url = coreNavSkin.mastheadExtension.myPage.url + '?tag=mp_a';
	
	                return (0, _merge3.default)(coreNavSkin, replacement);
	            }
	
	            return _cnSkinVg2.default;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(App, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                device = _props.device,
	                article = _props.article,
	                _props$location = _props.location;
	            _props$location = _props$location === undefined ? {} : _props$location;
	            var _props$location$pathn = _props$location.pathname,
	                pathname = _props$location$pathn === undefined ? '' : _props$location$pathn;
	
	            var themeId = (0, _themeProvider.getThemeIdFromIrisContent)(article);
	            var appnexus = _universalConfig.appConfig.appnexus,
	                _config$smartAppBanne = _universalConfig.appConfig.smartAppBanner,
	                smartAppBanner = _config$smartAppBanne === undefined ? {} : _config$smartAppBanne,
	                baseUrl = _universalConfig.appConfig.baseUrl,
	                _config$facebook = _universalConfig.appConfig.facebook,
	                facebook = _config$facebook === undefined ? {} : _config$facebook;
	
	
	            var appnexusArticleKeywords = (0, _helpers.getArticleAdKeywords)(article, device);
	            var appnexusKeywords = (0, _extends3.default)({}, appnexus.keywords, appnexusArticleKeywords);
	
	            var skipToContentAnchors = [{
	                href: '#main',
	                anchorText: 'Hopp til hovedinnhold'
	            }];
	
	            var smartAppBannerTags = smartAppBanner.tags.map(function (_ref3) {
	                var property = _ref3.property,
	                    content = _ref3.content;
	                return {
	                    property: property,
	                    content: content.replace('{{LOCATION}}', baseUrl + pathname)
	                };
	            });
	
	            return _react2.default.createElement(
	                _themeProvider.SelectedThemeProvider,
	                {
	                    id: themeId,
	                    whitelabelThemesMapping: _whitelabel2.default,
	                    localThemesMapping: _theme2.default,
	                    irisStyles: this.props.irisStyles
	                },
	                _react2.default.createElement(
	                    _BodyClass2.default,
	                    { theme: '' + _BodyClass.themePrefix + themeId },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container-column' },
	                        _react2.default.createElement(_reactHelmet2.default, {
	                            script: [{
	                                innerHTML: 'window.vgDevice = \'' + device + '\''
	                            }]
	                        }),
	                        _react2.default.createElement(_reactHelmet2.default, { meta: smartAppBannerTags }),
	                        _react2.default.createElement(_reactHelmet2.default, { meta: facebook.tags }),
	                        _react2.default.createElement(_uiSkipToContent2.default, { skipToContentAnchors: skipToContentAnchors }),
	                        device.indexOf('-app') === -1 && _react2.default.createElement(_uiCoreNavigation2.default, {
	                            skin: this.prepareCoreNavSkin(),
	                            publicationName: 'vg',
	                            sectionPath: pathname,
	                            engagement: engagement
	                        }),
	                        _react2.default.createElement(_adComponents.PageOptions, {
	                            member: appnexus.member,
	                            disablePsa: true,
	                            noBidIfUnsold: true,
	                            keywords: appnexusKeywords
	                        }),
	                        this.props.children,
	                        _react2.default.createElement(_footer2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	    return App;
	}(_react.Component), _class2.defaultProps = {
	    children: [],
	    article: {},
	    device: 'desktop',
	    irisStyles: {},
	    location: {},
	    isWeb: !!(true) // to re-render some parts of the page in the browser
	}, _class2.propTypes = {
	    children: _propTypes2.default.node,
	    article: _propTypes2.default.shape({
	        clientProperties: _propTypes2.default.object
	    }),
	    device: _propTypes2.default.string,
	    irisStyles: _propTypes2.default.shape({
	        default: _propTypes2.default.object
	    }),
	    location: _propTypes2.default.shape({
	        pathname: _propTypes2.default.string
	    }),
	    isWeb: _propTypes2.default.bool
	}, _temp2)) || _class);
	exports.default = App;

/***/ },

/***/ 820:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _uiGallery = __webpack_require__(297);
	
	var _editorialLabel = __webpack_require__(720);
	
	var _editorialLabel2 = _interopRequireDefault(_editorialLabel);
	
	var _publicationTimestamp = __webpack_require__(735);
	
	var _publicationTimestamp2 = _interopRequireDefault(_publicationTimestamp);
	
	var _Byline = __webpack_require__(780);
	
	var _Byline2 = _interopRequireDefault(_Byline);
	
	var _Bundle = __webpack_require__(779);
	
	var _Bundle2 = _interopRequireDefault(_Bundle);
	
	var _Comments = __webpack_require__(781);
	
	var _Comments2 = _interopRequireDefault(_Comments);
	
	var _ContactUs = __webpack_require__(770);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _VgGoldCompetition = __webpack_require__(798);
	
	var _VgGoldCompetition2 = _interopRequireDefault(_VgGoldCompetition);
	
	var _EmbedWrapper = __webpack_require__(783);
	
	var _EmbedWrapper2 = _interopRequireDefault(_EmbedWrapper);
	
	var _Factbox = __webpack_require__(784);
	
	var _Factbox2 = _interopRequireDefault(_Factbox);
	
	var _GalleryImage = __webpack_require__(785);
	
	var _GalleryImage2 = _interopRequireDefault(_GalleryImage);
	
	var _GalleryVideo = __webpack_require__(786);
	
	var _GalleryVideo2 = _interopRequireDefault(_GalleryVideo);
	
	var _LazyLoadedImage = __webpack_require__(787);
	
	var _LazyLoadedImage2 = _interopRequireDefault(_LazyLoadedImage);
	
	var _LazyLoadedVideo = __webpack_require__(790);
	
	var _LazyLoadedVideo2 = _interopRequireDefault(_LazyLoadedVideo);
	
	var _LazyLoadedMapMapbox = __webpack_require__(788);
	
	var _LazyLoadedMapMapbox2 = _interopRequireDefault(_LazyLoadedMapMapbox);
	
	var _Salesposter = __webpack_require__(793);
	
	var _Salesposter2 = _interopRequireDefault(_Salesposter);
	
	var _Streamer = __webpack_require__(794);
	
	var _Streamer2 = _interopRequireDefault(_Streamer);
	
	var _ActionableText = __webpack_require__(778);
	
	var _ActionableText2 = _interopRequireDefault(_ActionableText);
	
	var _Tags = __webpack_require__(795);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _TextAd = __webpack_require__(797);
	
	var _TextAd2 = _interopRequireDefault(_TextAd);
	
	var _Url = __webpack_require__(775);
	
	var _Url2 = _interopRequireDefault(_Url);
	
	var _LazyLoadedTopObject = __webpack_require__(789);
	
	var _LazyLoadedTopObject2 = _interopRequireDefault(_LazyLoadedTopObject);
	
	var _NtDisclaimer = __webpack_require__(792);
	
	var _NtDisclaimer2 = _interopRequireDefault(_NtDisclaimer);
	
	var _CoreComments = __webpack_require__(782);
	
	var _CoreComments2 = _interopRequireDefault(_CoreComments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var factboxEngagementTracking = function factboxEngagementTracking(_ref) {
	    var elementName = _ref.elementName,
	        args = _ref.args;
	
	    var event = args[0];
	    var toggleButton = event.currentTarget;
	    var opening = toggleButton.getAttribute('aria-expanded') === 'false';
	
	    try {
	        var activity = window.AutoTrack.activity();
	        activity.events.trackEngagement(undefined, undefined, 'Click', 'FactBox', elementName, opening ? 'Open' : 'Close').send();
	    } catch (err) {
	        console.error(err); // eslint-disable-line no-console
	    }
	};
	
	exports.default = {
	    url: {
	        default: {
	            component: _Url2.default
	        },
	        datawrapper: { component: _EmbedWrapper2.default },
	        'top-banner': { component: _EmbedWrapper2.default }
	    },
	    salesposter: {
	        default: {
	            component: _Salesposter2.default
	        }
	    },
	    streamer: {
	        default: {
	            component: _Streamer2.default
	        }
	    },
	    byline: {
	        default: {
	            component: _Byline2.default
	        }
	    },
	    text: {
	        timestamp: {
	            component: _publicationTimestamp2.default
	        }
	    },
	    'editorial-label': {
	        default: {
	            component: _editorialLabel2.default
	        }
	    },
	    comments: {
	        default: {
	            component: _Comments2.default
	        }
	    },
	    'core-comments': {
	        default: {
	            component: _CoreComments2.default
	        }
	    },
	    'actionable-text': {
	        default: {
	            component: _ActionableText2.default
	        }
	    },
	    image: {
	        default: {
	            component: _LazyLoadedImage2.default
	        }
	    },
	    fact: {
	        default: {
	            component: _Factbox2.default,
	            props: {
	                interaction: factboxEngagementTracking
	            }
	        }
	    },
	    map: {
	        default: {
	            component: _LazyLoadedMapMapbox2.default
	        }
	    },
	    video: {
	        default: {
	            component: _LazyLoadedVideo2.default
	        }
	    },
	    tags: {
	        default: {
	            component: _Tags2.default
	        }
	    },
	    ad: {
	        default: {
	            component: _TextAd2.default
	        }
	    },
	    'tip-us': {
	        default: {
	            component: _ContactUs2.default
	        }
	    },
	    'vg-gold-competition': {
	        default: {
	            component: _VgGoldCompetition2.default
	        }
	    },
	    gallery: {
	        default: {
	            component: _uiGallery.ThemedGallery,
	            children: {
	                image: {
	                    default: {
	                        component: _GalleryImage2.default
	                    }
	                },
	                video: {
	                    default: {
	                        component: _GalleryVideo2.default
	                    }
	                }
	            }
	        }
	    },
	    bundle: {
	        default: {
	            component: _Bundle2.default
	        }
	    },
	    top_object: {
	        default: {
	            component: _LazyLoadedTopObject2.default
	        }
	    },
	    'nt-disclaimer': {
	        default: {
	            component: _NtDisclaimer2.default
	        }
	    }
	};

/***/ },

/***/ 821:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactLazyLoad = __webpack_require__(67);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _redial = __webpack_require__(112);
	
	var _reactRouter = __webpack_require__(165);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxArticle = __webpack_require__(278);
	
	var _universalConfig = __webpack_require__(22);
	
	var _article = __webpack_require__(471);
	
	var _article2 = _interopRequireDefault(_article);
	
	var _irisUrls = __webpack_require__(545);
	
	var _irisUrls2 = _interopRequireDefault(_irisUrls);
	
	var _cnSkinVg = __webpack_require__(309);
	
	var _cnSkinVg2 = _interopRequireDefault(_cnSkinVg);
	
	var _tracking = __webpack_require__(116);
	
	var _uiCoreNavigation = __webpack_require__(118);
	
	var _themeProvider = __webpack_require__(27);
	
	var _couponCodes = __webpack_require__(718);
	
	var _couponCodes2 = _interopRequireDefault(_couponCodes);
	
	var _externalArticles = __webpack_require__(722);
	
	var _externalArticles2 = _interopRequireDefault(_externalArticles);
	
	var _List = __webpack_require__(771);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _SchemaOrg = __webpack_require__(773);
	
	var _SchemaOrg2 = _interopRequireDefault(_SchemaOrg);
	
	var _error = __webpack_require__(124);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _deferOnload = __webpack_require__(186);
	
	var _deferOnload2 = _interopRequireDefault(_deferOnload);
	
	var _initSpid = __webpack_require__(188);
	
	var _initSpid2 = _interopRequireDefault(_initSpid);
	
	var _loadCogwheel = __webpack_require__(759);
	
	var _loadCogwheel2 = _interopRequireDefault(_loadCogwheel);
	
	var _Ads = __webpack_require__(312);
	
	var _recirculation = __webpack_require__(806);
	
	var _couponCodes3 = __webpack_require__(801);
	
	var _utmParams = __webpack_require__(807);
	
	var _generateArticleRoute = __webpack_require__(838);
	
	var _generateArticleRoute2 = _interopRequireDefault(_generateArticleRoute);
	
	var _getLpMeta = __webpack_require__(841);
	
	var _getLpMeta2 = _interopRequireDefault(_getLpMeta);
	
	var _getLeadText = __webpack_require__(316);
	
	var _getLeadText2 = _interopRequireDefault(_getLeadText);
	
	var _articleComponentMapping = __webpack_require__(820);
	
	var _articleComponentMapping2 = _interopRequireDefault(_articleComponentMapping);
	
	var _NorskTippingMeta = __webpack_require__(772);
	
	var _NorskTippingMeta2 = _interopRequireDefault(_NorskTippingMeta);
	
	var _ShareMeta = __webpack_require__(774);
	
	var _ShareMeta2 = _interopRequireDefault(_ShareMeta);
	
	var _getUtmTags = __webpack_require__(844);
	
	var _getUtmTags2 = _interopRequireDefault(_getUtmTags);
	
	var _clientParams = __webpack_require__(185);
	
	var _clientParams2 = _interopRequireDefault(_clientParams);
	
	var _fontChooser = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var urls = (0, _irisUrls2.default)(_universalConfig.appConfig.iris); // eslint-disable-line
	
	var host = _universalConfig.appConfig.iris.host,
	    recirculationEndpoint = _universalConfig.appConfig.articleList.recirculation.endpoint,
	    couponCodesEndpoint = _universalConfig.appConfig.couponCodes.endpoint,
	    baseUrl = _universalConfig.appConfig.baseUrl;
	
	
	var recirculationUtmParams = {
	    utm_content: 'recirculation-matrix'
	};
	
	// https://github.schibsted.io/spt-dataanalytics/event-sdk-js/blob/master/autotracking/click.js
	var trackRecirculationClick = function trackRecirculationClick(e) {
	    if (!window.AutoTrack) {
	        return;
	    }
	
	    var targetArticleId = e.currentTarget.getAttribute('data-article-id');
	    var activity = window.AutoTrack.activity();
	    activity.events.trackClick('recirculation-matrix', undefined, 'Article', targetArticleId).send();
	};
	
	var Article = (_dec = (0, _redial.provideHooks)({
	    fetch: function fetch(_ref) {
	        var params = _ref.params,
	            dispatch = _ref.dispatch,
	            force = _ref.force,
	            location = _ref.location,
	            setProps = _ref.setProps;
	        var articleId = params.id;
	        var _location$query = location.query;
	        _location$query = _location$query === undefined ? {} : _location$query;
	        var layout = _location$query.layout;
	
	
	        if (layout) {
	            setProps({ layout: layout });
	        }
	
	        var fetchArticle = _reduxArticle.actions.fetchArticle({
	            id: articleId,
	            endpoint: urls.article(articleId, layout),
	            force: force,
	            headers: {
	                'X-SP-Bypass': 'Hyperion'
	            }
	        });
	
	        var fetchCouponCodes = (0, _couponCodes3.fetchCouponCodesAction)({
	            endpoint: couponCodesEndpoint
	        });
	
	        return _promise2.default.all([dispatch(fetchArticle), dispatch(fetchCouponCodes)]).then(function () {
	            return (0, _generateArticleRoute2.default)(dispatch, location, params);
	        });
	    },
	    defer: function defer(_ref2) {
	        var dispatch = _ref2.dispatch,
	            location = _ref2.location,
	            getProps = _ref2.getProps;
	        return dispatch(function () {
	            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(thunkDispatch, getState) {
	                var _location$search, search, _location$pathname, pathname, _location$query2, query, _getProps, layout, _getState, id, utmTags, filteredQueryString, filteredUrl, trackingOpt;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _location$search = location.search, search = _location$search === undefined ? '' : _location$search, _location$pathname = location.pathname, pathname = _location$pathname === undefined ? '' : _location$pathname, _location$query2 = location.query, query = _location$query2 === undefined ? {} : _location$query2;
	                                _getProps = getProps(), layout = _getProps.layout;
	                                _getState = getState(), id = _getState.article.id;
	
	
	                                recirculationUtmParams.utm_source = id;
	
	                                /* Extract all url params that are UTM tags on client and then strip them from the url */
	                                utmTags = (0, _getUtmTags2.default)(search);
	                                _context.next = 7;
	                                return thunkDispatch((0, _utmParams.utmParamsAction)(utmTags));
	
	                            case 7:
	                                filteredQueryString = (0, _keys2.default)(query)
	                                // Remove layout-parameter from url.
	                                .filter(function (key) {
	                                    return key !== 'layout';
	                                }).map(function (key) {
	                                    return key + '=' + query[key];
	                                }).join('&');
	                                filteredUrl = pathname;
	
	
	                                if (filteredQueryString.length > 0) {
	                                    filteredUrl += '?' + filteredQueryString;
	                                }
	
	                                _reactRouter.browserHistory.replace(filteredUrl);
	
	                                _context.next = 13;
	                                return (0, _initSpid2.default)({ thunkDispatch: thunkDispatch, location: location, getState: getState });
	
	                            case 13:
	                                thunkDispatch(_uiCoreNavigation.actions.coreNavigationUI.init(_cnSkinVg2.default.sectionsMenu));
	
	                                _context.next = 16;
	                                return (0, _deferOnload2.default)();
	
	                            case 16:
	
	                                (0, _loadCogwheel2.default)();
	
	                                trackingOpt = (0, _clientParams2.default)({
	                                    config: _universalConfig.appConfig,
	                                    layout: layout,
	                                    state: getState(),
	                                    utm: utmTags
	                                });
	
	
	                                if (trackingOpt && !id.includes('@preview')) {
	                                    thunkDispatch(_tracking.reduxActions.trackerMultipleStart(trackingOpt));
	                                }
	
	                            case 19:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function (_x, _x2) {
	                return _ref3.apply(this, arguments);
	            };
	        }());
	    }
	}), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        article: state.article,
	        theme: state.theme,
	        recirculation: state.recirculation,
	        couponCodes: state.couponCodes,
	        device: state.device
	    };
	}), _dec3 = (0, _themeProvider.themer)('Article'), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Article, _Component);
	
	    function Article() {
	        (0, _classCallCheck3.default)(this, Article);
	        return (0, _possibleConstructorReturn3.default)(this, (Article.__proto__ || (0, _getPrototypeOf2.default)(Article)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Article, [{
	        key: 'getRecirculationData',
	
	        /* eslint-disable react/forbid-prop-types */
	        value: function getRecirculationData() {
	            var _props$article = this.props.article,
	                id = _props$article.id,
	                sectionId = _props$article.section.id;
	
	
	            var endpoint = '' + host + recirculationEndpoint + '?articleId=' + id + '&sectionId=' + sectionId;
	
	            this.props.dispatch((0, _recirculation.fetchRecirculationListAction)({
	                endpoint: endpoint
	            }));
	        }
	        /* eslint-enable react/forbid-prop-types */
	
	    }, {
	        key: 'renderWorldCupHeader',
	        value: function renderWorldCupHeader() {
	            var tags = this.props.article.tags;
	
	
	            if (tags.find(function (tag) {
	                return tag.id === '4caba6ad-b909-4059-9ad1-2f2547b575bb';
	            }) !== undefined) {
	                return _react2.default.createElement('iframe', {
	                    src: 'https://www.vg.no/spesial/2018/fotball-vm/embeds/article-stripe.php',
	                    scrolling: 'no',
	                    frameBorder: '0',
	                    style: {
	                        width: '100%',
	                        height: '50px',
	                        marginBottom: '-4px'
	                    }
	                });
	            }
	
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // eslint-disable-next-line react/prop-types
	            var _props = this.props,
	                article = _props.article,
	                theme = _props.theme,
	                recirculation = _props.recirculation,
	                couponCodes = _props.couponCodes,
	                device = _props.device,
	                layout = _props.layout;
	
	
	            if (article.error) {
	                var status = article.status;
	
	
	                return _react2.default.createElement(_error2.default, { statusCode: status, theme: theme });
	            }
	
	            var isApp = device.indexOf('-app') > -1;
	            var isMobile = device.indexOf('mobile') > -1;
	
	            var _config$articleList$r = _universalConfig.appConfig.articleList.recirculation,
	                recirculationTitle = _config$articleList$r.title,
	                recirculationDes = _config$articleList$r.description,
	                titleSuffix = _universalConfig.appConfig.head.titleSuffix,
	                adPlacements = _universalConfig.appConfig.adPlacements;
	            var _article$title$value = article.title.value,
	                articleTitle = _article$title$value === undefined ? '' : _article$title$value,
	                sectionTitle = article.section.title,
	                canonicalUrl = article.links.canonicalUrl,
	                _article$customProper = article.customProperties,
	                isSubscription = _article$customProper.vg_paywall,
	                _article$customProper2 = _article$customProper.googleTitle,
	                googleTitle = _article$customProper2 === undefined ? '' : _article$customProper2,
	                showAds = _article$customProper.vg_showAds,
	                _article$customProper3 = _article$customProper.vg_blockSearchEngineIndexing,
	                blockSearchEngineIndexing = _article$customProper3 === undefined ? false : _article$customProper3,
	                tags = article.tags,
	                id = article.id;
	
	
	            var title = googleTitle || articleTitle;
	            var leadText = (0, _getLeadText2.default)(article);
	
	            var titleTagText = title.trim() + ' - ' + titleSuffix;
	
	            var _article$clientProper = article.clientProperties;
	            _article$clientProper = _article$clientProper === undefined ? {} : _article$clientProper;
	            var _article$clientProper2 = _article$clientProper.clientPlacedAds,
	                clientPlacedAds = _article$clientProper2 === undefined ? [] : _article$clientProper2,
	                _article$clientProper3 = _article$clientProper.externalArticles,
	                externalArticles = _article$clientProper3 === undefined ? [] : _article$clientProper3,
	                themes = _article$clientProper.themes;
	
	            var hasExternalArticles = externalArticles.length > 0;
	            var adTypes = isMobile ? 'mobile' : 'default';
	            var keywords = tags.map(function (tag) {
	                return tag.title;
	            });
	            var classes = (0, _classnames2.default)(theme.contentContainer, (0, _defineProperty3.default)({}, theme.noA, !showAds));
	            var rootClassNames = (0, _classnames2.default)(theme.root, {
	                'is-app': isApp
	            });
	
	            if (article.section.parent) {
	                keywords.push(article.section.parent.title);
	            }
	            var isPreview = id.includes('@preview');
	
	            keywords.push(article.section.title);
	
	            var fonts = (0, _fontChooser.getFonts)(_universalConfig.appConfig.fonts, themes);
	            var lpMeta = (0, _getLpMeta2.default)({ baseUrl: baseUrl, sectionTitle: sectionTitle, article: article, layout: layout });
	            var fbMeta = [{
	                property: 'fb:pages',
	                content: '137059286994' // VG
	            }, {
	                property: 'fb:pages',
	                content: '191842593486' // Rampelys
	            }, {
	                property: 'fb:pages',
	                content: '161048627113' // Sporten
	            }, {
	                property: 'fb:pages',
	                content: '162476410432473' // Meninger
	            }];
	
	            return _react2.default.createElement(
	                'div',
	                { className: rootClassNames },
	                _react2.default.createElement(_Ads.SponsorAd, { clientPlacedAds: clientPlacedAds }),
	                _react2.default.createElement(
	                    _reactHelmet2.default,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        titleTagText
	                    ),
	                    _react2.default.createElement('link', { rel: 'canonical', href: canonicalUrl }),
	                    _react2.default.createElement('meta', { name: 'robots', content: 'noarchive' }),
	                    _react2.default.createElement('meta', { name: 'description', content: leadText }),
	                    _react2.default.createElement('meta', { name: 'keywords', content: keywords.join(', ') }),
	                    blockSearchEngineIndexing && _react2.default.createElement('meta', { name: 'robots', content: 'noindex' }),
	                    isSubscription && _react2.default.createElement('meta', { name: 'lp:type', content: 'article_subscription' }),
	                    isPreview && _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' }),
	                    fonts.map(function (_ref4) {
	                        var cdn = _ref4.cdn;
	                        return _react2.default.createElement('link', {
	                            rel: 'preload',
	                            as: 'font',
	                            type: 'font/woff2',
	                            href: cdn + '.woff2',
	                            crossOrigin: true
	                        });
	                    }),
	                    _react2.default.createElement(
	                        'style',
	                        null,
	                        (0, _fontChooser.fontsToInlineStyle)(fonts)
	                    )
	                ),
	                _react2.default.createElement(_reactHelmet2.default, { meta: lpMeta.concat(fbMeta) }),
	                _react2.default.createElement(_ShareMeta2.default, { article: article }),
	                _react2.default.createElement(_SchemaOrg2.default, { article: article }),
	                _react2.default.createElement(_NorskTippingMeta2.default, { article: article }),
	                !isMobile && _react2.default.createElement(_Ads.HorseshoeAd, { clientPlacedAds: clientPlacedAds, device: device }),
	                _react2.default.createElement(
	                    'main',
	                    { className: classes, role: 'main', id: 'main' },
	                    _react2.default.createElement(_Ads.ClientPlacedAd, { subtype: 'test_1', clientPlacedAds: clientPlacedAds }),
	                    this.renderWorldCupHeader(),
	                    _react2.default.createElement('span', { className: 'lp_is_start', style: { width: '1px', height: '1px' } }),
	                    _react2.default.createElement(_article2.default, {
	                        data: article,
	                        localComponentsMapping: _articleComponentMapping2.default
	                    }),
	                    _react2.default.createElement('span', { className: 'lp_is_end', style: { width: '1px', height: '1px' } }),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'recirculation', 'data-engage-entity-id': 'recirculation-matrix' },
	                        _react2.default.createElement(
	                            _reactLazyLoad2.default,
	                            {
	                                offset: 500,
	                                debounce: false,
	                                throttle: 100,
	                                onContentVisible: function onContentVisible() {
	                                    return _this2.getRecirculationData();
	                                }
	                            },
	                            _react2.default.createElement(_List2.default, {
	                                articles: recirculation.items,
	                                title: recirculationTitle,
	                                description: recirculationDes,
	                                onClick: trackRecirculationClick,
	                                utmParams: recirculationUtmParams
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_Ads.AdPlacement, { types: adPlacements[adTypes], clientPlacedAds: clientPlacedAds }),
	                    hasExternalArticles && _react2.default.createElement(
	                        'div',
	                        { id: 'external-articles' },
	                        _react2.default.createElement(
	                            _reactLazyLoad2.default,
	                            { offset: 500, debounce: false, throttle: 100 },
	                            _react2.default.createElement(_externalArticles2.default, { articles: externalArticles })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'coupon-codes' },
	                        _react2.default.createElement(_couponCodes2.default, { discounts: couponCodes.items })
	                    )
	                )
	            );
	        }
	    }]);
	    return Article;
	}(_react.Component), _class2.propTypes = {
	    theme: _propTypes2.default.object,
	    article: _propTypes2.default.object,
	    recirculation: _propTypes2.default.object,
	    couponCodes: _propTypes2.default.object,
	    dispatch: _propTypes2.default.func.isRequired,
	    device: _propTypes2.default.string,
	    layout: _propTypes2.default.string
	}, _class2.defaultProps = {
	    theme: {},
	    article: {},
	    recirculation: {},
	    couponCodes: [],
	    device: 'desktop',
	    layout: ''
	}, _temp)) || _class) || _class) || _class);
	exports.default = Article;

/***/ },

/***/ 822:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _verifyLoginCallback = __webpack_require__(823);
	
	var _verifyLoginCallback2 = _interopRequireDefault(_verifyLoginCallback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthCallback = (_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(AuthCallback, _React$Component);
	
	    function AuthCallback() {
	        (0, _classCallCheck3.default)(this, AuthCallback);
	        return (0, _possibleConstructorReturn3.default)(this, (AuthCallback.__proto__ || (0, _getPrototypeOf2.default)(AuthCallback)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AuthCallback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var location = this.props.location;
	
	            (0, _verifyLoginCallback2.default)({ location: location }).then(function (_ref) {
	                var origin = _ref.origin;
	                return window.location.assign(origin);
	            }).catch(function (err) {
	                console.error(err); // eslint-disable-line no-console
	                // redirect to frontpage if invalid state
	                window.location.assign('/');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'h4',
	                { style: { textAlign: 'center', margin: '60px' } },
	                'Vennligst vent.'
	            );
	        }
	    }]);
	    return AuthCallback;
	}(_react2.default.Component), _class.propTypes = {
	    location: _propTypes2.default.shape({
	        query: _propTypes2.default.object
	    }).isRequired
	}, _temp);
	exports.default = AuthCallback;

/***/ },

/***/ 823:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global window */
	var getLoginCallbackParams = function getLoginCallbackParams() {
	    var state = window.sessionStorage.getItem('auth_state');
	    var origin = window.sessionStorage.getItem('auth_origin');
	    window.sessionStorage.removeItem('auth_state');
	    window.sessionStorage.removeItem('auth_origin');
	
	    if (!state || !origin) {
	        state = window.localStorage.getItem('auth_state');
	        origin = window.localStorage.getItem('auth_origin');
	        window.localStorage.removeItem('auth_state');
	        window.localStorage.removeItem('auth_origin');
	    }
	
	    return {
	        state: state,
	        origin: origin
	    };
	};
	
	var verifyLoginCallback = function verifyLoginCallback(_ref) {
	    var location = _ref.location;
	
	    var _getLoginCallbackPara = getLoginCallbackParams(),
	        origin = _getLoginCallbackPara.origin,
	        state = _getLoginCallbackPara.state;
	
	    if (state !== location.query.state) {
	        return _promise2.default.reject('invalid auth state');
	    }
	
	    return _promise2.default.resolve({ origin: origin });
	};
	
	exports.default = verifyLoginCallback;

/***/ },

/***/ 824:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(36);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _ContactVG = __webpack_require__(776);
	
	var _ContactVG2 = _interopRequireDefault(_ContactVG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactUs = (_dec = (0, _reactCssThemr.themr)('AboutVG'), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ContactUs, _Component);
	
	    function ContactUs() {
	        (0, _classCallCheck3.default)(this, ContactUs);
	        return (0, _possibleConstructorReturn3.default)(this, (ContactUs.__proto__ || (0, _getPrototypeOf2.default)(ContactUs)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ContactUs, [{
	        key: 'render',
	
	        /* eslint-disable react/forbid-prop-types */
	        value: function render() {
	            var theme = this.props.theme;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: theme.root },
	                _react2.default.createElement(_reactHelmet.Helmet, { title: 'Kontakt oss' }),
	                _react2.default.createElement(
	                    'main',
	                    { className: theme.contentContainer, role: 'main', id: 'main' },
	                    _react2.default.createElement('span', { className: 'lp_is_start', style: { width: '1px', height: '1px' } }),
	                    _react2.default.createElement(_ContactVG2.default, { theme: theme }),
	                    _react2.default.createElement('span', { className: 'lp_is_end', style: { width: '1px', height: '1px' } })
	                )
	            );
	        }
	        /* eslint-enable react/forbid-prop-types */
	
	    }]);
	    return ContactUs;
	}(_react.Component), _class2.propTypes = {
	    theme: _propTypes2.default.object
	}, _class2.defaultProps = {
	    theme: {}
	}, _temp)) || _class);
	exports.default = ContactUs;

/***/ },

/***/ 825:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _universalConfig = __webpack_require__(22);
	
	var _themeProvider = __webpack_require__(27);
	
	var _fbComments = __webpack_require__(310);
	
	var _fbComments2 = _interopRequireDefault(_fbComments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Comments = function Comments(_ref) {
	    var location = _ref.location;
	    var _location$query = location.query;
	    _location$query = _location$query === undefined ? {} : _location$query;
	    var url = _location$query.url;
	
	
	    if (!url) {
	        return null;
	    }
	
	    var decodedUrl = decodeURIComponent(url);
	
	    var _config$comments = _universalConfig.appConfig.comments;
	    _config$comments = _config$comments === undefined ? {} : _config$comments;
	    var _config$comments$face = _config$comments.facebook;
	    _config$comments$face = _config$comments$face === undefined ? {} : _config$comments$face;
	    var appId = _config$comments$face.appId,
	        buttonText = _config$comments$face.buttonText,
	        commentsAlwaysOpen = _config$comments$face.commentsAlwaysOpen,
	        commentsClosedHeading = _config$comments$face.commentsClosedHeading,
	        commentsClosedText = _config$comments$face.commentsClosedText,
	        commentsCloseHour = _config$comments$face.commentsCloseHour,
	        commentsOpenHour = _config$comments$face.commentsOpenHour,
	        cookie = _config$comments$face.cookie,
	        lang = _config$comments$face.lang,
	        minutesLeftWhenWarningDisplayed = _config$comments$face.minutesLeftWhenWarningDisplayed,
	        numPosts = _config$comments$face.numPosts,
	        version = _config$comments$face.version,
	        widgetWidth = _config$comments$face.widgetWidth,
	        xfbml = _config$comments$face.xfbml;
	
	
	    return _react2.default.createElement(_fbComments2.default, {
	        appId: appId,
	        buttonText: buttonText,
	        cookie: cookie,
	        commentsAlwaysOpen: commentsAlwaysOpen,
	        commentsClosedHeading: commentsClosedHeading,
	        commentsClosedText: commentsClosedText,
	        commentsOpenHour: commentsOpenHour,
	        commentsCloseHour: commentsCloseHour,
	        lang: lang,
	        minutesLeftWhenWarningDisplayed: minutesLeftWhenWarningDisplayed,
	        numPosts: numPosts,
	        url: decodedUrl,
	        version: version,
	        widgetWidth: widgetWidth,
	        xfbml: xfbml
	    });
	};
	
	exports.default = (0, _themeProvider.themer)('@vg/fb-comments')(Comments);

/***/ },

/***/ 826:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _whitelabel = __webpack_require__(311);
	
	var _whitelabel2 = _interopRequireDefault(_whitelabel);
	
	var _themeProvider = __webpack_require__(27);
	
	var _theme = __webpack_require__(315);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmbedComponent = (_temp = _class = function (_Component) {
	    (0, _inherits3.default)(EmbedComponent, _Component);
	
	    function EmbedComponent() {
	        (0, _classCallCheck3.default)(this, EmbedComponent);
	        return (0, _possibleConstructorReturn3.default)(this, (EmbedComponent.__proto__ || (0, _getPrototypeOf2.default)(EmbedComponent)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(EmbedComponent, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _themeProvider.SelectedThemeProvider,
	                {
	                    whitelabelThemesMapping: _whitelabel2.default,
	                    localThemesMapping: _theme2.default
	                },
	                this.props.children
	            );
	        }
	    }]);
	    return EmbedComponent;
	}(_react.Component), _class.defaultProps = {
	    children: []
	}, _class.propTypes = {
	    children: _propTypes2.default.node
	}, _temp);
	exports.default = EmbedComponent;

/***/ },

/***/ 827:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _universalConfig = __webpack_require__(22);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(25);
	
	var _redux = __webpack_require__(89);
	
	var _themeProvider = __webpack_require__(27);
	
	var _tracking = __webpack_require__(116);
	
	var _redial = __webpack_require__(112);
	
	var _lodash = __webpack_require__(354);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _adComponents = __webpack_require__(114);
	
	var _deferOnload = __webpack_require__(186);
	
	var _deferOnload2 = _interopRequireDefault(_deferOnload);
	
	var _Ads = __webpack_require__(312);
	
	var _BodyClass = __webpack_require__(313);
	
	var _BodyClass2 = _interopRequireDefault(_BodyClass);
	
	var _collectionArticles = __webpack_require__(800);
	
	var _initSpid = __webpack_require__(188);
	
	var _initSpid2 = _interopRequireDefault(_initSpid);
	
	var _GridTeaser = __webpack_require__(314);
	
	var _GridTeaser2 = _interopRequireDefault(_GridTeaser);
	
	var _error = __webpack_require__(124);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _generateCollectionRoute = __webpack_require__(839);
	
	var _generateCollectionRoute2 = _interopRequireDefault(_generateCollectionRoute);
	
	var _redirectToCollectionByTitle = __webpack_require__(848);
	
	var _redirectToCollectionByTitle2 = _interopRequireDefault(_redirectToCollectionByTitle);
	
	var _clientParams = __webpack_require__(185);
	
	var _clientParams2 = _interopRequireDefault(_clientParams);
	
	var _fontChooser = __webpack_require__(187);
	
	var _helpers = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapDispatchToProps(dispatch) {
	    return (0, _redux.bindActionCreators)({ addCollectionArticlesAction: _collectionArticles.addCollectionArticlesAction }, dispatch);
	}
	var ARTICLES_PER_PAGE = 21;
	
	var Collection = (_dec = (0, _redial.provideHooks)({
	    /* eslint-disable arrow-body-style */
	    fetch: function () {
	        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
	            var params = _ref2.params,
	                dispatch = _ref2.dispatch,
	                location = _ref2.location,
	                force = _ref2.force;
	
	            var sections, section, subSection, tag, story, tagTitle, _location$query$offse, offset, sectionId;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            sections = _universalConfig.appConfig.sections;
	                            section = params.section, subSection = params.subSection, tag = params.tag, story = params.story, tagTitle = params.tagTitle;
	                            _location$query$offse = location.query.offset, offset = _location$query$offse === undefined ? 0 : _location$query$offse;
	                            sectionId = void 0;
	
	                            if (!section) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            sectionId = sections[section];
	
	                            if (subSection) {
	                                sectionId = sections[section + '/' + subSection];
	                            }
	
	                            if (!(!sectionId || tagTitle)) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.next = 10;
	                            return (0, _redirectToCollectionByTitle2.default)({ dispatch: dispatch, title: tagTitle || subSection });
	
	                        case 10:
	                            return _context.abrupt('return');
	
	                        case 11:
	
	                            params.section = sectionId; // eslint-disable-line no-param-reassign
	
	                        case 12:
	                            if (!(sectionId !== '' || tag !== '' || story !== '')) {
	                                _context.next = 17;
	                                break;
	                            }
	
	                            _context.next = 15;
	                            return dispatch((0, _collectionArticles.fetchCollectionArticlesAction)({ force: force, offset: offset, section: sectionId, tag: tag, story: story }));
	
	                        case 15:
	                            _context.next = 17;
	                            return (0, _generateCollectionRoute2.default)(dispatch, location, params);
	
	                        case 17:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function fetch(_x) {
	            return _ref.apply(this, arguments);
	        };
	    }(),
	    /* eslint-enable arrow-body-style */
	    defer: function defer(_ref3) {
	        var dispatch = _ref3.dispatch,
	            location = _ref3.location,
	            getProps = _ref3.getProps;
	
	        dispatch(function () {
	            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(thunkDispatch, getState) {
	                var _getProps, layout, spidPromise, trackingOpt, trackingPromise;
	
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _getProps = getProps(), layout = _getProps.layout;
	                                spidPromise = (0, _initSpid2.default)({ thunkDispatch: thunkDispatch, location: location, getState: getState });
	                                _context2.next = 4;
	                                return (0, _deferOnload2.default)();
	
	                            case 4:
	                                trackingOpt = (0, _clientParams2.default)({
	                                    config: _universalConfig.appConfig,
	                                    layout: layout,
	                                    state: getState(),
	                                    location: location
	                                });
	                                trackingPromise = thunkDispatch(_tracking.reduxActions.trackerMultipleStart(trackingOpt));
	                                _context2.next = 8;
	                                return _promise2.default.all([spidPromise, trackingPromise]);
	
	                            case 8:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            }));
	
	            return function (_x2, _x3) {
	                return _ref4.apply(this, arguments);
	            };
	        }());
	    }
	}), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        articles: state.collectionArticles,
	        device: state.device
	    };
	}, mapDispatchToProps), _dec3 = (0, _themeProvider.themer)('Collection'), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Collection, _Component);
	
	    function Collection(props) {
	        var _this2 = this;
	
	        (0, _classCallCheck3.default)(this, Collection);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Collection.__proto__ || (0, _getPrototypeOf2.default)(Collection)).call(this, props));
	
	        _this.fetchMoreArticles = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	            var newOffset, _this$props$params, _this$props$params$se, section, _this$props$params$ta, tag, _this$props$params$st, story, response;
	
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            window.removeEventListener('scroll', _this.scrollListener);
	
	                            newOffset = _this.state.offset + ARTICLES_PER_PAGE;
	                            _this$props$params = _this.props.params, _this$props$params$se = _this$props$params.section, section = _this$props$params$se === undefined ? '' : _this$props$params$se, _this$props$params$ta = _this$props$params.tag, tag = _this$props$params$ta === undefined ? '' : _this$props$params$ta, _this$props$params$st = _this$props$params.story, story = _this$props$params$st === undefined ? '' : _this$props$params$st;
	
	
	                            _this.setState({
	                                offset: newOffset,
	                                isLoading: true
	                            });
	                            _context3.next = 6;
	                            return _this.props.addCollectionArticlesAction({
	                                section: section,
	                                tag: tag,
	                                story: story,
	                                offset: newOffset
	                            });
	
	                        case 6:
	                            response = _context3.sent;
	
	
	                            // click tracking
	                            try {
	                                if (response.payload.articles && response.payload.articles.length > 1) {
	                                    window.AutoTrack.activity().events.trackClick('fetch-more').send();
	                                }
	                            } catch (err) {
	                                console.error(err); // eslint-disable-line no-console
	                            }
	
	                            if (!(!response.payload.articles || response.payload.articles.length < ARTICLES_PER_PAGE)) {
	                                _context3.next = 11;
	                                break;
	                            }
	
	                            _this.setState({
	                                hasMoreArticles: false,
	                                isLoading: true
	                            });
	
	                            return _context3.abrupt('return');
	
	                        case 11:
	
	                            window.addEventListener('scroll', _this.scrollListener);
	
	                        case 12:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, _this2);
	        }));
	
	        _this.fetchMoreArticlesListener = function () {
	            var elementOffset = _this.fetchMoreButton.offsetTop;
	            if (window.scrollY + window.innerHeight * 1.5 < elementOffset) return; // eslint-disable-line no-mixed-operators
	
	            _this.fetchMoreArticles();
	        };
	
	        var location = props.location,
	            articles = props.articles;
	
	
	        _this.state = {
	            offset: location.query.offset || 0,
	            hasMoreArticles: articles.collection && articles.collection.length >= ARTICLES_PER_PAGE,
	            isLoading: false
	        };
	
	        _this.scrollListener = (0, _lodash2.default)(_this.fetchMoreArticlesListener, 500);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Collection, [{
	        key: 'isSponsorateHandball',
	        value: function isSponsorateHandball() {
	            var _props$articles = this.props.articles,
	                articles = _props$articles === undefined ? {} : _props$articles;
	            var _articles$meta = articles.meta,
	                meta = _articles$meta === undefined ? {} : _articles$meta;
	
	
	            if (!meta.section || !meta.section.parent) {
	                return false;
	            }
	
	            if (meta.section.id === '462cf64c-84bb-4e71-8fda-f6ce2d5ae3df') {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                _props$theme = _props.theme,
	                theme = _props$theme === undefined ? {} : _props$theme,
	                _props$articles2 = _props.articles,
	                articles = _props$articles2 === undefined ? {} : _props$articles2,
	                _props$device = _props.device,
	                device = _props$device === undefined ? 'desktop' : _props$device,
	                location = _props.location;
	            var _articles$clientPlace = articles.clientPlacedAds,
	                clientPlacedAds = _articles$clientPlace === undefined ? [] : _articles$clientPlace,
	                _articles$meta2 = articles.meta,
	                meta = _articles$meta2 === undefined ? {} : _articles$meta2;
	            var _state = this.state,
	                offset = _state.offset,
	                hasMoreArticles = _state.hasMoreArticles,
	                isLoading = _state.isLoading;
	
	            var isMobile = device.indexOf('mobile') > -1;
	
	            if (articles.error || !articles.collection.length) {
	                var statusCode = articles.status || 404;
	                return _react2.default.createElement(_error2.default, { statusCode: statusCode, theme: theme });
	            }
	
	            var collectionArticles = articles.collection.map(function (article, index) {
	                return _react2.default.createElement(_GridTeaser2.default, { key: article.id, article: article, theme: theme, index: index });
	            });
	
	            var collectionTitle = '';
	            var bodyTheme = 'default';
	            if (meta.tag) {
	                collectionTitle = meta.tag.title;
	            } else if (meta.story) {
	                collectionTitle = meta.story.title;
	            } else if (meta.section) {
	                collectionTitle = meta.section.title;
	                if (meta.section.parent && meta.section.parent.title === 'Sport') {
	                    bodyTheme = 'sport';
	                }
	            }
	
	            var appnexusSponsorKeywords = [];
	            if (this.isSponsorateHandball()) {
	                appnexusSponsorKeywords.push({
	                    title: 'Håndball VM'
	                });
	            }
	
	            var appnexusKeywords = {};
	            if (meta.section) {
	                appnexusKeywords = (0, _helpers.getArticleAdKeywords)((0, _extends3.default)({}, meta, {
	                    tags: appnexusSponsorKeywords
	                }), device);
	            }
	
	            var appnexus = _universalConfig.appConfig.appnexus;
	
	            var fonts = (0, _fontChooser.getFonts)(_universalConfig.appConfig.fonts);
	            var fontPreloadLinks = fonts.map(function (font) {
	                return {
	                    rel: 'preload',
	                    as: 'font',
	                    type: 'font/woff2',
	                    href: font.cdn + '.woff2',
	                    crossOrigin: true
	                };
	            });
	
	            var links = [{
	                rel: 'canonical',
	                href: location.pathname
	            }];
	
	            if (hasMoreArticles) {
	                links.push({
	                    rel: 'next',
	                    href: location.pathname + '?offset=' + (offset + ARTICLES_PER_PAGE)
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: theme.root },
	                _react2.default.createElement(_Ads.SponsorAd, { clientPlacedAds: clientPlacedAds }),
	                _react2.default.createElement(
	                    _BodyClass2.default,
	                    { theme: 'vgTheme-' + bodyTheme },
	                    _react2.default.createElement(
	                        _reactHelmet.Helmet,
	                        { title: collectionTitle + ' \u2013 VG', link: links.concat(fontPreloadLinks) },
	                        _react2.default.createElement('meta', {
	                            name: 'description',
	                            content: 'Siste nytt om ' + collectionTitle + '.' + (' Les og se nyheter, artikler og videoer om ' + collectionTitle + ' p\xE5 VG.no.')
	                        }),
	                        _react2.default.createElement(
	                            'style',
	                            { type: 'text/css' },
	                            (0, _fontChooser.fontsToInlineStyle)(fonts)
	                        )
	                    )
	                ),
	                !isMobile && _react2.default.createElement(_Ads.HorseshoeAd, { clientPlacedAds: clientPlacedAds, device: device }),
	                _react2.default.createElement(
	                    'section',
	                    { className: theme.front },
	                    _react2.default.createElement(_adComponents.PageOptions, {
	                        member: appnexus.member,
	                        disablePsa: true,
	                        noBidIfUnsold: true,
	                        keywords: appnexusKeywords
	                    }),
	                    _react2.default.createElement(
	                        'h1',
	                        { className: theme.subheader },
	                        'Siste saker om ',
	                        _react2.default.createElement(
	                            'span',
	                            { className: theme.tagTitle },
	                            collectionTitle
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: theme.articleCards },
	                        collectionArticles
	                    ),
	                    hasMoreArticles && _react2.default.createElement(
	                        'button',
	                        {
	                            ref: function ref(element) {
	                                _this3.fetchMoreButton = element;
	                            },
	                            className: theme.showMore,
	                            onClick: this.fetchMoreArticles,
	                            disabled: isLoading
	                        },
	                        'Vis flere artikler'
	                    )
	                )
	            );
	        }
	    }]);
	    return Collection;
	}(_react.Component), _class2.propTypes = {
	    theme: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	    articles: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	    params: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	    addCollectionArticlesAction: _propTypes2.default.func.isRequired,
	    device: _propTypes2.default.string,
	    location: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	}, _class2.defaultProps = {
	    theme: {},
	    articles: {},
	    device: 'desktop',
	    location: {}
	}, _temp)) || _class) || _class) || _class);
	exports.default = Collection;

/***/ },

/***/ 828:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(165);
	
	var _reactCssThemr = __webpack_require__(36);
	
	var _redial = __webpack_require__(112);
	
	var _universalConfig = __webpack_require__(22);
	
	var _latestArticles = __webpack_require__(803);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferenceFront = (_dec = (0, _redial.provideHooks)({
	    fetch: function fetch(_ref) {
	        var dispatch = _ref.dispatch,
	            force = _ref.force;
	        var host = _universalConfig.appConfig.iris.host,
	            _config$sections = _universalConfig.appConfig.sections,
	            sections = _config$sections === undefined ? {} : _config$sections;
	
	
	        var endpoint = host + _universalConfig.appConfig.iris['section-latest'].replace('{{ID}}', sections['nyheter/meninger']);
	
	        var fetchLatestArticles = (0, _latestArticles.fetchLatestArticlesAction)({
	            endpoint: endpoint,
	            force: force
	        });
	
	        return _promise2.default.all([dispatch(fetchLatestArticles)]);
	    }
	}), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        latest: state.latestArticles.latest
	    };
	}), _dec3 = (0, _reactCssThemr.themr)('ReferenceFront'), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ReferenceFront, _Component);
	
	    function ReferenceFront() {
	        (0, _classCallCheck3.default)(this, ReferenceFront);
	        return (0, _possibleConstructorReturn3.default)(this, (ReferenceFront.__proto__ || (0, _getPrototypeOf2.default)(ReferenceFront)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ReferenceFront, [{
	        key: 'render',
	
	        /* eslint-disable react/forbid-prop-types */
	        value: function render() {
	            var _props = this.props,
	                front = _props.theme.front,
	                latest = _props.latest;
	
	            // Disabling the index as key since it does not matter at all for this list.
	            // Will never end up in production.
	            /* eslint-disable react/no-array-index-key  */
	
	            var latestArticles = latest.map(function (_ref2, index) {
	                var id = _ref2.id,
	                    title = _ref2.promotionContent.title;
	                return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/i/' + id + '/' },
	                        title.value
	                    )
	                );
	            });
	            /* eslint-enable react/forbid-prop-types */
	
	            return _react2.default.createElement(
	                'article',
	                null,
	                _react2.default.createElement(
	                    'section',
	                    { className: front },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        '(Old) Staging/development'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/rLodl/' },
	                                'Article example 2: Jensen-varsel (plain article, long)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/g7rvk/' },
	                                'Article example 3: Lorem Ipsum (many components)'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'In production (beta.vg.no)'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/55qw1/' },
	                                'N\xE5 skal vi skilles, Johanne'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/55qw1/?layout=promo' },
	                                'N\xE5 skal vi skilles, Johanne (promo version)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/WV3x2' },
	                                'Prest avsatt (plain news)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/01X4J' },
	                                'S\xF8r-Sudan i krise (feature)'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Hildes testfiles:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/wPqQn/' },
	                                'Hildes testfiles: Plain article'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/awAEO/' },
	                                'Hildes testfiles: Meninger article'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/4qPeV/' },
	                                'Hildes testfiles: Sports article'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/kJ5rX/' },
	                                'Hildes testfiles: Plain feature article'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/i/Joa5X/' },
	                                'Hildes testfiles: Sports feature article'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Recent meninger articles'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        latestArticles
	                    )
	                )
	            );
	        }
	        /* eslint-enable react/forbid-prop-types */
	
	    }]);
	    return ReferenceFront;
	}(_react.Component), _class2.propTypes = {
	    theme: _propTypes2.default.object,
	    latest: _propTypes2.default.array
	}, _class2.defaultProps = {
	    theme: {},
	    latest: []
	}, _temp)) || _class) || _class) || _class);
	exports.default = ReferenceFront;

/***/ },

/***/ 829:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp, _initialiseProps; /* eslint-disable react/forbid-prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _universalConfig = __webpack_require__(22);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(25);
	
	var _redux = __webpack_require__(89);
	
	var _reactCssThemr = __webpack_require__(36);
	
	var _redial = __webpack_require__(112);
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _tracking = __webpack_require__(116);
	
	var _plussArticles = __webpack_require__(805);
	
	var _deferOnload = __webpack_require__(186);
	
	var _deferOnload2 = _interopRequireDefault(_deferOnload);
	
	var _initSpid = __webpack_require__(188);
	
	var _initSpid2 = _interopRequireDefault(_initSpid);
	
	var _GridTeaser = __webpack_require__(314);
	
	var _GridTeaser2 = _interopRequireDefault(_GridTeaser);
	
	var _error = __webpack_require__(124);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _clientParams = __webpack_require__(185);
	
	var _clientParams2 = _interopRequireDefault(_clientParams);
	
	var _fontChooser = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapDispatchToProps(dispatch) {
	    return (0, _redux.bindActionCreators)({
	        fetchPlussArticlesAction: _plussArticles.fetchPlussArticlesAction,
	        addPlussArticlesAction: _plussArticles.addPlussArticlesAction,
	        pushLocationHistory: _reactRouterRedux.push
	    }, dispatch);
	}
	
	function FilterButton(props) {
	    /* eslint-disable react/prop-types */
	    return _react2.default.createElement(
	        'button',
	        { className: props.selected, onClick: props.onClick },
	        props.value
	    );
	    /* eslint-enable react/prop-types */
	}
	
	var ARTICLES_PER_PAGE = 21;
	
	var sections = [{
	    name: 'Nyheter',
	    id: 'addeb271-e473-4fff-adef-32e3b8602605',
	    excludedsections: '',
	    selected: false
	}, {
	    name: 'Sport',
	    id: 'bd063f91-6bff-4fa1-84c2-a19a66b64d5f',
	    excludedSections: '',
	    selected: false
	}, {
	    name: 'Rampelys',
	    id: 'd70c055a-3c91-483c-b4b2-8fffcf04f2a6',
	    excludedSections: '',
	    selected: false
	}, {
	    name: 'Forbruker',
	    id: 'de434f6e-6c77-438e-aa59-639b118247f7',
	    excludedSections: '509d9cb5-d17c-43fa-a44d-0c729089a1cb',
	    selected: false
	}, {
	    name: 'Livsstil',
	    id: '509d9cb5-d17c-43fa-a44d-0c729089a1cb',
	    excludedSections: '',
	    selected: false
	}];
	
	var PlussFront = (_dec = (0, _redial.provideHooks)({
	    /* eslint-disable arrow-body-style */
	    fetch: function fetch(_ref) {
	        var dispatch = _ref.dispatch,
	            force = _ref.force,
	            location = _ref.location;
	        var _location$query = location.query,
	            _location$query$offse = _location$query.offset,
	            offset = _location$query$offse === undefined ? 0 : _location$query$offse,
	            section = _location$query.section;
	
	        var selectedSectionId = void 0;
	        var excludedSections = void 0;
	        if (section) {
	            var selectedSection = sections.find(function (s) {
	                return s.name.toLowerCase() === section;
	            });
	            if (selectedSection) {
	                selectedSectionId = selectedSection.id;
	                excludedSections = selectedSection.excludedSections;
	            }
	        }
	        return dispatch((0, _plussArticles.fetchPlussArticlesAction)({
	            force: force,
	            offset: offset,
	            section: selectedSectionId,
	            excludedSections: excludedSections
	        }));
	    },
	    /* eslint-enable arrow-body-style */
	    defer: function defer(_ref2) {
	        var dispatch = _ref2.dispatch,
	            location = _ref2.location,
	            getProps = _ref2.getProps;
	        return dispatch(function () {
	            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(thunkDispatch, getState) {
	                var _getProps, layout, spidPromise, trackingOpt, trackingPromise;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _getProps = getProps(), layout = _getProps.layout;
	                                spidPromise = (0, _initSpid2.default)({ thunkDispatch: thunkDispatch, location: location, getState: getState });
	                                _context.next = 4;
	                                return (0, _deferOnload2.default)();
	
	                            case 4:
	                                trackingOpt = (0, _clientParams2.default)({
	                                    config: _universalConfig.appConfig,
	                                    layout: layout,
	                                    state: getState()
	                                });
	                                trackingPromise = thunkDispatch(_tracking.reduxActions.trackerMultipleStart(trackingOpt));
	                                _context.next = 8;
	                                return _promise2.default.all([spidPromise, trackingPromise]);
	
	                            case 8:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function (_x, _x2) {
	                return _ref3.apply(this, arguments);
	            };
	        }());
	    }
	}), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	    return {
	        articles: state.plussArticles,
	        section: ownProps.location.query.section
	    };
	}, mapDispatchToProps), _dec3 = (0, _reactCssThemr.themr)('PlussFront'), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_PureComponent) {
	    (0, _inherits3.default)(PlussFront, _PureComponent);
	
	    function PlussFront(props) {
	        (0, _classCallCheck3.default)(this, PlussFront);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PlussFront.__proto__ || (0, _getPrototypeOf2.default)(PlussFront)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var location = props.location,
	            articles = props.articles,
	            section = props.section;
	
	
	        var selectedSection = void 0;
	        if (section) {
	            selectedSection = sections.find(function (s) {
	                return s.name.toLowerCase() === section;
	            });
	        }
	
	        _this.state = {
	            offset: location.query.offset || 0,
	            selectedSection: selectedSection,
	            hasMoreArticles: articles.pluss && articles.pluss.length >= ARTICLES_PER_PAGE
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PlussFront, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.section !== this.props.section) {
	                var section = this.props.section;
	                var selectedSection = void 0;
	                if (section) {
	                    selectedSection = sections.find(function (s) {
	                        return s.name.toLowerCase() === section;
	                    });
	                }
	                this.selectSection(selectedSection);
	            }
	        }
	    }, {
	        key: 'selectSection',
	        value: function selectSection(selectedSection) {
	            var _this2 = this;
	
	            var section = selectedSection && selectedSection.id;
	            var excludedSections = selectedSection && selectedSection.excludedSections;
	
	            this.setState({
	                selectedSection: selectedSection,
	                offset: 0
	            });
	
	            this.props.fetchPlussArticlesAction({
	                force: true,
	                offset: 0,
	                section: section,
	                excludedSections: excludedSections
	            }).then(function (response) {
	                if (!response.payload.articles || response.payload.articles.length < ARTICLES_PER_PAGE) {
	                    _this2.setState({
	                        hasMoreArticles: false
	                    });
	
	                    return;
	                }
	
	                window.addEventListener('scroll', _this2.scrollListener);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                _props$theme = _props.theme,
	                theme = _props$theme === undefined ? {} : _props$theme,
	                _props$articles = _props.articles,
	                articles = _props$articles === undefined ? {} : _props$articles,
	                location = _props.location;
	            var _state = this.state,
	                offset = _state.offset,
	                selectedSection = _state.selectedSection,
	                hasMoreArticles = _state.hasMoreArticles;
	
	
	            if (articles.error || !articles.pluss.length) {
	                var statusCode = articles.status || 404;
	                return _react2.default.createElement(_error2.default, { statusCode: statusCode, theme: theme });
	            }
	
	            var selectedSectionId = selectedSection && selectedSection.id;
	            var filterButtons = sections.map(function (filter, index) {
	                return _react2.default.createElement(FilterButton, {
	                    key: filter.id,
	                    value: filter.name,
	                    selected: selectedSectionId === filter.id ? theme.active : '',
	                    onClick: function onClick() {
	                        return _this3.handleFilterClick(index);
	                    }
	                });
	            });
	
	            var plussArticles = articles.pluss.map(function (article, index) {
	                return _react2.default.createElement(_GridTeaser2.default, {
	                    key: article.id,
	                    article: article,
	                    theme: theme,
	                    index: index,
	                    utmParams: { utm_source: 'pluss' }
	                });
	            });
	
	            var fonts = (0, _fontChooser.getFonts)(_universalConfig.appConfig.fonts);
	            var fontPreloadLinks = fonts.map(function (font) {
	                return {
	                    rel: 'preload',
	                    as: 'font',
	                    type: 'font/woff2',
	                    href: font.cdn + '.woff2',
	                    crossOrigin: true
	                };
	            });
	
	            var styles = [{
	                type: 'text/css',
	                cssText: (0, _fontChooser.fontsToInlineStyle)(fonts)
	            }];
	
	            var links = [{
	                rel: 'canonical',
	                href: location.pathname
	            }];
	
	            if (hasMoreArticles) {
	                links.push({
	                    rel: 'next',
	                    href: location.pathname + '?offset=' + (offset + ARTICLES_PER_PAGE)
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: theme.root },
	                _react2.default.createElement(_reactHelmet.Helmet, { title: 'VG+', link: links.concat(fontPreloadLinks), style: styles }),
	                _react2.default.createElement(
	                    'section',
	                    { className: theme.front },
	                    _react2.default.createElement(
	                        'div',
	                        { className: theme.filterButtons },
	                        _react2.default.createElement(
	                            'div',
	                            { className: theme.filterIndicator },
	                            'Les mer VG+'
	                        ),
	                        filterButtons
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: theme.articleCards },
	                        plussArticles
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: theme.showMore, onClick: this.fetchMoreArticles },
	                        'Vis flere artikler'
	                    )
	                )
	            );
	        }
	    }]);
	    return PlussFront;
	}(_react.PureComponent), _class2.propTypes = {
	    theme: _propTypes2.default.object,
	    articles: _propTypes2.default.object,
	    section: _propTypes2.default.string,
	    pushLocationHistory: _propTypes2.default.func.isRequired,
	    fetchPlussArticlesAction: _propTypes2.default.func.isRequired,
	    addPlussArticlesAction: _propTypes2.default.func.isRequired,
	    location: _propTypes2.default.object
	}, _class2.defaultProps = {
	    theme: {},
	    articles: {},
	    location: {}
	}, _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.handleFilterClick = function (i) {
	        var selectedSection = sections[i];
	        var previouslySelectedSection = _this4.state.selectedSection;
	
	        if (previouslySelectedSection && previouslySelectedSection.id === selectedSection.id) {
	            selectedSection = undefined;
	        }
	
	        var path = _this4.props.location.pathname;
	        if (selectedSection) {
	            path += '?section=' + encodeURIComponent(selectedSection.name.toLowerCase());
	        }
	        _this4.props.pushLocationHistory(path);
	    };
	
	    this.fetchMoreArticles = function () {
	        var newOffset = _this4.state.offset + ARTICLES_PER_PAGE;
	        var selectedSection = _this4.state.selectedSection;
	
	        var section = selectedSection && selectedSection.id;
	        var excludedSections = selectedSection && selectedSection.excludedSections;
	
	        _this4.setState({ offset: newOffset });
	        _this4.props.addPlussArticlesAction({
	            offset: newOffset,
	            section: section,
	            excludedSections: excludedSections
	        }).then(function (response) {
	            if (!response.payload.articles || response.payload.articles.length < ARTICLES_PER_PAGE) {
	                _this4.setState({
	                    hasMoreArticles: false
	                });
	
	                return;
	            }
	
	            window.addEventListener('scroll', _this4.scrollListener);
	        });
	    };
	}, _temp)) || _class) || _class) || _class);
	exports.default = PlussFront;

/***/ },

/***/ 830:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(36);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _ResponsiblePersons = __webpack_require__(777);
	
	var _ResponsiblePersons2 = _interopRequireDefault(_ResponsiblePersons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiblePersons = (_dec = (0, _reactCssThemr.themr)('AboutVG'), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ResponsiblePersons, _Component);
	
	    function ResponsiblePersons() {
	        (0, _classCallCheck3.default)(this, ResponsiblePersons);
	        return (0, _possibleConstructorReturn3.default)(this, (ResponsiblePersons.__proto__ || (0, _getPrototypeOf2.default)(ResponsiblePersons)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ResponsiblePersons, [{
	        key: 'render',
	
	        /* eslint-disable react/forbid-prop-types */
	        value: function render() {
	            var theme = this.props.theme;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: theme.root },
	                _react2.default.createElement(_reactHelmet.Helmet, { title: 'Ansvarlige personer' }),
	                _react2.default.createElement(
	                    'main',
	                    { className: theme.contentContainer, role: 'main', id: 'main' },
	                    _react2.default.createElement('span', { className: 'lp_is_start', style: { width: '1px', height: '1px' } }),
	                    _react2.default.createElement(_ResponsiblePersons2.default, { theme: theme }),
	                    _react2.default.createElement('span', { className: 'lp_is_end', style: { width: '1px', height: '1px' } })
	                )
	            );
	        }
	        /* eslint-enable react/forbid-prop-types */
	
	    }]);
	    return ResponsiblePersons;
	}(_react.Component), _class2.propTypes = {
	    theme: _propTypes2.default.object
	}, _class2.defaultProps = {
	    theme: {}
	}, _temp)) || _class);
	exports.default = ResponsiblePersons;

/***/ },

/***/ 831:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tracking = __webpack_require__(116);
	
	var _pulseEngageTracker = __webpack_require__(834);
	
	var _pulseEngageTracker2 = _interopRequireDefault(_pulseEngageTracker);
	
	var _comScoreTracker = __webpack_require__(832);
	
	var _comScoreTracker2 = _interopRequireDefault(_comScoreTracker);
	
	var _linkPulseTracker = __webpack_require__(833);
	
	var _linkPulseTracker2 = _interopRequireDefault(_linkPulseTracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var configuredPulseEngageTracker = (0, _pulseEngageTracker2.default)();
	var configuredcomScoreTracker = (0, _comScoreTracker2.default)();
	var configuredLinkPulseTracker = (0, _linkPulseTracker2.default)();
	
	var clientTrackers = (0, _tracking.createTrackers)({
	    trackers: {
	        engage: configuredPulseEngageTracker,
	        comScore: configuredcomScoreTracker,
	        linkPulse: configuredLinkPulseTracker
	    },
	    onError: function onError(err, params, trackerId) {
	        return (
	            // eslint-disable-next-line no-console
	            console.log('tracking error ', err, params, trackerId)
	        );
	    } // Look into logging
	});
	
	exports.default = clientTrackers;

/***/ },

/***/ 832:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _littleLoader = __webpack_require__(63);
	
	var _littleLoader2 = _interopRequireDefault(_littleLoader);
	
	var _getSections = __webpack_require__(843);
	
	var _getSections2 = _interopRequireDefault(_getSections);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultSdkCDN = 'https://sb.scorecardresearch.com/beacon.js';
	
	var convert = function convert(params) {
	    var _ref = params.content.section ? (0, _getSections2.default)(params.content.section) : {},
	        section = _ref.section,
	        subSection = _ref.subSection;
	
	    var _params$config$comSco = params.config.comScore,
	        c1 = _params$config$comSco.c1,
	        c2 = _params$config$comSco.c2;
	
	
	    return {
	        c1: c1, // Tag type
	        c2: c2, // comScore client id
	        c4: window.location.toString(), // full page url
	        c5: '' + subSection, // Genre of content
	        c6: '' + section // Package
	    };
	};
	
	exports.default = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$cdn = _ref2.cdn,
	        cdn = _ref2$cdn === undefined ? defaultSdkCDN : _ref2$cdn,
	        _ref2$trackerId = _ref2.trackerId,
	        trackerId = _ref2$trackerId === undefined ? 'comScore' : _ref2$trackerId;
	
	    return {
	        track: function track(params) {
	            return new _promise2.default(function (resolve, reject) {
	                if (!params) {
	                    return reject(new Error('Tracking params must be specified'));
	                }
	
	                /* eslint no-underscore-dangle: [2, { "allow": ["_comscore"] }] */
	                window._comscore = [];
	                window._comscore.push(convert(params));
	
	                (0, _littleLoader2.default)(cdn, function (err) {
	                    if (err) {
	                        return reject(err);
	                    }
	
	                    return resolve({
	                        response: 'comScore tracking completed.',
	                        params: params,
	                        trackerId: trackerId
	                    });
	                });
	
	                return undefined;
	            });
	        }
	    };
	};

/***/ },

/***/ 833:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _littleLoader = __webpack_require__(63);
	
	var _littleLoader2 = _interopRequireDefault(_littleLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultSdkCDN = 'https://vgc.no/stats/linkpulse/linkpulse.js?2017-12-20-2';
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$cdn = _ref.cdn,
	        cdn = _ref$cdn === undefined ? defaultSdkCDN : _ref$cdn,
	        _ref$trackerId = _ref.trackerId,
	        trackerId = _ref$trackerId === undefined ? 'linkPulse' : _ref$trackerId;
	
	    return {
	        track: function track(params) {
	            return new _promise2.default(function (resolve, reject) {
	                (0, _littleLoader2.default)(cdn, function (err) {
	                    if (err) {
	                        return reject(err);
	                    }
	
	                    return resolve({
	                        response: 'LinkPulse tracking completed.',
	                        params: params,
	                        trackerId: trackerId
	                    });
	                });
	
	                return undefined;
	            });
	        }
	    };
	};

/***/ },

/***/ 834:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _littleLoader = __webpack_require__(63);
	
	var _littleLoader2 = _interopRequireDefault(_littleLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sdk = void 0;
	var sdkLoading = false;
	
	var trackQueue = [];
	var defaultSdkCDN = 'https://jssdk.pulse.schibsted.com/autoTracker.with-engage.min.js';
	
	var getArticleEngageOpts = function getArticleEngageOpts(params) {
	    return {
	        articleId: params.content.id,
	        title: params.content.title,
	        category: params.content.categories && params.content.categories[0],
	        group: params.content.group,
	        published: params.content.published,
	        updated: params.content.updated,
	        authors: params.content.authors,
	        wordCount: params.content.wordcount,
	        shareUrl: {
	            facebook: params.url
	        }
	    };
	};
	
	// convert from derp format to pulses actual data format
	var convert = function convert(params) {
	    var customPulse = params.custom ? params.custom.pulse : {};
	
	    var articleEngage = params.type === 'Article' || params.type === 'SalesPoster'; // TODO: check that salesposter is correct here
	    var pageEngage = false; // params.type === 'Listing';
	
	    var engageOpts = void 0;
	    if (articleEngage || pageEngage) {
	        engageOpts = (0, _extends3.default)({
	            // common engage options
	            site: params.site,
	            device: params.device,
	            permalink: params.url,
	            contentType: params.type,
	            enableOverlay: params.enableOverlay,
	            previewUrl: {
	                http: params.url,
	                https: params.url
	            }
	
	        }, articleEngage ? getArticleEngageOpts(params) : {});
	    }
	
	    var pulseEngageEvent = {
	        clientId: params.site.toLowerCase(),
	        contentId: params.content.id,
	        contentType: params.type,
	        category: params.content.categories && params.content.categories[0],
	        tags: (params.content.tags || []).map(function (tag) {
	            return tag.title;
	        }),
	        experiments: params.experiments,
	        trackingFeatures: {
	            impressionTracking: articleEngage, // enable impression tracking on articles for recirc matrix
	            articleEngage: articleEngage,
	            pageEngage: pageEngage,
	            engageOpts: engageOpts
	        },
	        userId: params.userId,
	        userIdDomain: params.userIdDomain || 'spid.no',
	        object: customPulse,
	        provider: {
	            productTag: params.content.productTag
	        }
	    };
	
	    return pulseEngageEvent;
	};
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$cdn = _ref.cdn,
	        cdn = _ref$cdn === undefined ? defaultSdkCDN : _ref$cdn,
	        _ref$trackerId = _ref.trackerId,
	        trackerId = _ref$trackerId === undefined ? 'engage' : _ref$trackerId;
	
	    return {
	        track: function track(params) {
	            return new _promise2.default(function (resolve, reject) {
	                if (!params) {
	                    return reject(new Error('Tracking params must be specified'));
	                }
	
	                var isInitialized = sdk && !sdkLoading;
	                var isUninitialized = !sdk && !sdkLoading;
	                var isLoading = !sdk && sdkLoading;
	                var isStalled = sdk && sdkLoading;
	                var sdkParams = convert(params);
	
	                if (isInitialized) {
	                    params.url = window.location.href; // eslint-disable-line
	
	                    sdk.initTracking(sdkParams, true);
	                } else if (isLoading) {
	                    params.url = window.location.href; // eslint-disable-line
	
	                    trackQueue.push(sdkParams);
	                } else if (isUninitialized || isStalled) {
	                    sdkLoading = true;
	                    window.pulse2opt = sdkParams; // eslint-disable-line
	
	                    // load the autotracker script
	                    (0, _littleLoader2.default)(cdn, function (err) {
	                        if (err) {
	                            return reject(err);
	                        }
	
	                        try {
	                            if (!window.AutoTrack) {
	                                // eslint-disable-line
	                                sdk = true;
	                                throw new Error('Stalled: failed to load Pulse+Engage SDK using CDN: ' + cdn);
	                            }
	
	                            sdk = window.AutoTrack; // eslint-disable-line
	
	                            sdkLoading = false;
	                            trackQueue.forEach(function (event) {
	                                return sdk.initTracking(event, true);
	                            });
	                        } catch (trackErr) {
	                            return reject(trackErr);
	                        }
	
	                        return resolve({
	                            response: 'Pulse+Engage tracking completed.',
	                            params: params,
	                            trackerId: trackerId
	                        });
	                    });
	                }
	
	                return undefined;
	            });
	        }
	    };
	};

/***/ },

/***/ 835:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(38);
	
	var opts = _config.config.adblockDetect;
	
	// loading/checking state
	// adblock detection ported from https://github.schibsted.io/spt-advertising/adblock-detect/blob/master/snippet.html
	
	var checking = {
	    loading: true,
	    hasAdBlock: undefined
	};
	
	var cbs = [];
	
	// Using old-school node callback style, to let adblock detection to be ran before any callbacks are added
	var addCallback = function addCallback(cb) {
	    if (checking.loading) {
	        cbs.push(cb);
	        return;
	    }
	    if (checking.hasAdBlock) {
	        cb(checking.hasAdBlock);
	        return;
	    }
	    cb();
	};
	
	var oncheckComplete = function oncheckComplete(error) {
	    checking.loading = false;
	    // if the error is not undefined, adblock has been detected (reason in error type)
	    checking.hasAdBlock = error;
	    // empty queue and call callbacks
	    while (cbs.length) {
	        cbs.shift()(error);
	    }
	};
	
	function onScriptLoad(frameEl, globalToCheck) {
	    var globalAccessible = frameEl.contentWindow[globalToCheck];
	    if (globalAccessible) {
	        oncheckComplete();
	    } else {
	        oncheckComplete(new Error(globalToCheck + ' was not defined'));
	    }
	    frameEl.parentNode.removeChild(frameEl);
	}
	
	function onScriptError(src) {
	    // assume that if the script fails to load, it's being blocked
	    oncheckComplete(new Error('The script ' + src + ' did not load'));
	}
	
	function createFrame() {
	    var frameEl = document.createElement('iframe');
	    if (frameEl.hidden === undefined) {
	        frameEl.style.display = 'none';
	    }
	    frameEl.hidden = true;
	    return frameEl;
	}
	
	function insertScript(src, frameEl, globalToCheck) {
	    var document = frameEl.contentDocument;
	    var script = document.createElement('script');
	    script.src = src;
	    script.onload = function () {
	        return onScriptLoad(frameEl, globalToCheck);
	    };
	    script.onerror = function () {
	        return onScriptError(src);
	    };
	    document.body.appendChild(script);
	}
	
	var onload = function onload() {
	    var path = opts.path,
	        globalVarToCheck = opts.globalVarToCheck,
	        urls = opts.urls;
	
	
	    window.removeEventListener('load', onload);
	
	    var onIdle = function onIdle() {
	        var iframe = createFrame();
	        var iframeLoaded = function iframeLoaded() {
	            iframe.removeEventListener('load', iframeLoaded);
	            insertScript(urls[Math.floor(Math.random() * urls.length)] + '/' + path, iframe, globalVarToCheck);
	        };
	        iframe.addEventListener('load', iframeLoaded, false);
	        document.body.appendChild(iframe);
	    };
	
	    // wait for the UI thread to be idle
	    setTimeout(onIdle, 10);
	};
	
	// do not run in node context
	if (typeof window !== 'undefined') {
	    window.addEventListener('load', onload);
	}
	
	exports.default = addCallback;

/***/ },

/***/ 836:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = duplicateApnKeywords;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this is a temporary fix for the post-migration issues for new appnexus seat
	
	function duplicateApnKeywords(values) {
	    var duplicates = {};
	
	    (0, _keys2.default)(values).forEach(function (key) {
	        if (key.indexOf('no-') === 0 || key.indexOf('aa-') === 0) {
	            duplicates['kw_' + key] = values[key];
	        }
	    });
	
	    return (0, _extends3.default)({}, values, duplicates);
	}

/***/ },

/***/ 837:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isomorphicFetch = __webpack_require__(62);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Example usage:
	 *
	 * import fetchTimeout from './utils/fetch-timeout';
	 *
	 * async function main() {
	 *     const res = await fetchTimeout('https://www.vg.no/iris-vg/sweet-endpoint', {
	 *         headers: {
	 *             'x-fancy-pants': true,
	 *         },
	 *         timeout: 5000
	 *     });
	 *
	 *     const json = await res.json();
	 * }
	 *
	 */
	function fetchTimeout(endpoint, _ref) {
	    var _ref$timeout = _ref.timeout,
	        timeout = _ref$timeout === undefined ? 2000 : _ref$timeout,
	        options = (0, _objectWithoutProperties3.default)(_ref, ['timeout']);
	
	    return timeOutPromise((0, _isomorphicFetch2.default)(endpoint, (0, _extends3.default)({}, options)), timeout);
	}
	
	function timeOutPromise(promise, timeout) {
	    return new _promise2.default(function (resolve, reject) {
	        var didTimeOut = false;
	
	        var timer = setTimeout(function () {
	            didTimeOut = true;
	
	            reject(new Error('Request timed out'));
	        }, timeout);
	
	        return promise.then(function (res) {
	            clearTimeout(timer);
	
	            if (!didTimeOut) {
	                resolve(res);
	            }
	        }).catch(function (err) {
	            if (didTimeOut) {
	                // rejection has already happened
	                return;
	            }
	
	            reject(err); // reject with fetch error
	        });
	    });
	}
	
	exports.default = fetchTimeout;

/***/ },

/***/ 838:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = redirectArticleRoute;
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _url = __webpack_require__(1341);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function redirectArticleRoute(dispatch, location) {
	    return dispatch(function (thunkDispatch, getState) {
	        var _getState = getState(),
	            article = _getState.article;
	
	        if (article.error) {
	            return _promise2.default.resolve();
	        }
	
	        var _ref = article.links || {},
	            canonicalUrl = _ref.canonicalUrl;
	
	        var canonicalPathname = _url2.default.parse(article.links.canonicalUrl).pathname;
	        if (canonicalPathname && canonicalPathname !== location.pathname) {
	            var newLocation = canonicalUrl;
	            if (location.search) {
	                newLocation += location.search;
	            }
	
	            return thunkDispatch((0, _reactRouterRedux.replace)(newLocation));
	        }
	
	        return _promise2.default.resolve();
	    });
	}

/***/ },

/***/ 839:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = generateCollectionRoute;
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _urlFriendly = __webpack_require__(189);
	
	var _urlFriendly2 = _interopRequireDefault(_urlFriendly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Rules which defines incomplete collection urls
	function isCompleteTagUrl(params, tag) {
	    if (!params.title || params.title !== tag.title) {
	        return false;
	    }
	
	    return true;
	}
	
	function isCompleteStoryUrl(params, story) {
	    if (!params.title || params.title !== story.title) {
	        return false;
	    }
	
	    return true;
	}
	
	function generateCollectionRoute(dispatch, location, params) {
	    return dispatch(function (thunkDispatch, getState) {
	        var _getState = getState(),
	            _getState$collectionA = _getState.collectionArticles,
	            _getState$collectionA2 = _getState$collectionA.meta,
	            meta = _getState$collectionA2 === undefined ? {} : _getState$collectionA2,
	            error = _getState$collectionA.error;
	
	        if (error) {
	            return _promise2.default.resolve();
	        }
	
	        var _location$pathname = location.pathname,
	            pathname = _location$pathname === undefined ? '' : _location$pathname,
	            _location$search = location.search,
	            search = _location$search === undefined ? '' : _location$search;
	
	
	        var urlPath = '';
	        var isCompleteUrl = true;
	
	        if (meta.tag) {
	            var _meta$tag = meta.tag,
	                tag = _meta$tag === undefined ? {} : _meta$tag;
	
	            var tagId = tag.id;
	            var tagTitle = (0, _urlFriendly2.default)(tag.title);
	
	            isCompleteUrl = isCompleteTagUrl(params, tag);
	            urlPath = '/tag/' + tagId + '/' + tagTitle;
	        } else if (meta.story) {
	            var _meta$story = meta.story,
	                story = _meta$story === undefined ? {} : _meta$story;
	
	            var storyId = story.id;
	            var storyTitle = (0, _urlFriendly2.default)(story.title);
	
	            isCompleteUrl = isCompleteStoryUrl(params, story);
	            urlPath = '/emne/' + storyId + '/' + storyTitle;
	        }
	
	        var newLocation = '' + urlPath + search;
	        var oldLocation = '' + pathname + search;
	
	        var isNewLocation = newLocation === oldLocation;
	
	        if (isNewLocation || isCompleteUrl) {
	            return _promise2.default.resolve();
	        }
	
	        return thunkDispatch((0, _reactRouterRedux.replace)(newLocation));
	    });
	}

/***/ },

/***/ 840:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getAuthors;
	function getAuthors() {
	    var authors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    if (authors.length > 0) {
	        var emails = [];
	        authors.forEach(function (author) {
	            var emailIndex = author.contacts.findIndex(function (_ref) {
	                var _ref$type = _ref.type,
	                    type = _ref$type === undefined ? '' : _ref$type;
	                return type === 'email';
	            });
	
	            if (emailIndex > -1) {
	                emails.push(author.contacts[emailIndex].value);
	            }
	        });
	
	        return emails;
	    }
	
	    return [];
	}

/***/ },

/***/ 841:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = generateLpMeta;
	function generateLpMeta(_ref) {
	    var sectionTitle = _ref.sectionTitle,
	        _ref$article = _ref.article,
	        _ref$article$tags = _ref$article.tags,
	        tags = _ref$article$tags === undefined ? [] : _ref$article$tags,
	        _ref$article$authors = _ref$article.authors,
	        authors = _ref$article$authors === undefined ? [] : _ref$article$authors,
	        shareUrl = _ref$article.links.shareUrl,
	        published = _ref$article.changes.published,
	        _ref$article$characte = _ref$article.characteristics;
	    _ref$article$characte = _ref$article$characte === undefined ? {} : _ref$article$characte;
	    var hotness = _ref$article$characte.hotness,
	        wordcount = _ref$article.clientProperties.wordcount,
	        layout = _ref.layout;
	
	    var lpMeta = [{
	        property: 'article:section',
	        content: sectionTitle
	    }, {
	        property: 'article:published_time',
	        content: published
	    }];
	
	    if (shareUrl) {
	        lpMeta.push({
	            property: 'lp:url',
	            content: shareUrl
	        });
	    }
	
	    if (hotness) {
	        lpMeta.push({
	            property: 'lp.article:score',
	            content: Math.floor(hotness / 10)
	        });
	    }
	
	    if (wordcount) {
	        lpMeta.push({
	            property: 'lp:wordcount',
	            content: wordcount
	        });
	    }
	
	    if (layout === 'promo') {
	        lpMeta.push({
	            property: 'lp:paywall',
	            content: 'hard'
	        });
	    }
	
	    return lpMeta.concat(tags.map(function (tag) {
	        return {
	            property: 'article:tag',
	            content: tag.title
	        };
	    })).concat(authors.map(function (author) {
	        return {
	            property: 'og:author',
	            content: author.title
	        };
	    }));
	}

/***/ },

/***/ 842:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(190);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = getPersonalizedConfig;
	
	var _isomorphicFetch = __webpack_require__(62);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cache = {};
	var callQueue = {};
	var listeners = {};
	
	function getPersonalizedConfig(key, userId, sig) {
	    return new _promise2.default(function (resolve, reject) {
	        if (cache[key]) {
	            return resolve(cache[key]);
	        }
	
	        if (callQueue[key]) {
	            if (!listeners[key]) {
	                listeners[key] = [];
	            }
	
	            listeners[key].push(function () {
	                return resolve(cache[key]);
	            });
	
	            return null;
	        }
	
	        callQueue[key] = true;
	
	        return (0, _isomorphicFetch2.default)('https://fp.vg.no/front-personalization/get/' + key + ':' + userId, {
	            method: 'POST',
	            body: (0, _stringify2.default)({
	                validationData: sig
	            })
	        }).then(function (persResult) {
	            return persResult.json();
	        }).then(function () {
	            var adConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var _adConfig$value = adConfig.value,
	                value = _adConfig$value === undefined ? {} : _adConfig$value;
	
	            value = value || {};
	
	            cache[key] = value;
	            callQueue[key] = false;
	
	            if ((0, _keys2.default)(listeners).indexOf(key) >= 0) {
	                listeners[key].map(function (callback) {
	                    return callback(value);
	                });
	                delete listeners[key];
	            }
	
	            resolve(value);
	        }).catch(function (err) {
	            callQueue[key] = false;
	            reject(err);
	        });
	    });
	}

/***/ },

/***/ 843:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getSections;
	
	var _urlFriendly = __webpack_require__(189);
	
	var _urlFriendly2 = _interopRequireDefault(_urlFriendly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSections(section) {
	    var parent = section.parent;
	
	    if (parent) {
	        return {
	            section: (0, _urlFriendly2.default)(parent.title),
	            subSection: (0, _urlFriendly2.default)(section.title)
	        };
	    }
	
	    return {
	        section: (0, _urlFriendly2.default)(section.title),
	        subSection: ''
	    };
	}

/***/ },

/***/ 844:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__(91);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tagMap = {
	    utm_source: 'source',
	    utm_medium: 'medium',
	    utm_campaign: 'campaign',
	    utm_term: 'terms',
	    utm_content: 'content'
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return params.replace(/[^a-zA-Z0-9=\-_&]/g, '').split('&').reduce(function (data, pair) {
	        var keyValue = pair.split('=');
	
	        if (keyValue.length === 2) {
	            var _keyValue = (0, _slicedToArray3.default)(keyValue, 2),
	                key = _keyValue[0],
	                value = _keyValue[1];
	
	            var propKey = tagMap[key];
	
	            if (propKey) {
	                return (0, _extends4.default)({}, data, (0, _defineProperty3.default)({}, propKey, value));
	            }
	        }
	
	        return data;
	    }, {});
	};

/***/ },

/***/ 845:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _universalCookie = __webpack_require__(1338);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookies = new _universalCookie2.default();
	var MAXIMUM_VARNISH_BUCKET_NUMBER = 99;
	
	var shouldRedirectToMyPage = function shouldRedirectToMyPage(atRatio) {
	    var clientBucket = parseInt(cookies.get('clientBucket') || MAXIMUM_VARNISH_BUCKET_NUMBER, 10);
	
	    return clientBucket < parseFloat(atRatio) * 100;
	};
	
	exports.default = shouldRedirectToMyPage;

/***/ },

/***/ 846:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _isomorphicFetch = __webpack_require__(62);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _config = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Cache the result
	var userHasIpAccess = null;
	
	exports.default = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var accessEndpoint, endpointResponse;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        accessEndpoint = _config.config.pluss.accessEndpoint;
	
	                        // If result is cached, return the result
	
	                        if (!(userHasIpAccess !== null)) {
	                            _context.next = 3;
	                            break;
	                        }
	
	                        return _context.abrupt('return', userHasIpAccess);
	
	                    case 3:
	                        _context.prev = 3;
	                        _context.next = 6;
	                        return (0, _isomorphicFetch2.default)(accessEndpoint);
	
	                    case 6:
	                        endpointResponse = _context.sent;
	
	                        userHasIpAccess = endpointResponse.status === 200;
	
	                        return _context.abrupt('return', userHasIpAccess);
	
	                    case 11:
	                        _context.prev = 11;
	                        _context.t0 = _context['catch'](3);
	                        return _context.abrupt('return', false);
	
	                    case 14:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[3, 11]]);
	    }));
	
	    function hasIpAccess() {
	        return _ref.apply(this, arguments);
	    }
	
	    return hasIpAccess;
	}();

/***/ },

/***/ 847:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(91);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (location) {
	    return location.search.replace(/\?/, '').split('&').reduce(function (acc, next) {
	        var _next$split = next.split('='),
	            _next$split2 = (0, _slicedToArray3.default)(_next$split, 2),
	            key = _next$split2[0],
	            val = _next$split2[1];
	
	        acc[key] = val;
	        return acc;
	    }, {});
	};

/***/ },

/***/ 848:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _getTagByTitle = __webpack_require__(802);
	
	var _getTagByTitle2 = _interopRequireDefault(_getTagByTitle);
	
	var _urlFriendly = __webpack_require__(189);
	
	var _urlFriendly2 = _interopRequireDefault(_urlFriendly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
	        var dispatch = _ref2.dispatch,
	            title = _ref2.title;
	        var response, tag;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return dispatch((0, _getTagByTitle2.default)({ title: title, force: true }));
	
	                    case 2:
	                        response = _context.sent;
	
	                        if (response) {
	                            _context.next = 5;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 5:
	                        tag = response.payload.tag;
	
	                        if (tag) {
	                            _context.next = 8;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 8:
	                        _context.next = 10;
	                        return dispatch((0, _reactRouterRedux.replace)('/tag/' + tag.id + '/' + (0, _urlFriendly2.default)(tag.title)));
	
	                    case 10:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    function redirectToCollectionByTitle(_x) {
	        return _ref.apply(this, arguments);
	    }
	
	    return redirectToCollectionByTitle;
	}();

/***/ },

/***/ 849:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getHeaderConfig = exports.addPaymentUrl = exports.getPaymentUrl = exports.isInAppPurchaseEnabled = exports.getAppProducts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAppProducts = exports.getAppProducts = function getAppProducts() {
	    var productNameMap = {
	        'no.vg.snarvei.subscription.daily': 'Daglig',
	        'no.vg.snarvei.subscription.weekly': 'Ukentlig',
	        'no.vg.snarvei.subscription.monthly': 'Månedlig',
	        'no.vg.snarvei.subscription.quarterly': 'Kvartalsvis',
	        'no.vg.snarvei.subscription.yearly': 'Årlig'
	    };
	
	    return window.iap.map(function (product) {
	        var productName = productNameMap[product.productId] || 'VG+';
	        var fullProduct = (0, _extends3.default)({}, product);
	        fullProduct.id = product.productId;
	        fullProduct.title = productName;
	        fullProduct.price = String(Number(product.price));
	        fullProduct.buyButtonText = 'Kjøp';
	
	        return fullProduct;
	    });
	};
	
	var isInAppPurchaseEnabled = exports.isInAppPurchaseEnabled = function isInAppPurchaseEnabled() {
	    return window.iap;
	};
	
	var getPaymentUrl = exports.getPaymentUrl = function getPaymentUrl(id, campaignId, paymentUrlTemplate) {
	    return paymentUrlTemplate.replace('{{PRODUCT_ID}}', id ? '&product_id=' + id : '').replace('{{APP_PRODUCT_ID}}', id ? '&productId=' + id : '').replace('{{CAMPAIGN_ID}}', campaignId ? '&campaign_id=' + campaignId : '');
	};
	
	var addPaymentUrl = exports.addPaymentUrl = function addPaymentUrl(products, paymentUrlTemplate) {
	    return products.map(function (product) {
	        var id = product.id,
	            campaignId = product.campaignId;
	
	        var paymentUrl = getPaymentUrl(id, campaignId, paymentUrlTemplate);
	
	        return (0, _extends3.default)({}, product, { paymentUrl: paymentUrl });
	    });
	};
	
	var getHeaderConfig = exports.getHeaderConfig = function getHeaderConfig(headerConfig, paymentUrlTemplate) {
	    if (!headerConfig || !headerConfig.id) {
	        return {};
	    }
	
	    var id = headerConfig.id,
	        campaignId = headerConfig.campaignId,
	        image = headerConfig.image,
	        alt = headerConfig.alt;
	
	    var paymentUrl = getPaymentUrl(id, campaignId, paymentUrlTemplate);
	
	    return { image: image, alt: alt, paymentUrl: paymentUrl };
	};

/***/ },

/***/ 928:
927,

/***/ 929:
927,

/***/ 974:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2MulS","visuallyhidden":"_2lSpG","hide-text":"_2YKnY","center":"_3zG0n","noprint":"_1TU4L","root":"_16Y1H","contentContainer":"_2tFI8","aboutvg":"_3Ak3z","lighthr":"_3BM0S","darkhr":"_2QfDE","contactButton":"_1JSiB"};

/***/ },

/***/ 975:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1gKzQ","visuallyhidden":"_20NH0","hide-text":"_2ntEM","center":"CDHvu","noprint":"_1CD3r","front":"_3aDeR"};

/***/ },

/***/ 976:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2VqOL","visuallyhidden":"_38OzZ","hide-text":"_2Mdsy","center":"loAdN","noprint":"_3tDzk","root":"_2R-3T","contentContainer":"_17Lc9","noA":"_2aGcc"};

/***/ },

/***/ 977:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1AStk","visuallyhidden":"_1Oodr","hide-text":"K9VzI","center":"_1PId6","noprint":"_1RYFT","root":"_2Y-7H","contentContainer":"_1lO2Y","noA":"_3fX7P"};

/***/ },

/***/ 978:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"CHiSc","visuallyhidden":"tS0qX","hide-text":"XwnAW","center":"_2Jop9","noprint":"_1LNgV","root":"_2hcZh","contentContainer":"HzV50","noA":"_3PcBe"};

/***/ },

/***/ 979:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_35g6P","visuallyhidden":"_1GBuv","hide-text":"_-zlRF","center":"_2LIxc","noprint":"_2cDro","front":"_29qdn","subheader":"NTQbD","tagTitle":"DUtUO","articleCards":"_2PVad","imageWrapper":"_2NRra","plussIndicator":"_2yDdq","articleCard":"_2arR4","fullWidthMobile":"_3eiGu","showMore":"_2daJT","fullWidthDesktop":"_4yfHE"};

/***/ },

/***/ 980:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"NDEyI","visuallyhidden":"_2Yfnt","hide-text":"_1UDl0","center":"_3DKmD","noprint":"_1zK2f","root":"_2SXsq","contentContainer":"_3X2e5","noA":"_38YkW"};

/***/ },

/***/ 981:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1BtOt","visuallyhidden":"_2SOgk","hide-text":"_3Z0Xv","center":"GJuov","noprint":"_3JHLf","front":"_1jqVv","subheader":"SFAgA","tagTitle":"_1jy8G","articleCards":"_3CgFR","imageWrapper":"_3j9Da","plussIndicator":"_3ahOi","articleCard":"_2Ce8c","fullWidthMobile":"M4ISW","showMore":"_2CSdW","fullWidthDesktop":"_2a4ux","root":"_3gN6E","filterButtons":"_1GyGH","filterIndicator":"_2bo2g","active":"_1I0JH"};

/***/ },

/***/ 982:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_229aG","visuallyhidden":"_2uEHt","hide-text":"OLdFD","center":"_3XD89","noprint":"_2WcQS","root":"_23z-f","title":"H6r3p"};

/***/ },

/***/ 983:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"P9egz","visuallyhidden":"_34zKl","hide-text":"_2VQCD","center":"_2NSS2","noprint":"yFs9h","footer":"_2Z8Lj","flexcontainer":"ArGW3","terms":"_3k9fg","legal":"_1ZAJO"};

/***/ },

/***/ 984:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"orocQ","visuallyhidden":"_2SDam","hide-text":"_2tjmh","center":"_2nxW6","noprint":"_1KN5j","map":"_-Sqtr","mapbox-root":"_2zYxn","mapbox-active":"_3954a","activate-controls-button":"_1wuMe"};

/***/ },

/***/ 985:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"RdmMb","visuallyhidden":"oNUPL","hide-text":"_1Tof_","center":"_2-QlC","noprint":"bf6uq","articlesList":"_3igrR","listItem":"_3945n","article":"_30s5-","articleLink":"W4_ic","root":"_10Pby"};

/***/ },

/***/ 986:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"DDknq","visuallyhidden":"_3NLAv","hide-text":"_19pFM","center":"_2TjYQ","noprint":"_1btOV","root":"_35JqV"};

/***/ },

/***/ 987:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"UJWrC","visuallyhidden":"_3gP0j","hide-text":"_2WoSY","center":"_3iGrV","noprint":"_2IUkS","root":"_1ZzPF","text":"_21O08"};

/***/ },

/***/ 988:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1Ha8N","visuallyhidden":"le_2H","hide-text":"_1z26u","center":"_1YFWz","noprint":"_5BiMw","root":"wYxDJ","text":"_2o83_"};

/***/ },

/***/ 989:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1qj10","visuallyhidden":"_3xQMS","hide-text":"_2JgpW","center":"_1vovg","noprint":"Rti91","root":"IKQCs","text":"p6LXb"};

/***/ },

/***/ 990:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"ZfTMz","visuallyhidden":"_3ADzm","hide-text":"_3lGcP","center":"GH8kT","noprint":"_1KMiW","listItem":"_3vdqy","authorList":"fxN10","image":"dPT4P","root":"_3aMu5 _25KE7","description":"_19SJ6"};

/***/ },

/***/ 991:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"Y79Wq","visuallyhidden":"_3VE4j","hide-text":"EKQvE","center":"_19Nx-","noprint":"_2IKIn","listItem":"_2SCv-","authorList":"_2r2yV","image":"UyIR4","root":"ae_j3 _25KE7","description":"_13x6q"};

/***/ },

/***/ 992:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"Qi9_q","visuallyhidden":"_1AXzs","hide-text":"_2ZD7_","center":"_3Y608","noprint":"_1ybf9","carousel":"_1mCJ0","slideContainer":"ARJ08","slideContainerViewport":"_1-65-","slide":"_29Iwb","slideItemWrapper":"_17sRR","changeSlideButton":"_2APk9","changeSlideButtonDisabled":"_5PreY"};

/***/ },

/***/ 993:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2HLmd","visuallyhidden":"_1IFae","hide-text":"_3fTw3","center":"_3WL5e","noprint":"_1T6sd","root":"_4KS1F","tip-list":"_3iglv","title":"_1R9s2"};

/***/ },

/***/ 994:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1csaF","visuallyhidden":"_2Rjel","hide-text":"E0RgG","center":"iymdr","noprint":"_1Hplx","editorial-label":"kd0dU"};

/***/ },

/***/ 995:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"sq6_G","visuallyhidden":"_1FZ5l","hide-text":"_1I2zl","center":"_1eq3R","noprint":"_36QT9","root":"_2WE5R","aspectRatio":"_3_vCy","iframeContent":"_88scx","twitter-tweet":"X1I0p","facebook-post":"_1FuCq","instagram-image":"_1TjP1","spotify-audio":"_1NlT1","soundcloud-audio":"BlL5g"};

/***/ },

/***/ 996:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"aDvto","visuallyhidden":"PzETi","hide-text":"_2QSuP","center":"_123ql","noprint":"_33lqk","topBanner":"_1z2yv _25KE7","tippebannerDiscaimer":"LVbgo","tippebanner":"_2Iz54","stretch":"_2yB_6"};

/***/ },

/***/ 997:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2F5vW","visuallyhidden":"Fx3Ec","hide-text":"_2JOOm","center":"Jjo5R","noprint":"sczMY","external-articles":"_2Fxqb","source":"BVFnu"};

/***/ },

/***/ 998:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2iTHg","visuallyhidden":"_3Lr6R","hide-text":"_3UHbW","center":"_2BlnK","noprint":"_1tNaU","button":"_1zHRp","streamer":"_2XsmH","title":"_3tqj-","header":"_1EEBV","headerClickable":"_2sE3n","root":"_1ilWm","body":"Mxw0b","rootButtonToggleable":"_10INT","rootIsCollapsed":"_3UcGK","rootHeaderToggleable":"_2KAB9"};

/***/ },

/***/ 999:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3bV-b","visuallyhidden":"vkEor","hide-text":"_CB3w","center":"_1QaDS","noprint":"_22-Ka","load-comments":"_2pcvK","comments-closed-heading":"hTvxL","comments-closed-text":"_3nUgQ","closing-info-wrapper":"_2eHwT","closing-info":"_1zAOW"};

/***/ },

/***/ 1000:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_27dkE","visuallyhidden":"_10lZL","hide-text":"_3kaLo","center":"_2iinN","noprint":"_5u5hC","wrapper":"SNyOb"};

/***/ },

/***/ 1001:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_14iPu","visuallyhidden":"_1BYLh","hide-text":"_31GkR","center":"_1Z4da","noprint":"_3uJrl","root":"uPJfJ","carousel":"_1uRFp","button":"_349Al","buttonPrevious":"_1JMIk","buttonNext":"_112o9","videoSlide":"_2I3Ck","buttonContent":"_1a1Y7","slides":"_3QALe","statusBar":"_2f8As","caption":"_1W8NG","byline":"_1vHcZ","state":"_1UBL6"};

/***/ },

/***/ 1002:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2jtoV","visuallyhidden":"mFeUi","hide-text":"_2ud-Q","center":"_3rur8","noprint":"_3esQv","root":"_2HgRA","caption":"_1tfK_","fullcaption":"_2ucMr","captionButton":"iqMdJ","image":"_2f2ch"};

/***/ },

/***/ 1003:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3uOCf","visuallyhidden":"_1gYHC","hide-text":"_31q7c","item":"_3BBFP","center":"_2UnV4","noprint":"_325gf","root":"_3e0QJ","highlight":"_1e0sy","active":"_3C6rE"};

/***/ },

/***/ 1004:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3UuaD","visuallyhidden":"_3LxyF","hide-text":"_1G9vd","center":"_1u91Q","noprint":"_3pelG","headline":"_1o64I"};

/***/ },

/***/ 1005:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1DQpo","visuallyhidden":"_1h-DG","hide-text":"bcoWD","center":"_1mRdU","noprint":"_1u2WZ","headline":"_9uXep _1o64I"};

/***/ },

/***/ 1006:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1M6Od","visuallyhidden":"T_OuB","hide-text":"_3gcKF","center":"_3LfVX","noprint":"uMUsx","headline":"_31gHV _11zKy _1o64I"};

/***/ },

/***/ 1007:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1SIYt","visuallyhidden":"_1MWYh","hide-text":"_2vs3x","center":"WC_61","noprint":"hX-Rs","root":"_3ThgB","caption":"_3jwl_","fullcaption":"_9JHK_","captionButton":"_2pMt3","image":"_103QJ"};

/***/ },

/***/ 1008:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"UyxJm","visuallyhidden":"Q63eD","hide-text":"ywu5_","center":"_3k5_C","noprint":"ayphn","videoRatio":"_13S6V","square":"_51epf","audio":"_1hyVa","root":"_2n018"};

/***/ },

/***/ 1009:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3TBRF","visuallyhidden":"_3SSMM","hide-text":"_2nxMc","center":"wdaU3","noprint":"_2Dx6x","date":"_3jFsm","root":"_1kU1Z"};

/***/ },

/***/ 1010:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3tR-c","visuallyhidden":"_2PfeY","hide-text":"_1p43v","center":"_3Rlye","noprint":"_37Jlb","root":"_-_Vfy","leadText":"_2vpHP _-_Vfy _25KE7"};

/***/ },

/***/ 1011:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"LV5Oq","visuallyhidden":"_1B0tR","hide-text":"_3QpqS","center":"_2HyY0","noprint":"_1KtrD","root":"_2hXlZ","item":"_2fiCE"};

/***/ },

/***/ 1012:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_22-t9","visuallyhidden":"_2iiU2","hide-text":"_3hyMh","center":"_2f625","noprint":"_3kiLX","map":"_1W29W"};

/***/ },

/***/ 1013:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1rEyQ","visuallyhidden":"_33-vT","hide-text":"_2sq3F","center":"_-lhEz","noprint":"_2J8AN","nt-bundle":"_1ZVOW"};

/***/ },

/***/ 1014:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3z6ZR","visuallyhidden":"_3zgGz","hide-text":"_1hJt5","center":"_2dIOt","noprint":"_2HGwp","nt-disclaimer":"_4nDT8"};

/***/ },

/***/ 1015:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"gz9ZD","visuallyhidden":"_2KYnP","hide-text":"_2CUX0","center":"_2gcjp","noprint":"_1HfNj","root":"_3qXzz","buttonlist":"_2Wy_x","listItem":"_2lclr","button":"_1ksJm","linkCopiedMessage":"_3FGgq","cssAnimation":"_2w8fl"};

/***/ },

/***/ 1016:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2HQBQ","visuallyhidden":"c3wl7","hide-text":"_3Yni9","center":"OCte3","noprint":"_19Tpc","skip":"_21ZZe"};

/***/ },

/***/ 1017:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_1HOir","visuallyhidden":"_7JJSj","hide-text":"_2N5yK","root":"_1dZee _25KE7","center":"_2uEFz","noprint":"_2SaPd"};

/***/ },

/***/ 1018:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"e_p52","visuallyhidden":"_2aR77","hide-text":"BIMos","center":"_1PfHi","noprint":"_3MD8A","subheading":"_1_bq4"};

/***/ },

/***/ 1019:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2Uioz","visuallyhidden":"_1ufcf","hide-text":"tk_Yt","center":"_3IHT3","noprint":"_21_YB","subheading":"_3AY4R","subtitle":"_2RsST"};

/***/ },

/***/ 1020:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"mZHMf","visuallyhidden":"BEJpi","hide-text":"_2ItUs","center":"_1zyI2","noprint":"_2vxOV","root":"_19uJo"};

/***/ },

/***/ 1021:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_22FIJ","visuallyhidden":"_2_eku","hide-text":"_1CiEB","center":"_2xUSI","noprint":"_3jO-s","tags":"p4A9B"};

/***/ },

/***/ 1022:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3CVqf","visuallyhidden":"_2n9so","hide-text":"_1EdUg","center":"_1dnMF","noprint":"vgkRP","root":"_18FzH","image":"_3ROuS","alternateImagePosition":"SSrT0","content":"_1mXCu","label":"_16TvN"};

/***/ },

/***/ 1023:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2o8dx","visuallyhidden":"_1R9Ns","hide-text":"_2BWnY","center":"_3v-Ch","noprint":"CoKMs","text":"_2gLYl"};

/***/ },

/***/ 1024:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3Enq0","visuallyhidden":"ONHZ8","hide-text":"_34_Lg","center":"_2fTfA","noprint":"_1JGHy","timestamp":"v815a _25KE7"};

/***/ },

/***/ 1025:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_3Jvd-","visuallyhidden":"_2lClt","hide-text":"p57qh","center":"_3QjKN","noprint":"_JFyy","top_object":"_1GXzR","top-object-in-header":"NRL-4"};

/***/ },

/***/ 1026:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_2F2zn","visuallyhidden":"Hqh62","hide-text":"_1SSq_","center":"_2FwXv","noprint":"_2qca6","root":"_1xqaU"};

/***/ },

/***/ 1027:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"_15CV6","visuallyhidden":"_2rT0b","hide-text":"_2GtT6","center":"_23mh_","noprint":"_1KaKs","videoRatio":"_1RbWO","square":"_3skHG","audio":"QQz2v","video-paywall-overlay":"_2NKln","top":"_21J6O","play-button":"_205YZ","info-message":"iLcV9"};

/***/ },

/***/ 1028:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"In3-F","visuallyhidden":"_2i_jI","hide-text":"_32B0Q","center":"_3-If9","noprint":"QwtLS","root":"_3Ppfs","promoCode":"_1awE3","instructions":"_2ok1w","disclaimer":"_3AyMX"};

/***/ },

/***/ 1029:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"S0Z1P","visuallyhidden":"ZXMq2","hide-text":"_11LYr","center":"abC4h","error":"_1rs-x","overlayContainer":"qwCsP","overlayCountdown":"_226F5","overlayCloseButtonSymbol":"_2FXTu","noprint":"_2xtvA","root":"_2jO_0","player":"_3-4TT","overlayRoot":"_3EJMm","overlayBackgroundImage":"_1-1zE","overlayImageContainer":"_5Mjgo","overlayImageRatio":"_3ME-i","overlayImage":"Ls0XO","overlayPlayButton":"_2lWvf","overlayCountdownPath":"_iXqT","path":"_1112N","overlayTextContainer":"_2WE50","overlayLabel":"_2_ksX","overlayTitle":"_1g3c2","overlayCloseButton":"_2pMDk","svp-player-error-wrapper":"_3uPnI","svp-player-message":"_2_zfr"};

/***/ },

/***/ 1050:
/***/ function(module, exports) {

	module.exports = {"version":"2018e","zones":["Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4"],"links":["Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen"]}

/***/ }

});


/** WEBPACK FOOTER **
 ** app.46eec4996defd76c72ea.js
 **/